var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _g, _path62, _path63, _path64, _g2, _path65, _path66, _path67, _g3, _path68, _path69, _path70, _g4, _path71, _path72, _path73, _g5, _path74, _path75, _path76, _g6, _path77, _path78, _path79, _path80, _path81, _path82, _path83, _path84, _path85, _path86, _path87, _path88, _path89, _path90, _path91, _path92, _path93, _path94, _path95, _path96, _path97, _path98, _path99, _path100, _path101, _path102, _path103, _path104, _path105, _path106, _path107, _path108, _path109, _path110, _path111, _path112, _path113, _path114, _path115, _path116, _path117, _path118, _path119, _path120, _path121, _path122, _path123, _path124, _path125, _path126, _path127, _path128, _path129, _path130, _path131, _path132, _path133, _path134, _path135, _path136, _path137, _path138, _path139, _path140, _path141, _path142, _path143, _path144, _path145, _path146, _path147, _path148, _path149, _path150, _path151, _path152, _path153, _path154, _path155, _path156, _path157, _path158, _path159, _path160, _path161, _path162, _path163, _path164, _path165, _path166, _path167, _path168, _path169, _path170, _path171, _path172, _path173, _path174, _path175, _path176, _path177, _path178, _path179, _path180, _path181, _path182, _path183, _path184, _path185, _path186, _path187, _path188, _path189, _path190, _path191, _path192, _path193, _path194, _path195, _path196, _path197, _path198, _path199, _path200, _path201, _path202, _path203, _path204, _path205, _path206, _path207, _path208, _path209, _path210, _path211, _path212, _path213, _path214, _path215, _path216, _path217, _path218, _path219, _path220, _path221, _path222, _path223, _path224, _path225, _path226, _path227, _path228, _path229, _path230, _path231, _path232, _path233, _path234, _path235, _path236, _path237, _path238, _path239, _path240, _path241, _path242, _path243, _path244, _path245, _path246, _path247, _path248, _path249, _path250, _path251, _path252, _path253, _path254, _path255, _path256, _path257, _path258, _path259, _path260, _path261, _path262, _path263, _path264, _path265, _path266, _path267, _path268, _path269, _path270, _path271, _path272, _path273, _path274, _path275, _path276, _path277, _path278, _path279, _path280, _path281, _path282, _path283, _path284, _path285, _path286, _path287, _path288, _g7, _path289, _path290, _path291, _path292, _path293, _path294, _path295, _path296, _path297, _path298, _path299, _path300, _path301, _path302, _path303, _path304, _path305, _path306, _path307, _path308, _path309, _path310, _path311, _path312, _path313, _path314, _path315, _path316, _path317, _path318, _path319, _path320, _path321, _path322, _path323, _path324, _path325, _path326, _path327, _path328, _path329, _path330, _path331, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgServerStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 481,
    height: 444,
    viewBox: "0 0 481 444",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M240.012 443.6C372.56 443.6 480.012 381.563 480.012 305.038C480.012 228.512 372.56 166.476 240.012 166.476C107.463 166.476 0.0117188 228.512 0.0117188 305.038C0.0117188 381.563 107.463 443.6 240.012 443.6Z",
    fill: "#DCEAF8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M228.414 395.099L218.599 389.431C218.441 389.378 218.304 389.278 218.206 389.143C218.109 389.008 218.057 388.846 218.057 388.679C218.057 388.513 218.109 388.351 218.206 388.216C218.304 388.081 218.441 387.981 218.599 387.928L402.247 281.884C402.651 281.681 403.097 281.576 403.549 281.576C404.001 281.576 404.447 281.681 404.851 281.884L414.665 287.552C415.386 287.973 415.386 288.644 414.665 289.054L230.997 395.099C230.596 395.298 230.154 395.402 229.705 395.402C229.257 395.402 228.815 395.298 228.414 395.099Z",
    fill: "#EBF5FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M202.445 295.243L128.037 338.176C127.034 338.684 125.926 338.949 124.802 338.949C123.678 338.949 122.57 338.684 121.567 338.176L47.2588 295.243C45.4762 294.242 45.4762 292.539 47.2588 291.508L121.667 248.585C122.668 248.077 123.775 247.812 124.897 247.812C126.019 247.812 127.126 248.077 128.127 248.585L202.445 291.508C204.228 292.539 204.228 294.212 202.445 295.243Z",
    fill: "#EBF5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M197.113 263.417L124.897 305.118L52.6719 263.427L124.897 221.726L197.113 263.417Z",
    fill: "url(#paint0_linear_515_48900)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M197.113 263.417L124.897 305.118L52.6719 263.427L124.897 221.726L197.113 263.417Z",
    fill: "black"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M124.896 305.118V299.91L57.1868 260.813L52.6602 263.417L124.896 305.118Z",
    fill: "black"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M124.895 305.128V333.659C126.568 333.695 128.223 333.302 129.702 332.518L160.987 314.491L194.216 295.293C195.06 294.747 195.762 294.008 196.265 293.138C196.768 292.267 197.058 291.29 197.11 290.286V263.417L124.895 305.128Z",
    fill: "url(#paint1_linear_515_48900)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M124.895 305.128V333.659C126.568 333.695 128.223 333.302 129.702 332.518L160.987 314.491L194.216 295.293C195.06 294.747 195.762 294.008 196.265 293.138C196.768 292.267 197.058 291.29 197.11 290.286V263.417L124.895 305.128Z",
    fill: "#F0F7FF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52.6602 263.417V290.246C52.7148 291.249 53.0054 292.226 53.5083 293.096C54.0112 293.966 54.7122 294.705 55.5544 295.253L84.2663 311.837L120.088 332.518C121.567 333.304 123.222 333.697 124.896 333.659V305.128L52.6602 263.417Z",
    fill: "url(#paint2_linear_515_48900)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M52.6602 263.417V290.246C52.7148 291.249 53.0054 292.226 53.5083 293.096C54.0112 293.966 54.7122 294.705 55.5544 295.253L84.2663 311.837L120.088 332.518C121.567 333.304 123.222 333.697 124.896 333.659V305.128L52.6602 263.417Z",
    fill: "#F0F7FF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M197.113 232.151L124.897 273.842L52.6719 232.151L124.897 190.45L197.113 232.151Z",
    fill: "url(#paint3_linear_515_48900)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M197.113 232.151L124.897 273.842L52.6719 232.151L124.897 190.45L197.113 232.151Z",
    fill: "black"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M124.897 273.842V268.634L57.1885 229.537L52.6719 232.151L124.897 273.842Z",
    fill: "black"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M197.112 252.992L124.887 294.693L124.897 273.842L197.112 232.151V252.992Z",
    fill: "url(#paint4_linear_515_48900)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M197.112 252.992L124.887 294.693L124.897 273.842L197.112 232.151V252.992Z",
    fill: "#F0F7FF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M124.887 294.693L52.6719 252.992V232.151L124.897 273.842L124.887 294.693Z",
    fill: "url(#paint5_linear_515_48900)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.887 294.693L52.6719 252.992V232.151L124.897 273.842L124.887 294.693Z",
    fill: "#F0F7FF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M188.089 263.417V258.209L124.887 294.692L124.897 299.91L188.089 263.417Z",
    fill: "#455A64"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1758 255.605L57.1858 260.813L124.895 299.91L124.885 294.692L57.1758 255.605Z",
    fill: "url(#paint6_linear_515_48900)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1758 255.605L57.1858 260.813L124.895 299.91L124.885 294.692L57.1758 255.605Z",
    fill: "#37474F"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M197.113 200.876L124.897 242.576L52.6719 200.876L124.897 159.175L197.113 200.876Z",
    fill: "url(#paint7_linear_515_48900)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M197.113 200.876L124.897 242.576L52.6719 200.876L124.897 159.175L197.113 200.876Z",
    fill: "black"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M124.897 242.576V237.359L57.1885 198.262L52.6719 200.876L124.897 242.576Z",
    fill: "black"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M197.112 221.726L124.887 263.427L124.897 242.577L197.112 200.876V221.726Z",
    fill: "url(#paint8_linear_515_48900)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M197.112 221.726L124.887 263.427L124.897 242.577L197.112 200.876V221.726Z",
    fill: "#F0F7FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M124.887 263.427L52.6719 221.726V200.876L124.897 242.577L124.887 263.427Z",
    fill: "url(#paint9_linear_515_48900)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.887 263.427L52.6719 221.726V200.876L124.897 242.577L124.887 263.427Z",
    fill: "#F0F7FF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M188.089 232.151V226.934L124.887 263.427L124.897 268.634L188.089 232.151Z",
    fill: "#455A64"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1758 224.33L57.1858 229.537L124.895 268.634L124.885 263.427L57.1758 224.33Z",
    fill: "#37474F"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M188.089 200.876V195.658L124.887 232.151L124.897 237.359L188.089 200.876Z",
    fill: "#455A64"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1758 193.054L57.1858 198.262L124.895 237.359L124.885 232.151L57.1758 193.054Z",
    fill: "#37474F"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M197.113 169.6L124.897 211.301L52.6719 169.6L124.897 127.899L197.113 169.6Z",
    fill: "url(#paint10_linear_515_48900)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M197.113 169.6L124.897 211.301L52.6719 169.6L124.897 127.899L197.113 169.6Z",
    fill: "#F0F7FF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M197.113 169.6L124.897 211.301L52.6719 169.6L124.897 127.899L197.113 169.6Z",
    fill: "black"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M124.897 206.093V211.301L52.6719 169.6L57.1885 166.996L124.897 206.093Z",
    fill: "black"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M197.112 190.451L124.887 232.151L124.897 211.301L197.112 169.6V190.451Z",
    fill: "url(#paint11_linear_515_48900)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M197.112 190.451L124.887 232.151L124.897 211.301L197.112 169.6V190.451Z",
    fill: "#F0F7FF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M124.887 232.151L52.6719 190.451V169.6L124.897 211.301L124.887 232.151Z",
    fill: "url(#paint12_linear_515_48900)"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.887 232.151L52.6719 190.451V169.6L124.897 211.301L124.887 232.151Z",
    fill: "#F0F7FF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M188.089 169.61V164.392L124.887 200.886L124.897 206.093L188.089 169.61Z",
    fill: "#455A64"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1758 161.789L57.1858 166.996L124.895 206.093L124.885 200.886L57.1758 161.789Z",
    fill: "#37474F"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M197.113 138.264L124.897 179.965L52.6719 138.264L124.897 96.5635L197.113 138.264Z",
    fill: "url(#paint13_linear_515_48900)"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M197.113 138.264L124.897 179.965L52.6719 138.264L124.897 96.5635L197.113 138.264Z",
    fill: "#F0F7FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M197.113 138.264L124.897 179.965L52.6719 138.264L124.897 96.5635L197.113 138.264Z",
    fill: "black"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M124.897 174.758V179.965L52.6719 138.264L57.1885 135.671L124.897 174.758Z",
    fill: "black"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M197.112 159.115L124.887 200.816L124.897 179.965L197.112 138.264V159.115Z",
    fill: "url(#paint14_linear_515_48900)"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M197.112 159.115L124.887 200.816L124.897 179.965L197.112 138.264V159.115Z",
    fill: "#F0F7FF"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M124.887 200.816L52.6719 159.115V138.264L124.897 179.965L124.887 200.816Z",
    fill: "url(#paint15_linear_515_48900)"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M124.887 200.816L52.6719 159.115V138.264L124.897 179.965L124.887 200.816Z",
    fill: "#F0F7FF"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M55.5544 105.336L122.041 66.9704C122.937 66.5164 123.927 66.2798 124.931 66.2798C125.935 66.2798 126.924 66.5164 127.82 66.9704L194.227 105.336C195.069 105.885 195.77 106.624 196.273 107.494C196.776 108.364 197.066 109.34 197.121 110.344V127.869L124.845 169.55L52.6602 127.869V110.334C52.7164 109.332 53.0077 108.357 53.5105 107.489C54.0133 106.621 54.7135 105.884 55.5544 105.336Z",
    fill: "url(#paint16_linear_515_48900)"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M55.5544 105.336L122.041 66.9704C122.937 66.5164 123.927 66.2798 124.931 66.2798C125.935 66.2798 126.924 66.5164 127.82 66.9704L194.227 105.336C195.069 105.885 195.77 106.624 196.273 107.494C196.776 108.364 197.066 109.34 197.121 110.344V127.869L124.845 169.55L52.6602 127.869V110.334C52.7164 109.332 53.0077 108.357 53.5105 107.489C54.0133 106.621 54.7135 105.884 55.5544 105.336Z",
    fill: "#F0F7FF"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M124.846 147.718V169.55L197.111 127.869V110.334C197.059 109.439 196.822 108.566 196.415 107.767C196.009 106.969 195.441 106.264 194.748 105.697C195.749 106.628 195.629 107.86 194.227 108.701L127.73 147.067C126.839 147.523 125.847 147.747 124.846 147.718Z",
    fill: "url(#paint17_linear_515_48900)"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.65,
    d: "M124.846 147.718V169.55L197.111 127.869V110.334C197.059 109.439 196.822 108.566 196.415 107.767C196.009 106.969 195.441 106.264 194.748 105.697C195.749 106.628 195.629 107.86 194.227 108.701L127.73 147.067C126.839 147.523 125.847 147.747 124.846 147.718Z",
    fill: "#F0F7FF"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M194.227 108.671L127.731 147.037C126.837 147.491 125.849 147.728 124.846 147.728C123.844 147.728 122.856 147.491 121.962 147.037L55.5553 108.671C53.9529 107.75 53.9529 106.258 55.5553 105.336L122.042 66.9704C122.938 66.5164 123.927 66.2798 124.931 66.2798C125.935 66.2798 126.925 66.5164 127.821 66.9704L194.227 105.336C195.83 106.258 195.83 107.75 194.227 108.671Z",
    fill: "url(#paint18_linear_515_48900)"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    d: "M194.227 108.671L127.731 147.037C126.837 147.491 125.849 147.728 124.846 147.728C123.844 147.728 122.856 147.491 121.962 147.037L55.5553 108.671C53.9529 107.75 53.9529 106.258 55.5553 105.336L122.042 66.9704C122.938 66.5164 123.927 66.2798 124.931 66.2798C125.935 66.2798 126.925 66.5164 127.821 66.9704L194.227 105.336C195.83 106.258 195.83 107.75 194.227 108.671Z",
    fill: "#F0F7FF"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M188.089 138.274V133.067L124.887 169.55L124.897 174.757L188.089 138.274Z",
    fill: "#455A64"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M57.1758 130.453L57.1858 135.671L124.895 174.758L124.885 169.55L57.1758 130.453Z",
    fill: "#37474F"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M68.3726 296.665C68.6655 296.853 68.9093 297.109 69.0835 297.41C69.2577 297.711 69.3573 298.05 69.374 298.398C69.374 299.039 68.9234 299.299 68.3726 298.979C68.0811 298.787 67.8386 298.529 67.6647 298.226C67.4908 297.924 67.3902 297.585 67.3711 297.236C67.3711 296.595 67.8218 296.345 68.3726 296.665Z",
    fill: "#455A64"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M76.7749 301.492C77.0649 301.681 77.3065 301.935 77.4804 302.235C77.6543 302.534 77.7557 302.869 77.7764 303.215C77.7764 303.856 77.3257 304.116 76.7749 303.796C76.4836 303.606 76.2412 303.35 76.0672 303.049C75.8932 302.748 75.7926 302.41 75.7734 302.063C75.7734 301.432 76.174 301.172 76.7749 301.492Z",
    fill: "#455A64"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M84.937 306.229C85.2275 306.418 85.4696 306.672 85.6436 306.971C85.8176 307.27 85.9186 307.606 85.9385 307.952C85.9385 308.583 85.4978 308.843 84.937 308.523C84.6454 308.336 84.4024 308.082 84.2283 307.782C84.0542 307.483 83.9538 307.146 83.9355 306.8C83.9355 306.129 84.3862 305.909 84.937 306.229Z",
    fill: "#455A64"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M93.2183 311.016C93.508 311.203 93.7497 311.455 93.9237 311.753C94.0977 312.05 94.1991 312.385 94.2197 312.729C94.2197 313.36 93.7691 313.62 93.2183 313.3C92.9268 313.115 92.6839 312.863 92.5096 312.565C92.3354 312.267 92.235 311.932 92.2168 311.587C92.2268 310.956 92.6675 310.696 93.2183 311.016Z",
    fill: "#455A64"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6362 272.079L67.1185 276.956C67.82 277.411 68.4036 278.026 68.8214 278.75C69.2392 279.475 69.4793 280.288 69.5221 281.123V285.99C69.5221 287.522 68.4505 288.143 67.1185 287.372L58.6362 282.505C57.9351 282.048 57.3513 281.433 56.932 280.71C56.5127 279.986 56.2697 279.174 56.2227 278.338V273.461C56.2227 271.899 57.3042 271.278 58.6362 272.079Z",
    fill: "#F0F7FF"
  }))), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9219 277.537L62.0235 276.897C62.2605 276.79 62.5213 276.748 62.7796 276.775C63.038 276.801 63.2849 276.895 63.4956 277.047C64.1055 277.443 64.6129 277.978 64.9767 278.609C65.3404 279.239 65.5501 279.946 65.5887 280.672C65.6136 280.931 65.5703 281.192 65.4632 281.429C65.356 281.666 65.1887 281.871 64.9778 282.024L63.9763 282.605L63.7961 282.304C63.5854 282.253 63.3831 282.172 63.1952 282.064C62.585 281.67 62.0771 281.137 61.7132 280.509C61.3493 279.88 61.1399 279.174 61.1021 278.449C61.1001 278.267 61.1202 278.085 61.1622 277.908L60.9219 277.537Z",
    fill: "url(#paint19_linear_515_48900)"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.9219 277.537L62.0235 276.897C62.2605 276.79 62.5213 276.748 62.7796 276.775C63.038 276.801 63.2849 276.895 63.4956 277.047C64.1055 277.443 64.6129 277.978 64.9767 278.609C65.3404 279.239 65.5501 279.946 65.5887 280.672C65.6136 280.931 65.5703 281.192 65.4632 281.429C65.356 281.666 65.1887 281.871 64.9778 282.024L63.9763 282.605L63.7961 282.304C63.5854 282.253 63.3831 282.172 63.1952 282.064C62.585 281.67 62.0771 281.137 61.7132 280.509C61.3493 279.88 61.1399 279.174 61.1021 278.449C61.1001 278.267 61.1202 278.085 61.1622 277.908L60.9219 277.537Z",
    fill: "black"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4446 277.658C63.0531 278.053 63.5598 278.587 63.9234 279.215C64.2871 279.843 64.4975 280.548 64.5377 281.273C64.5377 282.615 63.5963 283.156 62.4446 282.485C61.8365 282.086 61.3303 281.551 60.9667 280.921C60.6032 280.291 60.3925 279.585 60.3516 278.859C60.3516 277.527 61.2929 276.987 62.4446 277.658Z",
    fill: "url(#paint20_linear_515_48900)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6362 240.754L67.1185 245.621C67.8183 246.078 68.4006 246.693 68.8182 247.417C69.2358 248.14 69.4769 248.953 69.5221 249.787V254.664C69.5221 256.196 68.4505 256.817 67.1185 256.046L58.6362 251.169C57.9387 250.718 57.3569 250.11 56.9376 249.394C56.5184 248.677 56.2735 247.872 56.2227 247.043V242.136C56.2227 240.604 57.3042 240.033 58.6362 240.754Z",
    fill: "#F0F7FF"
  }))), _path65 || (_path65 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9219 246.242L62.0235 245.601C62.26 245.493 62.5212 245.45 62.78 245.476C63.0387 245.502 63.2858 245.597 63.4956 245.751C64.1041 246.147 64.6108 246.68 64.9745 247.309C65.3381 247.937 65.5486 248.642 65.5887 249.366C65.6157 249.626 65.5733 249.887 65.466 250.125C65.3587 250.363 65.1902 250.567 64.9778 250.718L63.9763 251.299L63.756 251.049C63.5443 251.006 63.3412 250.928 63.1551 250.819C62.5436 250.424 62.0349 249.889 61.6709 249.259C61.307 248.628 61.0983 247.92 61.0621 247.193C61.0605 247.015 61.0807 246.836 61.1222 246.662L60.9219 246.242Z",
    fill: "url(#paint21_linear_515_48900)"
  })), _path66 || (_path66 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.9219 246.242L62.0235 245.601C62.26 245.493 62.5212 245.45 62.78 245.476C63.0387 245.502 63.2858 245.597 63.4956 245.751C64.1041 246.147 64.6108 246.68 64.9745 247.309C65.3381 247.937 65.5486 248.642 65.5887 249.366C65.6157 249.626 65.5733 249.887 65.466 250.125C65.3587 250.363 65.1902 250.567 64.9778 250.718L63.9763 251.299L63.756 251.049C63.5443 251.006 63.3412 250.928 63.1551 250.819C62.5436 250.424 62.0349 249.889 61.6709 249.259C61.307 248.628 61.0983 247.92 61.0621 247.193C61.0605 247.015 61.0807 246.836 61.1222 246.662L60.9219 246.242Z",
    fill: "black"
  })), _path67 || (_path67 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4446 246.362C63.0531 246.758 63.5598 247.291 63.9234 247.919C64.2871 248.548 64.4975 249.253 64.5377 249.977C64.5377 251.309 63.5963 251.85 62.4446 251.189C61.8365 250.791 61.3303 250.255 60.9667 249.625C60.6032 248.996 60.3925 248.29 60.3516 247.564C60.3516 246.232 61.2929 245.691 62.4446 246.362Z",
    fill: "url(#paint22_linear_515_48900)"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6362 209.468L67.1185 214.345C67.8183 214.802 68.4006 215.417 68.8182 216.141C69.2358 216.865 69.4769 217.677 69.5221 218.511V223.378C69.5221 224.921 68.4505 225.541 67.1185 224.77L58.6362 219.893C57.934 219.438 57.3493 218.824 56.9299 218.1C56.5104 217.376 56.2681 216.563 56.2227 215.727V210.86C56.2227 209.328 57.3042 208.707 58.6362 209.468Z",
    fill: "#F0F7FF"
  }))), _path68 || (_path68 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9219 214.996L62.0235 214.365C62.2605 214.259 62.5213 214.217 62.7796 214.243C63.038 214.27 63.2849 214.364 63.4956 214.515C64.1038 214.914 64.61 215.449 64.9735 216.079C65.337 216.709 65.5477 217.415 65.5887 218.141C65.6146 218.4 65.5718 218.661 65.4646 218.899C65.3573 219.136 65.1894 219.341 64.9778 219.493L63.9763 220.084L63.7961 219.773C63.5844 219.73 63.3813 219.652 63.1952 219.543C62.5854 219.146 62.0779 218.611 61.7142 217.981C61.3504 217.351 61.1407 216.644 61.1021 215.918C61.1001 215.739 61.1202 215.56 61.1622 215.387L60.9219 214.996Z",
    fill: "url(#paint23_linear_515_48900)"
  })), _path69 || (_path69 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.9219 214.996L62.0235 214.365C62.2605 214.259 62.5213 214.217 62.7796 214.243C63.038 214.27 63.2849 214.364 63.4956 214.515C64.1038 214.914 64.61 215.449 64.9735 216.079C65.337 216.709 65.5477 217.415 65.5887 218.141C65.6146 218.4 65.5718 218.661 65.4646 218.899C65.3573 219.136 65.1894 219.341 64.9778 219.493L63.9763 220.084L63.7961 219.773C63.5844 219.73 63.3813 219.652 63.1952 219.543C62.5854 219.146 62.0779 218.611 61.7142 217.981C61.3504 217.351 61.1407 216.644 61.1021 215.918C61.1001 215.739 61.1202 215.56 61.1622 215.387L60.9219 214.996Z",
    fill: "black"
  })), _path70 || (_path70 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4446 215.076C63.0528 215.475 63.559 216.01 63.9225 216.64C64.286 217.27 64.4967 217.976 64.5377 218.702C64.5377 220.034 63.5963 220.574 62.4446 219.913C61.8365 219.515 61.3303 218.979 60.9667 218.35C60.6032 217.72 60.3925 217.014 60.3516 216.288C60.3516 214.996 61.2929 214.415 62.4446 215.076Z",
    fill: "url(#paint24_linear_515_48900)"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6362 178.233L67.1185 183.11C67.8194 183.565 68.4026 184.18 68.8203 184.904C69.2381 185.628 69.4785 186.441 69.5221 187.276V192.143C69.5221 193.675 68.4505 194.296 67.1185 193.535L58.6362 188.658C57.9351 188.202 57.3513 187.587 56.932 186.863C56.5127 186.139 56.2697 185.327 56.2227 184.492V179.625C56.2227 178.082 57.3042 177.461 58.6362 178.233Z",
    fill: "#F0F7FF"
  }))), _path71 || (_path71 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9219 183.721L62.0235 183.08C62.2605 182.973 62.5213 182.931 62.7796 182.958C63.038 182.984 63.2849 183.078 63.4956 183.23C64.1038 183.628 64.61 184.164 64.9735 184.793C65.337 185.423 65.5477 186.129 65.5887 186.855C65.6136 187.114 65.5703 187.375 65.4632 187.612C65.356 187.85 65.1887 188.055 64.9778 188.207L63.9763 188.798L63.7961 188.487C63.5841 188.44 63.3811 188.359 63.1952 188.247C62.585 187.853 62.0771 187.32 61.7132 186.692C61.3493 186.063 61.1399 185.357 61.1021 184.632C61.1006 184.45 61.1208 184.268 61.1622 184.091L60.9219 183.721Z",
    fill: "url(#paint25_linear_515_48900)"
  })), _path72 || (_path72 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.9219 183.721L62.0235 183.08C62.2605 182.973 62.5213 182.931 62.7796 182.958C63.038 182.984 63.2849 183.078 63.4956 183.23C64.1038 183.628 64.61 184.164 64.9735 184.793C65.337 185.423 65.5477 186.129 65.5887 186.855C65.6136 187.114 65.5703 187.375 65.4632 187.612C65.356 187.85 65.1887 188.055 64.9778 188.207L63.9763 188.798L63.7961 188.487C63.5841 188.44 63.3811 188.359 63.1952 188.247C62.585 187.853 62.0771 187.32 61.7132 186.692C61.3493 186.063 61.1399 185.357 61.1021 184.632C61.1006 184.45 61.1208 184.268 61.1622 184.091L60.9219 183.721Z",
    fill: "black"
  })), _path73 || (_path73 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4446 183.841C63.0544 184.237 63.5619 184.773 63.9256 185.403C64.2894 186.033 64.4991 186.74 64.5377 187.466C64.5377 188.798 63.5963 189.339 62.4446 188.668C61.8348 188.271 61.3273 187.736 60.9636 187.106C60.5999 186.476 60.3901 185.769 60.3516 185.043C60.3516 183.711 61.2929 183.17 62.4446 183.841Z",
    fill: "url(#paint26_linear_515_48900)"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6362 146.897L67.1185 151.774C67.8183 152.231 68.4006 152.846 68.8182 153.57C69.2358 154.294 69.4769 155.106 69.5221 155.94V160.807C69.5221 162.34 68.4505 162.97 67.1185 162.199L58.6362 157.322C57.934 156.867 57.3493 156.253 56.9299 155.529C56.5104 154.805 56.2681 153.992 56.2227 153.156V148.289C56.2227 146.757 57.3042 146.136 58.6362 146.897Z",
    fill: "#F0F7FF"
  }))), _path74 || (_path74 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9219 152.385L62.0235 151.754C62.2605 151.648 62.5213 151.606 62.7796 151.632C63.038 151.659 63.2849 151.752 63.4956 151.904C64.1038 152.303 64.61 152.838 64.9735 153.468C65.337 154.097 65.5477 154.804 65.5887 155.529C65.6146 155.789 65.5718 156.05 65.4646 156.287C65.3573 156.525 65.1894 156.73 64.9778 156.881L63.9763 157.472L63.7961 157.162C63.5844 157.119 63.3813 157.041 63.1952 156.931C62.5854 156.535 62.0779 156 61.7142 155.37C61.3504 154.74 61.1407 154.033 61.1021 153.306C61.1001 153.127 61.1202 152.949 61.1622 152.775L60.9219 152.385Z",
    fill: "url(#paint27_linear_515_48900)"
  })), _path75 || (_path75 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.9219 152.385L62.0235 151.754C62.2605 151.648 62.5213 151.606 62.7796 151.632C63.038 151.659 63.2849 151.752 63.4956 151.904C64.1038 152.303 64.61 152.838 64.9735 153.468C65.337 154.097 65.5477 154.804 65.5887 155.529C65.6146 155.789 65.5718 156.05 65.4646 156.287C65.3573 156.525 65.1894 156.73 64.9778 156.881L63.9763 157.472L63.7961 157.162C63.5844 157.119 63.3813 157.041 63.1952 156.931C62.5854 156.535 62.0779 156 61.7142 155.37C61.3504 154.74 61.1407 154.033 61.1021 153.306C61.1001 153.127 61.1202 152.949 61.1622 152.775L60.9219 152.385Z",
    fill: "black"
  })), _path76 || (_path76 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4446 152.505C63.0528 152.903 63.559 153.439 63.9225 154.069C64.286 154.698 64.4967 155.404 64.5377 156.13C64.5377 157.462 63.5963 158.003 62.4446 157.332C61.8361 156.936 61.3295 156.403 60.9658 155.775C60.6021 155.147 60.3917 154.441 60.3516 153.717C60.3516 152.385 61.2929 151.844 62.4446 152.505Z",
    fill: "url(#paint28_linear_515_48900)"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M58.6362 115.601L67.1185 120.468C67.8196 120.926 68.4028 121.543 68.8204 122.268C69.2381 122.994 69.4785 123.808 69.5221 124.644V129.511C69.5221 131.044 68.4505 131.665 67.1185 130.893L58.6362 126.026C57.9351 125.57 57.3513 124.955 56.932 124.232C56.5127 123.508 56.2697 122.695 56.2227 121.86V116.993C56.2227 115.451 57.3042 114.85 58.6362 115.601Z",
    fill: "#F0F7FF"
  }))), _path77 || (_path77 = /*#__PURE__*/React.createElement("path", {
    d: "M60.9219 121.089L62.0235 120.448C62.2605 120.342 62.5213 120.3 62.7796 120.327C63.038 120.353 63.2849 120.447 63.4956 120.598C64.1055 120.995 64.6129 121.53 64.9767 122.16C65.3404 122.79 65.5501 123.497 65.5887 124.224C65.6136 124.483 65.5703 124.744 65.4632 124.981C65.356 125.218 65.1887 125.423 64.9778 125.576L63.9763 126.157L63.756 125.866C63.5453 125.815 63.343 125.734 63.1551 125.626C62.545 125.232 62.037 124.699 61.6731 124.07C61.3092 123.442 61.0998 122.736 61.0621 122.011C61.06 121.829 61.0802 121.647 61.1222 121.47L60.9219 121.089Z",
    fill: "url(#paint29_linear_515_48900)"
  })), _path78 || (_path78 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M60.9219 121.089L62.0235 120.448C62.2605 120.342 62.5213 120.3 62.7796 120.327C63.038 120.353 63.2849 120.447 63.4956 120.598C64.1055 120.995 64.6129 121.53 64.9767 122.16C65.3404 122.79 65.5501 123.497 65.5887 124.224C65.6136 124.483 65.5703 124.744 65.4632 124.981C65.356 125.218 65.1887 125.423 64.9778 125.576L63.9763 126.157L63.756 125.866C63.5453 125.815 63.343 125.734 63.1551 125.626C62.545 125.232 62.037 124.699 61.6731 124.07C61.3092 123.442 61.0998 122.736 61.0621 122.011C61.06 121.829 61.0802 121.647 61.1222 121.47L60.9219 121.089Z",
    fill: "black"
  })), _path79 || (_path79 = /*#__PURE__*/React.createElement("path", {
    d: "M62.4446 121.209C63.0584 121.609 63.5684 122.149 63.9323 122.784C64.2962 123.42 64.5037 124.133 64.5377 124.865C64.5377 126.207 63.5963 126.748 62.4446 126.077C61.8365 125.678 61.3303 125.143 60.9667 124.513C60.6032 123.883 60.3925 123.177 60.3516 122.451C60.3516 121.079 61.2929 120.538 62.4446 121.209Z",
    fill: "url(#paint30_linear_515_48900)"
  })), _path80 || (_path80 = /*#__PURE__*/React.createElement("path", {
    d: "M190.19 272.64L154.378 293.31C153.679 293.77 153.097 294.387 152.679 295.112C152.262 295.838 152.021 296.651 151.975 297.487V302.354C151.975 303.886 153.056 304.507 154.378 303.736L190.19 283.096C190.891 282.639 191.475 282.024 191.895 281.301C192.314 280.577 192.557 279.765 192.604 278.929V274.052C192.604 272.49 191.522 271.869 190.19 272.64Z",
    fill: "#455A64"
  })), _path81 || (_path81 = /*#__PURE__*/React.createElement("path", {
    d: "M190.061 276.756V279.09C190.057 279.257 190.011 279.421 189.927 279.567C189.843 279.712 189.723 279.834 189.58 279.921L189.039 280.241C188.779 280.392 188.559 280.241 188.559 279.961V277.598C188.568 277.431 188.616 277.269 188.7 277.124C188.783 276.98 188.9 276.857 189.039 276.766L189.58 276.456C189.85 276.326 190.061 276.456 190.061 276.756Z",
    fill: "url(#paint31_linear_515_48900)"
  })), _path82 || (_path82 = /*#__PURE__*/React.createElement("path", {
    d: "M187.627 278.158V280.522C187.623 280.689 187.577 280.854 187.493 280.999C187.409 281.144 187.29 281.266 187.146 281.353L186.606 281.673C186.345 281.824 186.125 281.673 186.125 281.393V279.03C186.134 278.863 186.182 278.701 186.266 278.557C186.35 278.412 186.466 278.289 186.606 278.198L187.146 277.888C187.417 277.728 187.627 277.858 187.627 278.158Z",
    fill: "url(#paint32_linear_515_48900)"
  })), _path83 || (_path83 = /*#__PURE__*/React.createElement("path", {
    d: "M185.204 279.56V281.924C185.194 282.09 185.146 282.253 185.063 282.397C184.979 282.541 184.863 282.664 184.723 282.755L184.172 283.076C183.912 283.226 183.691 283.076 183.691 282.795V280.432C183.701 280.265 183.749 280.103 183.832 279.959C183.916 279.814 184.032 279.692 184.172 279.601L184.723 279.29C184.983 279.09 185.204 279.26 185.204 279.56Z",
    fill: "url(#paint33_linear_515_48900)"
  })), _path84 || (_path84 = /*#__PURE__*/React.createElement("path", {
    d: "M182.77 280.962V283.326C182.761 283.492 182.712 283.655 182.629 283.799C182.545 283.943 182.429 284.066 182.289 284.157L181.748 284.478C181.478 284.628 181.268 284.478 181.268 284.197V281.834C181.272 281.666 181.318 281.502 181.402 281.357C181.486 281.212 181.605 281.09 181.748 281.003L182.289 280.692C182.549 280.532 182.77 280.662 182.77 280.962Z",
    fill: "#37474F"
  })), _path85 || (_path85 = /*#__PURE__*/React.createElement("path", {
    d: "M180.336 282.364V284.728C180.327 284.894 180.279 285.057 180.195 285.201C180.112 285.345 179.995 285.468 179.855 285.559L179.315 285.88C179.044 286.03 178.834 285.88 178.834 285.599V283.236C178.838 283.068 178.884 282.904 178.968 282.759C179.052 282.614 179.171 282.492 179.315 282.405L179.855 282.094C180.116 281.934 180.336 282.094 180.336 282.364Z",
    fill: "#37474F"
  })), _path86 || (_path86 = /*#__PURE__*/React.createElement("path", {
    d: "M177.924 283.767V286.1C177.92 286.268 177.874 286.432 177.79 286.577C177.706 286.722 177.587 286.844 177.443 286.931L176.903 287.252C176.632 287.402 176.422 287.252 176.422 286.971V284.608C176.426 284.44 176.472 284.276 176.556 284.131C176.64 283.986 176.759 283.864 176.903 283.777L177.443 283.466C177.694 283.336 177.924 283.466 177.924 283.767Z",
    fill: "url(#paint34_linear_515_48900)"
  })), _path87 || (_path87 = /*#__PURE__*/React.createElement("path", {
    d: "M175.47 285.169V287.532C175.466 287.7 175.42 287.864 175.336 288.009C175.252 288.154 175.133 288.276 174.989 288.363L174.449 288.684C174.401 288.72 174.344 288.742 174.284 288.745C174.225 288.749 174.165 288.735 174.114 288.705C174.062 288.675 174.021 288.63 173.995 288.576C173.969 288.523 173.959 288.462 173.968 288.403V286.04C173.977 285.873 174.025 285.711 174.109 285.567C174.192 285.422 174.309 285.3 174.449 285.209L174.989 284.898C175.26 284.738 175.47 284.868 175.47 285.169Z",
    fill: "url(#paint35_linear_515_48900)"
  })), _path88 || (_path88 = /*#__PURE__*/React.createElement("path", {
    d: "M173.036 286.571V288.934C173.032 289.102 172.986 289.266 172.902 289.411C172.818 289.556 172.699 289.678 172.556 289.765L172.015 290.086C171.968 290.122 171.911 290.144 171.851 290.148C171.791 290.151 171.732 290.137 171.68 290.107C171.629 290.077 171.587 290.032 171.561 289.979C171.535 289.925 171.526 289.865 171.534 289.805V287.442C171.543 287.275 171.592 287.113 171.675 286.969C171.759 286.824 171.875 286.702 172.015 286.611L172.556 286.3C172.826 286.1 173.036 286.27 173.036 286.571Z",
    fill: "url(#paint36_linear_515_48900)"
  })), _path89 || (_path89 = /*#__PURE__*/React.createElement("path", {
    d: "M170.613 287.973V290.336C170.604 290.503 170.555 290.665 170.472 290.809C170.388 290.954 170.272 291.076 170.132 291.167L169.581 291.488C169.534 291.524 169.477 291.546 169.417 291.55C169.358 291.553 169.298 291.539 169.247 291.509C169.195 291.479 169.154 291.434 169.128 291.381C169.102 291.327 169.092 291.267 169.101 291.207V288.844C169.11 288.677 169.158 288.515 169.242 288.371C169.325 288.227 169.442 288.104 169.581 288.013L170.132 287.702C170.393 287.542 170.613 287.672 170.613 287.973Z",
    fill: "url(#paint37_linear_515_48900)"
  })), _path90 || (_path90 = /*#__PURE__*/React.createElement("path", {
    d: "M168.18 289.375V291.738C168.171 291.905 168.122 292.067 168.039 292.211C167.955 292.356 167.839 292.478 167.699 292.569L167.158 292.89C166.888 293.04 166.678 292.89 166.678 292.61V290.246C166.682 290.078 166.728 289.914 166.812 289.769C166.896 289.624 167.015 289.502 167.158 289.415L167.699 289.104C167.96 288.944 168.18 289.104 168.18 289.375Z",
    fill: "url(#paint38_linear_515_48900)"
  })), _path91 || (_path91 = /*#__PURE__*/React.createElement("path", {
    d: "M165.744 290.777V293.11C165.735 293.277 165.687 293.439 165.603 293.583C165.52 293.728 165.403 293.85 165.264 293.941L164.723 294.262C164.453 294.412 164.242 294.262 164.242 293.981V291.618C164.246 291.45 164.292 291.286 164.376 291.141C164.46 290.996 164.58 290.874 164.723 290.787L165.264 290.476C165.524 290.346 165.744 290.476 165.744 290.777Z",
    fill: "url(#paint39_linear_515_48900)"
  })), _path92 || (_path92 = /*#__PURE__*/React.createElement("path", {
    d: "M163.311 292.179V294.542C163.307 294.71 163.261 294.874 163.177 295.019C163.093 295.164 162.973 295.286 162.83 295.373L162.289 295.694C162.019 295.844 161.809 295.694 161.809 295.414V293.05C161.813 292.882 161.859 292.718 161.943 292.573C162.027 292.428 162.146 292.306 162.289 292.219L162.83 291.908C163.1 291.748 163.311 291.878 163.311 292.179Z",
    fill: "url(#paint40_linear_515_48900)"
  })), _path93 || (_path93 = /*#__PURE__*/React.createElement("path", {
    d: "M160.899 293.581V295.944C160.895 296.112 160.849 296.276 160.765 296.421C160.681 296.567 160.562 296.688 160.419 296.776L159.898 297.116C159.85 297.153 159.793 297.174 159.734 297.178C159.674 297.182 159.615 297.168 159.563 297.138C159.512 297.107 159.47 297.063 159.444 297.009C159.418 296.955 159.409 296.895 159.417 296.836V294.472C159.426 294.306 159.475 294.144 159.558 293.999C159.642 293.855 159.758 293.732 159.898 293.641L160.439 293.331C160.669 293.11 160.899 293.28 160.899 293.581Z",
    fill: "#37474F"
  })), _path94 || (_path94 = /*#__PURE__*/React.createElement("path", {
    d: "M158.446 294.983V297.346C158.441 297.514 158.395 297.678 158.311 297.823C158.227 297.969 158.108 298.09 157.965 298.178L157.424 298.488C157.164 298.648 156.943 298.488 156.943 298.218V295.854C156.953 295.688 157.001 295.526 157.084 295.381C157.168 295.237 157.284 295.114 157.424 295.023L157.965 294.713C158.235 294.552 158.446 294.682 158.446 294.983Z",
    fill: "url(#paint41_linear_515_48900)"
  })), _path95 || (_path95 = /*#__PURE__*/React.createElement("path", {
    d: "M156.02 296.385V298.748C156.011 298.915 155.963 299.077 155.879 299.221C155.796 299.366 155.679 299.489 155.539 299.58L154.989 299.89C154.728 300.05 154.508 299.89 154.508 299.62V297.256C154.517 297.09 154.565 296.928 154.649 296.783C154.732 296.639 154.849 296.516 154.989 296.425L155.539 296.105C155.587 296.068 155.644 296.047 155.703 296.043C155.763 296.039 155.822 296.053 155.874 296.083C155.926 296.113 155.967 296.158 155.993 296.212C156.019 296.266 156.028 296.326 156.02 296.385Z",
    fill: "url(#paint42_linear_515_48900)"
  })), _path96 || (_path96 = /*#__PURE__*/React.createElement("path", {
    d: "M190.19 241.375L154.378 262.065C153.679 262.523 153.098 263.138 152.681 263.862C152.263 264.585 152.021 265.397 151.975 266.231V271.078C151.975 272.62 153.056 273.241 154.378 272.47L190.19 251.79C190.893 251.335 191.478 250.721 191.898 249.997C192.317 249.273 192.559 248.459 192.604 247.624V242.757C192.604 241.224 191.522 240.604 190.19 241.375Z",
    fill: "#455A64"
  })), _path97 || (_path97 = /*#__PURE__*/React.createElement("path", {
    d: "M190.061 245.491V247.854C190.057 248.022 190.011 248.186 189.927 248.331C189.843 248.476 189.723 248.598 189.58 248.685L189.039 248.996C188.779 249.156 188.559 248.996 188.559 248.725V246.362C188.568 246.195 188.616 246.033 188.7 245.889C188.783 245.744 188.9 245.622 189.039 245.531L189.58 245.21C189.85 245.04 190.061 245.19 190.061 245.491Z",
    fill: "url(#paint43_linear_515_48900)"
  })), _path98 || (_path98 = /*#__PURE__*/React.createElement("path", {
    d: "M187.627 246.893V249.256C187.623 249.424 187.577 249.588 187.493 249.733C187.409 249.879 187.29 250 187.146 250.088L186.606 250.398C186.345 250.558 186.125 250.398 186.125 250.128V247.764C186.134 247.598 186.182 247.435 186.266 247.291C186.35 247.147 186.466 247.024 186.606 246.933L187.146 246.612C187.417 246.462 187.627 246.592 187.627 246.893Z",
    fill: "#37474F"
  })), _path99 || (_path99 = /*#__PURE__*/React.createElement("path", {
    d: "M185.204 248.295V250.658C185.194 250.825 185.146 250.987 185.063 251.131C184.979 251.276 184.863 251.398 184.723 251.489L184.172 251.8C183.912 251.96 183.691 251.8 183.691 251.529V249.166C183.701 248.999 183.749 248.837 183.832 248.693C183.916 248.548 184.032 248.426 184.172 248.335L184.723 248.014C184.77 247.978 184.827 247.956 184.887 247.953C184.947 247.949 185.006 247.963 185.058 247.993C185.109 248.023 185.151 248.068 185.177 248.121C185.203 248.175 185.212 248.236 185.204 248.295Z",
    fill: "url(#paint44_linear_515_48900)"
  })), _path100 || (_path100 = /*#__PURE__*/React.createElement("path", {
    d: "M182.77 249.697V252.05C182.761 252.217 182.712 252.379 182.629 252.523C182.545 252.668 182.429 252.79 182.289 252.881L181.748 253.192C181.478 253.352 181.268 253.192 181.268 252.922V250.558C181.272 250.39 181.318 250.226 181.402 250.081C181.486 249.936 181.605 249.814 181.748 249.727L182.289 249.406C182.337 249.369 182.395 249.347 182.456 249.343C182.517 249.339 182.577 249.354 182.63 249.386C182.682 249.417 182.723 249.464 182.748 249.52C182.773 249.575 182.781 249.637 182.77 249.697Z",
    fill: "#37474F"
  })), _path101 || (_path101 = /*#__PURE__*/React.createElement("path", {
    d: "M180.336 251.099V253.462C180.327 253.629 180.279 253.791 180.195 253.935C180.112 254.08 179.995 254.202 179.855 254.294L179.315 254.604C179.044 254.764 178.834 254.604 178.834 254.334V251.97C178.838 251.802 178.884 251.638 178.968 251.493C179.052 251.348 179.171 251.226 179.315 251.139L179.855 250.818C180.116 250.668 180.336 250.788 180.336 251.099Z",
    fill: "#37474F"
  })), _path102 || (_path102 = /*#__PURE__*/React.createElement("path", {
    d: "M177.924 252.501V254.864C177.919 255.032 177.873 255.196 177.789 255.341C177.705 255.487 177.586 255.608 177.443 255.696L176.922 256.056C176.652 256.216 176.441 256.056 176.441 255.786V253.422C176.445 253.254 176.492 253.09 176.576 252.945C176.66 252.8 176.779 252.678 176.922 252.591L177.463 252.271C177.693 252.05 177.924 252.19 177.924 252.501Z",
    fill: "url(#paint45_linear_515_48900)"
  })), _path103 || (_path103 = /*#__PURE__*/React.createElement("path", {
    d: "M175.471 253.903V256.266C175.467 256.434 175.421 256.598 175.337 256.743C175.253 256.889 175.134 257.01 174.99 257.098L174.449 257.408C174.189 257.568 173.969 257.408 173.969 257.138V254.774C173.978 254.608 174.026 254.446 174.11 254.301C174.193 254.157 174.31 254.034 174.449 253.943L174.99 253.623C175.261 253.472 175.471 253.592 175.471 253.903Z",
    fill: "url(#paint46_linear_515_48900)"
  })), _path104 || (_path104 = /*#__PURE__*/React.createElement("path", {
    d: "M173.035 255.305V257.668C173.031 257.836 172.985 258 172.901 258.145C172.817 258.291 172.698 258.413 172.555 258.5L172.014 258.81C171.754 258.97 171.533 258.81 171.533 258.54V256.176C171.542 256.01 171.591 255.848 171.674 255.703C171.758 255.559 171.874 255.436 172.014 255.345L172.555 255.025C172.825 254.874 173.035 254.995 173.035 255.305Z",
    fill: "url(#paint47_linear_515_48900)"
  })), _path105 || (_path105 = /*#__PURE__*/React.createElement("path", {
    d: "M170.612 256.707V259.061C170.603 259.227 170.554 259.389 170.471 259.534C170.387 259.678 170.271 259.801 170.131 259.892L169.58 260.202C169.32 260.362 169.1 260.202 169.1 259.932V257.568C169.109 257.402 169.157 257.24 169.241 257.095C169.324 256.951 169.441 256.828 169.58 256.737L170.131 256.417C170.391 256.277 170.612 256.397 170.612 256.707Z",
    fill: "#37474F"
  })), _path106 || (_path106 = /*#__PURE__*/React.createElement("path", {
    d: "M168.18 258.109V260.472C168.171 260.639 168.122 260.801 168.039 260.946C167.955 261.09 167.839 261.213 167.699 261.304L167.158 261.614C166.888 261.774 166.678 261.614 166.678 261.344V258.98C166.682 258.813 166.728 258.649 166.812 258.503C166.896 258.358 167.015 258.236 167.158 258.149L167.699 257.829C167.96 257.678 168.18 257.799 168.18 258.109Z",
    fill: "url(#paint48_linear_515_48900)"
  })), _path107 || (_path107 = /*#__PURE__*/React.createElement("path", {
    d: "M165.744 259.511V261.875C165.735 262.041 165.687 262.203 165.603 262.348C165.52 262.492 165.403 262.615 165.264 262.706L164.723 263.016C164.453 263.176 164.242 263.016 164.242 262.746V260.382C164.246 260.215 164.292 260.051 164.376 259.905C164.46 259.76 164.58 259.638 164.723 259.551L165.264 259.231C165.524 259.06 165.744 259.201 165.744 259.511Z",
    fill: "#37474F"
  })), _path108 || (_path108 = /*#__PURE__*/React.createElement("path", {
    d: "M163.311 260.913V263.277C163.307 263.444 163.261 263.608 163.177 263.754C163.093 263.899 162.973 264.021 162.83 264.108L162.289 264.418C162.019 264.579 161.809 264.418 161.809 264.148V261.784C161.813 261.617 161.859 261.453 161.943 261.307C162.027 261.162 162.146 261.04 162.289 260.953L162.83 260.633C163.1 260.483 163.311 260.603 163.311 260.913Z",
    fill: "url(#paint49_linear_515_48900)"
  })), _path109 || (_path109 = /*#__PURE__*/React.createElement("path", {
    d: "M160.899 262.315V264.679C160.89 264.845 160.842 265.008 160.759 265.152C160.675 265.297 160.558 265.42 160.418 265.51L159.877 265.82C159.617 265.981 159.396 265.82 159.396 265.55V263.187C159.407 263.019 159.456 262.856 159.539 262.71C159.623 262.564 159.738 262.44 159.877 262.345L160.418 262.035C160.668 261.885 160.899 262.005 160.899 262.315Z",
    fill: "#37474F"
  })), _path110 || (_path110 = /*#__PURE__*/React.createElement("path", {
    d: "M158.446 263.717V266.071C158.437 266.237 158.389 266.4 158.306 266.544C158.222 266.689 158.105 266.811 157.965 266.902L157.424 267.212C157.164 267.373 156.943 267.212 156.943 266.942V264.579C156.954 264.411 157.003 264.248 157.086 264.102C157.17 263.956 157.285 263.832 157.424 263.737L157.965 263.427C158.235 263.287 158.446 263.407 158.446 263.717Z",
    fill: "url(#paint50_linear_515_48900)"
  })), _path111 || (_path111 = /*#__PURE__*/React.createElement("path", {
    d: "M156.02 265.119V267.483C156.009 267.649 155.96 267.81 155.877 267.955C155.794 268.099 155.678 268.222 155.539 268.314L154.989 268.624C154.728 268.785 154.508 268.624 154.508 268.354V265.991C154.519 265.823 154.567 265.66 154.651 265.514C154.734 265.368 154.85 265.244 154.989 265.149L155.539 264.839C155.8 264.689 156.02 264.809 156.02 265.119Z",
    fill: "url(#paint51_linear_515_48900)"
  })), _path112 || (_path112 = /*#__PURE__*/React.createElement("path", {
    d: "M190.19 210.069L154.378 230.739C153.679 231.199 153.097 231.816 152.679 232.541C152.262 233.266 152.021 234.08 151.975 234.915V239.782C151.975 241.315 153.056 241.935 154.378 241.164L190.19 220.494C190.891 220.038 191.475 219.423 191.895 218.699C192.314 217.976 192.557 217.163 192.604 216.328V211.451C192.604 209.919 191.522 209.298 190.19 210.069Z",
    fill: "#455A64"
  })), _path113 || (_path113 = /*#__PURE__*/React.createElement("path", {
    d: "M190.061 214.185V216.548C190.057 216.716 190.011 216.88 189.927 217.025C189.843 217.171 189.723 217.293 189.58 217.38L189.039 217.7C188.779 217.85 188.559 217.7 188.559 217.42V215.056C188.568 214.89 188.616 214.728 188.7 214.583C188.783 214.439 188.9 214.316 189.039 214.225L189.58 213.915C189.85 213.754 190.061 213.885 190.061 214.185Z",
    fill: "url(#paint52_linear_515_48900)"
  })), _path114 || (_path114 = /*#__PURE__*/React.createElement("path", {
    d: "M187.627 215.587V218.001C187.623 218.168 187.577 218.332 187.493 218.478C187.409 218.623 187.29 218.745 187.146 218.832L186.606 219.152C186.345 219.303 186.125 219.152 186.125 218.872V216.508C186.134 216.342 186.182 216.18 186.266 216.035C186.35 215.891 186.466 215.768 186.606 215.677L187.146 215.367C187.417 215.156 187.627 215.287 187.627 215.587Z",
    fill: "url(#paint53_linear_515_48900)"
  })), _path115 || (_path115 = /*#__PURE__*/React.createElement("path", {
    d: "M185.203 216.999V219.363C185.194 219.529 185.145 219.691 185.062 219.836C184.978 219.98 184.862 220.103 184.722 220.194L184.171 220.514C184.124 220.551 184.067 220.572 184.007 220.576C183.948 220.58 183.888 220.566 183.837 220.536C183.785 220.506 183.744 220.461 183.717 220.407C183.691 220.353 183.682 220.293 183.69 220.234V217.87C183.7 217.704 183.748 217.542 183.831 217.397C183.915 217.253 184.031 217.13 184.171 217.039L184.722 216.729C184.982 216.558 185.203 216.689 185.203 216.999Z",
    fill: "url(#paint54_linear_515_48900)"
  })), _path116 || (_path116 = /*#__PURE__*/React.createElement("path", {
    d: "M182.77 218.391V220.755C182.761 220.921 182.712 221.083 182.629 221.228C182.545 221.372 182.429 221.495 182.289 221.586L181.748 221.906C181.478 222.057 181.268 221.906 181.268 221.626V219.262C181.272 219.095 181.318 218.931 181.402 218.785C181.486 218.64 181.605 218.518 181.748 218.431L182.289 218.121C182.549 218.001 182.77 218.091 182.77 218.391Z",
    fill: "url(#paint55_linear_515_48900)"
  })), _path117 || (_path117 = /*#__PURE__*/React.createElement("path", {
    d: "M180.336 219.793V222.157C180.327 222.323 180.279 222.485 180.195 222.63C180.112 222.774 179.995 222.897 179.855 222.988L179.315 223.308C179.044 223.459 178.834 223.308 178.834 223.028V220.664C178.838 220.497 178.884 220.333 178.968 220.187C179.052 220.042 179.171 219.92 179.315 219.833L179.855 219.523C180.116 219.363 180.336 219.493 180.336 219.793Z",
    fill: "#37474F"
  })), _path118 || (_path118 = /*#__PURE__*/React.createElement("path", {
    d: "M177.924 221.195V223.559C177.92 223.726 177.874 223.89 177.79 224.036C177.706 224.181 177.587 224.303 177.443 224.39L176.903 224.71C176.632 224.861 176.422 224.71 176.422 224.43V222.067C176.426 221.899 176.472 221.735 176.556 221.59C176.64 221.444 176.759 221.323 176.903 221.235L177.443 220.925C177.694 220.765 177.924 220.895 177.924 221.195Z",
    fill: "#37474F"
  })), _path119 || (_path119 = /*#__PURE__*/React.createElement("path", {
    d: "M175.47 222.597V225.011C175.466 225.179 175.42 225.343 175.336 225.488C175.252 225.633 175.133 225.755 174.989 225.842L174.449 226.163C174.401 226.199 174.344 226.22 174.284 226.224C174.225 226.228 174.165 226.214 174.114 226.184C174.062 226.154 174.021 226.109 173.995 226.055C173.969 226.002 173.959 225.941 173.968 225.882V223.519C173.977 223.352 174.025 223.19 174.109 223.046C174.192 222.901 174.309 222.778 174.449 222.687L174.989 222.377C175.26 222.167 175.47 222.297 175.47 222.597Z",
    fill: "url(#paint56_linear_515_48900)"
  })), _path120 || (_path120 = /*#__PURE__*/React.createElement("path", {
    d: "M173.036 224.009V226.373C173.032 226.54 172.986 226.704 172.902 226.85C172.818 226.995 172.699 227.117 172.556 227.204L172.015 227.524C171.968 227.561 171.911 227.582 171.851 227.586C171.791 227.59 171.732 227.576 171.68 227.546C171.629 227.516 171.587 227.471 171.561 227.417C171.535 227.363 171.526 227.303 171.534 227.244V224.881C171.543 224.714 171.592 224.552 171.675 224.408C171.759 224.263 171.875 224.14 172.015 224.049L172.556 223.739C172.826 223.569 173.036 223.699 173.036 224.009Z",
    fill: "url(#paint57_linear_515_48900)"
  })), _path121 || (_path121 = /*#__PURE__*/React.createElement("path", {
    d: "M170.613 225.402V227.765C170.604 227.932 170.555 228.094 170.472 228.238C170.388 228.382 170.272 228.505 170.132 228.596L169.581 228.917C169.534 228.953 169.477 228.975 169.417 228.978C169.358 228.982 169.298 228.968 169.247 228.938C169.195 228.908 169.154 228.863 169.128 228.809C169.102 228.756 169.092 228.695 169.101 228.636V226.273C169.11 226.106 169.158 225.944 169.242 225.8C169.325 225.655 169.442 225.533 169.581 225.442L170.132 225.131C170.393 225.011 170.613 225.101 170.613 225.402Z",
    fill: "url(#paint58_linear_515_48900)"
  })), _path122 || (_path122 = /*#__PURE__*/React.createElement("path", {
    d: "M168.18 226.803V229.167C168.171 229.333 168.122 229.495 168.039 229.64C167.955 229.784 167.839 229.907 167.699 229.998L167.158 230.308C166.888 230.469 166.678 230.308 166.678 230.038V227.675C166.682 227.507 166.728 227.343 166.812 227.198C166.896 227.052 167.015 226.931 167.158 226.843L167.699 226.533C167.96 226.373 168.18 226.503 168.18 226.803Z",
    fill: "#37474F"
  })), _path123 || (_path123 = /*#__PURE__*/React.createElement("path", {
    d: "M165.744 228.206V230.569C165.735 230.736 165.687 230.898 165.603 231.042C165.52 231.187 165.403 231.309 165.264 231.4L164.723 231.711C164.453 231.871 164.242 231.711 164.242 231.44V229.077C164.246 228.909 164.292 228.745 164.376 228.6C164.46 228.455 164.58 228.333 164.723 228.246L165.264 227.925C165.311 227.889 165.368 227.867 165.428 227.863C165.487 227.86 165.547 227.874 165.598 227.904C165.65 227.934 165.691 227.979 165.717 228.032C165.743 228.086 165.753 228.146 165.744 228.206Z",
    fill: "url(#paint59_linear_515_48900)"
  })), _path124 || (_path124 = /*#__PURE__*/React.createElement("path", {
    d: "M163.311 229.607V232.021C163.307 232.189 163.261 232.353 163.177 232.498C163.093 232.643 162.973 232.765 162.83 232.852L162.289 233.163C162.019 233.323 161.809 233.163 161.809 232.892V230.529C161.813 230.361 161.859 230.197 161.943 230.052C162.027 229.907 162.146 229.785 162.289 229.698L162.83 229.377C163.1 229.177 163.311 229.307 163.311 229.607Z",
    fill: "url(#paint60_linear_515_48900)"
  })), _path125 || (_path125 = /*#__PURE__*/React.createElement("path", {
    d: "M160.899 231.02V233.383C160.895 233.551 160.848 233.715 160.764 233.86C160.68 234.005 160.561 234.127 160.418 234.214L159.877 234.525C159.617 234.685 159.396 234.525 159.396 234.254V231.891C159.401 231.716 159.45 231.544 159.537 231.392C159.625 231.24 159.748 231.112 159.897 231.02L160.438 230.699C160.668 230.579 160.899 230.709 160.899 231.02Z",
    fill: "#37474F"
  })), _path126 || (_path126 = /*#__PURE__*/React.createElement("path", {
    d: "M158.446 232.412V234.775C158.441 234.943 158.395 235.107 158.311 235.252C158.227 235.397 158.108 235.519 157.965 235.606L157.424 235.917C157.164 236.077 156.943 235.917 156.943 235.646V233.283C156.953 233.116 157.001 232.954 157.084 232.81C157.168 232.665 157.284 232.543 157.424 232.452L157.965 232.131C158.235 232.021 158.446 232.111 158.446 232.412Z",
    fill: "url(#paint61_linear_515_48900)"
  })), _path127 || (_path127 = /*#__PURE__*/React.createElement("path", {
    d: "M156.02 233.814V236.177C156.011 236.344 155.963 236.506 155.879 236.65C155.796 236.795 155.679 236.917 155.539 237.008L154.989 237.319C154.728 237.479 154.508 237.319 154.508 237.048V234.685C154.517 234.518 154.565 234.356 154.649 234.212C154.732 234.067 154.849 233.945 154.989 233.854L155.539 233.533C155.587 233.497 155.644 233.475 155.703 233.472C155.763 233.468 155.822 233.482 155.874 233.512C155.926 233.542 155.967 233.587 155.993 233.64C156.019 233.694 156.028 233.755 156.02 233.814Z",
    fill: "#37474F"
  })), _path128 || (_path128 = /*#__PURE__*/React.createElement("path", {
    d: "M190.19 178.813L154.378 199.494C153.679 199.952 153.098 200.567 152.681 201.291C152.263 202.014 152.021 202.826 151.975 203.66V208.527C151.975 210.059 153.056 210.69 154.378 209.919L190.19 189.239C190.893 188.784 191.477 188.169 191.897 187.445C192.316 186.721 192.558 185.908 192.604 185.073V180.205C192.604 178.673 191.522 178.052 190.19 178.813Z",
    fill: "#455A64"
  })), _path129 || (_path129 = /*#__PURE__*/React.createElement("path", {
    d: "M190.061 182.949V185.313C190.052 185.48 190.004 185.642 189.921 185.787C189.837 185.931 189.72 186.054 189.58 186.144L189.039 186.455C188.779 186.615 188.559 186.455 188.559 186.174V183.821C188.569 183.653 188.618 183.49 188.702 183.344C188.785 183.199 188.9 183.074 189.039 182.98L189.58 182.669C189.85 182.509 190.061 182.629 190.061 182.949Z",
    fill: "url(#paint62_linear_515_48900)"
  })), _path130 || (_path130 = /*#__PURE__*/React.createElement("path", {
    d: "M187.627 184.341V186.705C187.619 186.872 187.571 187.034 187.487 187.179C187.404 187.323 187.287 187.446 187.146 187.536L186.606 187.847C186.345 187.997 186.125 187.847 186.125 187.566V185.213C186.136 185.045 186.185 184.882 186.268 184.736C186.351 184.591 186.467 184.466 186.606 184.372L187.146 184.061C187.417 183.951 187.627 184.031 187.627 184.341Z",
    fill: "#37474F"
  })), _path131 || (_path131 = /*#__PURE__*/React.createElement("path", {
    d: "M185.204 185.744V188.107C185.193 188.273 185.144 188.435 185.061 188.579C184.977 188.723 184.862 188.846 184.723 188.938L184.172 189.249C183.912 189.399 183.691 189.249 183.691 188.968V186.615C183.702 186.447 183.751 186.284 183.834 186.138C183.918 185.993 184.033 185.868 184.172 185.774L184.723 185.463C184.983 185.313 185.204 185.433 185.204 185.744Z",
    fill: "url(#paint63_linear_515_48900)"
  })), _path132 || (_path132 = /*#__PURE__*/React.createElement("path", {
    d: "M182.77 187.146V189.509C182.759 189.675 182.71 189.837 182.627 189.981C182.543 190.125 182.428 190.248 182.289 190.34L181.748 190.651C181.478 190.801 181.268 190.651 181.268 190.37V188.017C181.276 187.849 181.324 187.685 181.407 187.539C181.491 187.393 181.608 187.268 181.748 187.176L182.289 186.865C182.549 186.715 182.77 186.835 182.77 187.146Z",
    fill: "url(#paint64_linear_515_48900)"
  })), _path133 || (_path133 = /*#__PURE__*/React.createElement("path", {
    d: "M180.336 188.548V190.961C180.325 191.127 180.276 191.289 180.193 191.433C180.11 191.577 179.994 191.7 179.855 191.792L179.315 192.103C179.044 192.253 178.834 192.103 178.834 191.822V189.469C178.842 189.301 178.89 189.137 178.974 188.991C179.057 188.845 179.174 188.72 179.315 188.628L179.855 188.317C180.116 188.117 180.336 188.237 180.336 188.548Z",
    fill: "url(#paint65_linear_515_48900)"
  })), _path134 || (_path134 = /*#__PURE__*/React.createElement("path", {
    d: "M177.924 189.96V192.323C177.916 192.49 177.868 192.652 177.784 192.797C177.701 192.941 177.584 193.064 177.443 193.154L176.903 193.465C176.632 193.615 176.422 193.465 176.422 193.184V190.831C176.428 190.656 176.476 190.485 176.564 190.333C176.651 190.181 176.774 190.053 176.923 189.96L177.463 189.649C177.694 189.519 177.924 189.639 177.924 189.96Z",
    fill: "#37474F"
  })), _path135 || (_path135 = /*#__PURE__*/React.createElement("path", {
    d: "M175.471 191.352V193.715C175.463 193.882 175.415 194.044 175.331 194.189C175.247 194.333 175.131 194.456 174.99 194.546L174.449 194.857C174.189 195.007 173.969 194.857 173.969 194.576V192.223C173.979 192.055 174.028 191.892 174.112 191.747C174.195 191.601 174.311 191.476 174.449 191.382L174.99 191.071C175.261 190.961 175.471 191.041 175.471 191.352Z",
    fill: "#37474F"
  })), _path136 || (_path136 = /*#__PURE__*/React.createElement("path", {
    d: "M173.035 192.754V195.117C173.027 195.284 172.979 195.446 172.895 195.591C172.812 195.735 172.695 195.858 172.555 195.948L172.014 196.259C171.754 196.409 171.533 196.259 171.533 195.978V193.625C171.544 193.457 171.593 193.295 171.676 193.149C171.759 193.003 171.875 192.878 172.014 192.784L172.555 192.473C172.825 192.323 173.035 192.443 173.035 192.754Z",
    fill: "url(#paint66_linear_515_48900)"
  })), _path137 || (_path137 = /*#__PURE__*/React.createElement("path", {
    d: "M170.612 194.156V196.519C170.601 196.686 170.552 196.847 170.469 196.991C170.385 197.135 170.27 197.258 170.131 197.351L169.58 197.661C169.32 197.811 169.1 197.661 169.1 197.381V195.027C169.11 194.86 169.159 194.697 169.243 194.551C169.326 194.405 169.441 194.28 169.58 194.186L170.131 193.875C170.391 193.725 170.612 193.845 170.612 194.156Z",
    fill: "#37474F"
  })), _path138 || (_path138 = /*#__PURE__*/React.createElement("path", {
    d: "M168.18 195.558V197.971C168.169 198.138 168.12 198.299 168.037 198.443C167.953 198.587 167.838 198.71 167.699 198.803L167.158 199.113C166.888 199.263 166.678 199.113 166.678 198.833V196.469C166.688 196.303 166.736 196.141 166.82 195.997C166.903 195.852 167.019 195.73 167.158 195.638L167.699 195.328C167.96 195.127 168.18 195.247 168.18 195.558Z",
    fill: "url(#paint67_linear_515_48900)"
  })), _path139 || (_path139 = /*#__PURE__*/React.createElement("path", {
    d: "M165.744 196.97V199.333C165.734 199.5 165.685 199.661 165.601 199.805C165.518 199.949 165.402 200.072 165.264 200.165L164.723 200.475C164.453 200.625 164.242 200.475 164.242 200.195V197.831C164.252 197.665 164.301 197.503 164.384 197.359C164.468 197.214 164.584 197.092 164.723 197L165.264 196.69C165.524 196.529 165.744 196.65 165.744 196.97Z",
    fill: "url(#paint68_linear_515_48900)"
  })), _path140 || (_path140 = /*#__PURE__*/React.createElement("path", {
    d: "M163.311 198.362V200.725C163.301 200.892 163.252 201.054 163.169 201.198C163.085 201.342 162.969 201.465 162.83 201.557L162.289 201.867C162.019 202.017 161.809 201.867 161.809 201.587V199.223C161.819 199.057 161.867 198.895 161.951 198.751C162.034 198.606 162.15 198.484 162.289 198.392L162.83 198.082C163.1 197.971 163.311 198.052 163.311 198.362Z",
    fill: "url(#paint69_linear_515_48900)"
  })), _path141 || (_path141 = /*#__PURE__*/React.createElement("path", {
    d: "M160.899 199.764V202.127C160.889 202.294 160.84 202.456 160.757 202.6C160.673 202.744 160.557 202.867 160.418 202.959L159.877 203.269C159.617 203.419 159.396 203.269 159.396 202.989V200.625C159.408 200.459 159.457 200.298 159.541 200.154C159.624 200.01 159.739 199.887 159.877 199.794L160.418 199.484C160.668 199.333 160.899 199.454 160.899 199.764Z",
    fill: "#37474F"
  })), _path142 || (_path142 = /*#__PURE__*/React.createElement("path", {
    d: "M158.446 201.166V203.53C158.436 203.696 158.387 203.858 158.304 204.002C158.22 204.146 158.104 204.269 157.965 204.361L157.424 204.671C157.164 204.821 156.943 204.671 156.943 204.391V202.027C156.955 201.861 157.004 201.7 157.087 201.556C157.171 201.412 157.286 201.289 157.424 201.196L157.965 200.886C158.235 200.735 158.446 200.856 158.446 201.166Z",
    fill: "url(#paint70_linear_515_48900)"
  })), _path143 || (_path143 = /*#__PURE__*/React.createElement("path", {
    d: "M156.02 202.568V204.982C156.009 205.148 155.959 205.309 155.876 205.453C155.793 205.597 155.678 205.72 155.539 205.813L154.989 206.123C154.728 206.273 154.508 206.123 154.508 205.843V203.479C154.519 203.313 154.569 203.152 154.652 203.008C154.735 202.864 154.85 202.741 154.989 202.648L155.539 202.338C155.8 202.137 156.02 202.258 156.02 202.568Z",
    fill: "url(#paint71_linear_515_48900)"
  })), _path144 || (_path144 = /*#__PURE__*/React.createElement("path", {
    d: "M190.19 147.488L154.378 168.158C153.679 168.616 153.098 169.231 152.681 169.955C152.263 170.678 152.021 171.49 151.975 172.324V177.201C151.975 178.733 153.056 179.354 154.378 178.583L190.19 157.913C190.893 157.456 191.477 156.839 191.897 156.114C192.316 155.388 192.558 154.574 192.604 153.737V148.9C192.604 147.338 191.522 146.717 190.19 147.488Z",
    fill: "#455A64"
  })), _path145 || (_path145 = /*#__PURE__*/React.createElement("path", {
    d: "M190.062 151.604V153.967C190.058 154.135 190.012 154.299 189.928 154.444C189.844 154.589 189.724 154.711 189.581 154.798L189.04 155.119C188.993 155.155 188.936 155.177 188.876 155.181C188.817 155.184 188.757 155.17 188.706 155.14C188.654 155.11 188.613 155.065 188.587 155.012C188.561 154.958 188.551 154.898 188.56 154.838V152.475C188.569 152.308 188.617 152.146 188.701 152.002C188.784 151.858 188.901 151.735 189.04 151.644L189.581 151.333C189.852 151.173 190.062 151.303 190.062 151.604Z",
    fill: "url(#paint72_linear_515_48900)"
  })), _path146 || (_path146 = /*#__PURE__*/React.createElement("path", {
    d: "M187.626 153.006V155.369C187.622 155.537 187.576 155.701 187.492 155.846C187.408 155.991 187.289 156.113 187.146 156.2L186.605 156.521C186.557 156.557 186.5 156.579 186.441 156.583C186.381 156.587 186.322 156.572 186.27 156.542C186.219 156.512 186.177 156.468 186.151 156.414C186.125 156.36 186.116 156.3 186.124 156.241V153.907C186.133 153.741 186.182 153.578 186.265 153.434C186.349 153.29 186.465 153.167 186.605 153.076L187.146 152.765C187.416 152.575 187.626 152.705 187.626 153.006Z",
    fill: "#37474F"
  })), _path147 || (_path147 = /*#__PURE__*/React.createElement("path", {
    d: "M185.203 154.408V156.771C185.194 156.938 185.145 157.1 185.062 157.244C184.978 157.389 184.862 157.511 184.722 157.603L184.171 157.923C184.124 157.959 184.067 157.981 184.007 157.985C183.948 157.989 183.888 157.975 183.837 157.944C183.785 157.914 183.744 157.87 183.717 157.816C183.691 157.762 183.682 157.702 183.69 157.643V155.279C183.7 155.113 183.748 154.95 183.831 154.806C183.915 154.662 184.031 154.539 184.171 154.448L184.722 154.137C184.982 153.977 185.203 154.107 185.203 154.408Z",
    fill: "url(#paint73_linear_515_48900)"
  })), _path148 || (_path148 = /*#__PURE__*/React.createElement("path", {
    d: "M182.77 155.81V158.173C182.761 158.34 182.712 158.502 182.629 158.646C182.545 158.791 182.429 158.914 182.289 159.005L181.748 159.315C181.478 159.475 181.268 159.315 181.268 159.045V156.681C181.272 156.513 181.318 156.349 181.402 156.204C181.486 156.059 181.605 155.937 181.748 155.85L182.289 155.54C182.549 155.379 182.77 155.509 182.77 155.81Z",
    fill: "url(#paint74_linear_515_48900)"
  })), _path149 || (_path149 = /*#__PURE__*/React.createElement("path", {
    d: "M180.336 157.212V159.575C180.327 159.742 180.279 159.904 180.195 160.048C180.112 160.193 179.995 160.316 179.855 160.407L179.315 160.717C179.044 160.877 178.834 160.717 178.834 160.447V158.083C178.838 157.916 178.884 157.752 178.968 157.606C179.052 157.461 179.171 157.339 179.315 157.252L179.855 156.932C179.903 156.895 179.96 156.874 180.02 156.87C180.079 156.866 180.139 156.88 180.19 156.91C180.242 156.94 180.283 156.985 180.309 157.039C180.335 157.093 180.345 157.153 180.336 157.212Z",
    fill: "url(#paint75_linear_515_48900)"
  })), _path150 || (_path150 = /*#__PURE__*/React.createElement("path", {
    d: "M177.924 158.614V160.977C177.92 161.145 177.874 161.309 177.79 161.454C177.706 161.6 177.587 161.721 177.443 161.809L176.903 162.119C176.632 162.279 176.422 162.119 176.422 161.849V159.485C176.426 159.318 176.472 159.154 176.556 159.008C176.64 158.863 176.759 158.741 176.903 158.654L177.443 158.334C177.694 158.183 177.924 158.314 177.924 158.614Z",
    fill: "#37474F"
  })), _path151 || (_path151 = /*#__PURE__*/React.createElement("path", {
    d: "M175.471 160.016V162.379C175.467 162.547 175.421 162.711 175.337 162.856C175.253 163.002 175.134 163.123 174.99 163.211L174.449 163.521C174.189 163.681 173.969 163.521 173.969 163.251V160.917C173.978 160.751 174.026 160.589 174.11 160.444C174.193 160.3 174.31 160.177 174.449 160.086L174.99 159.766C175.261 159.585 175.471 159.716 175.471 160.016Z",
    fill: "#37474F"
  })), _path152 || (_path152 = /*#__PURE__*/React.createElement("path", {
    d: "M173.035 161.418V163.781C173.031 163.949 172.985 164.113 172.901 164.258C172.817 164.404 172.698 164.525 172.555 164.613L172.014 164.923C171.754 165.083 171.533 164.923 171.533 164.653V162.289C171.542 162.123 171.591 161.961 171.674 161.816C171.758 161.672 171.874 161.549 172.014 161.458L172.555 161.138C172.825 160.987 173.035 161.118 173.035 161.418Z",
    fill: "url(#paint76_linear_515_48900)"
  })), _path153 || (_path153 = /*#__PURE__*/React.createElement("path", {
    d: "M170.612 162.82V165.184C170.603 165.35 170.554 165.512 170.471 165.657C170.387 165.801 170.271 165.924 170.131 166.015L169.58 166.325C169.32 166.485 169.1 166.325 169.1 166.055V163.691C169.109 163.525 169.157 163.363 169.241 163.218C169.324 163.074 169.441 162.951 169.58 162.86L170.131 162.54C170.178 162.503 170.236 162.482 170.295 162.478C170.355 162.474 170.414 162.488 170.466 162.518C170.517 162.548 170.559 162.593 170.585 162.647C170.611 162.701 170.62 162.761 170.612 162.82Z",
    fill: "#37474F"
  })), _path154 || (_path154 = /*#__PURE__*/React.createElement("path", {
    d: "M168.18 164.222V166.586C168.171 166.752 168.122 166.914 168.039 167.059C167.955 167.203 167.839 167.326 167.699 167.417L167.158 167.727C166.888 167.888 166.678 167.727 166.678 167.457V165.093C166.682 164.926 166.728 164.762 166.812 164.616C166.896 164.471 167.015 164.349 167.158 164.262L167.699 163.942C167.747 163.905 167.804 163.884 167.863 163.88C167.923 163.876 167.982 163.89 168.034 163.92C168.085 163.95 168.127 163.995 168.153 164.049C168.179 164.103 168.188 164.163 168.18 164.222Z",
    fill: "url(#paint77_linear_515_48900)"
  })), _path155 || (_path155 = /*#__PURE__*/React.createElement("path", {
    d: "M165.744 165.624V167.988C165.735 168.154 165.687 168.316 165.603 168.461C165.52 168.605 165.403 168.728 165.264 168.819L164.723 169.129C164.453 169.289 164.242 169.129 164.242 168.859V166.495C164.246 166.328 164.292 166.164 164.376 166.018C164.46 165.873 164.58 165.751 164.723 165.664L165.264 165.344C165.524 165.194 165.744 165.314 165.744 165.624Z",
    fill: "url(#paint78_linear_515_48900)"
  })), _path156 || (_path156 = /*#__PURE__*/React.createElement("path", {
    d: "M163.311 167.026V169.39C163.307 169.558 163.261 169.722 163.177 169.867C163.093 170.012 162.973 170.134 162.83 170.221L162.289 170.531C162.019 170.692 161.809 170.531 161.809 170.261V167.928C161.813 167.76 161.859 167.596 161.943 167.451C162.027 167.305 162.146 167.184 162.289 167.096L162.83 166.776C163.1 166.596 163.311 166.716 163.311 167.026Z",
    fill: "url(#paint79_linear_515_48900)"
  })), _path157 || (_path157 = /*#__PURE__*/React.createElement("path", {
    d: "M160.898 168.428V170.792C160.894 170.96 160.848 171.124 160.764 171.269C160.68 171.414 160.561 171.536 160.417 171.623L159.897 171.933C159.636 172.094 159.416 171.933 159.416 171.663V169.3C159.425 169.133 159.473 168.971 159.557 168.827C159.641 168.682 159.757 168.559 159.897 168.468L160.437 168.148C160.668 167.998 160.898 168.118 160.898 168.428Z",
    fill: "#37474F"
  })), _path158 || (_path158 = /*#__PURE__*/React.createElement("path", {
    d: "M158.446 169.83V172.194C158.441 172.362 158.395 172.526 158.311 172.671C158.227 172.816 158.108 172.938 157.965 173.025L157.424 173.335C157.164 173.496 156.943 173.335 156.943 173.065V170.702C156.953 170.535 157.001 170.373 157.084 170.229C157.168 170.084 157.284 169.961 157.424 169.87L157.965 169.55C158.235 169.4 158.446 169.52 158.446 169.83Z",
    fill: "url(#paint80_linear_515_48900)"
  })), _path159 || (_path159 = /*#__PURE__*/React.createElement("path", {
    d: "M156.02 171.232V173.596C156.011 173.762 155.963 173.924 155.879 174.069C155.796 174.213 155.679 174.336 155.539 174.427L154.989 174.738C154.728 174.898 154.508 174.738 154.508 174.467V172.104C154.517 171.937 154.565 171.775 154.649 171.631C154.732 171.486 154.849 171.363 154.989 171.272L155.539 170.952C155.8 170.802 156.02 170.932 156.02 171.232Z",
    fill: "url(#paint81_linear_515_48900)"
  })), _path160 || (_path160 = /*#__PURE__*/React.createElement("path", {
    d: "M190.19 116.202L154.378 136.882C153.679 137.34 153.098 137.956 152.681 138.679C152.263 139.403 152.021 140.214 151.975 141.048V145.895C151.975 147.438 153.056 148.059 154.378 147.287L190.19 126.607C190.893 126.153 191.478 125.538 191.898 124.814C192.317 124.09 192.559 123.277 192.604 122.441V117.574C192.604 116.062 191.522 115.441 190.19 116.202Z",
    fill: "#455A64"
  })), _path161 || (_path161 = /*#__PURE__*/React.createElement("path", {
    d: "M190.061 120.328V122.692C190.057 122.859 190.011 123.023 189.927 123.169C189.843 123.314 189.723 123.436 189.58 123.523L189.039 123.833C188.779 123.994 188.559 123.833 188.559 123.563V121.199C188.568 121.033 188.616 120.871 188.7 120.726C188.783 120.582 188.9 120.459 189.039 120.368L189.58 120.048C189.85 119.857 190.061 120.028 190.061 120.328Z",
    fill: "#37474F"
  })), _path162 || (_path162 = /*#__PURE__*/React.createElement("path", {
    d: "M187.627 121.73V124.094C187.623 124.261 187.577 124.425 187.493 124.571C187.409 124.716 187.29 124.838 187.146 124.925L186.606 125.235C186.345 125.396 186.125 125.235 186.125 124.965V122.602C186.134 122.435 186.182 122.273 186.266 122.128C186.35 121.984 186.466 121.861 186.606 121.77L187.146 121.45C187.417 121.3 187.627 121.43 187.627 121.73Z",
    fill: "url(#paint82_linear_515_48900)"
  })), _path163 || (_path163 = /*#__PURE__*/React.createElement("path", {
    d: "M185.204 123.132V125.496C185.194 125.662 185.146 125.824 185.063 125.969C184.979 126.113 184.863 126.236 184.723 126.327L184.172 126.637C183.912 126.798 183.691 126.637 183.691 126.367V124.004C183.701 123.837 183.749 123.675 183.832 123.531C183.916 123.386 184.032 123.263 184.172 123.172L184.723 122.852C184.77 122.815 184.827 122.794 184.887 122.79C184.947 122.786 185.006 122.8 185.058 122.83C185.109 122.861 185.151 122.905 185.177 122.959C185.203 123.013 185.212 123.073 185.204 123.132Z",
    fill: "#37474F"
  })), _path164 || (_path164 = /*#__PURE__*/React.createElement("path", {
    d: "M182.77 124.534V126.868C182.761 127.034 182.712 127.196 182.629 127.341C182.545 127.485 182.429 127.608 182.289 127.699L181.748 128.009C181.478 128.17 181.268 128.009 181.268 127.739V125.376C181.272 125.208 181.318 125.044 181.402 124.899C181.486 124.753 181.605 124.632 181.748 124.544L182.289 124.224C182.549 124.104 182.77 124.224 182.77 124.534Z",
    fill: "#37474F"
  })), _path165 || (_path165 = /*#__PURE__*/React.createElement("path", {
    d: "M180.336 125.936V128.3C180.327 128.466 180.279 128.628 180.195 128.773C180.112 128.917 179.995 129.04 179.855 129.131L179.315 129.441C179.044 129.602 178.834 129.441 178.834 129.171V126.808C178.838 126.64 178.884 126.476 178.968 126.331C179.052 126.185 179.171 126.064 179.315 125.976L179.855 125.656C180.116 125.506 180.336 125.626 180.336 125.936Z",
    fill: "#37474F"
  })), _path166 || (_path166 = /*#__PURE__*/React.createElement("path", {
    d: "M177.924 127.338V129.702C177.919 129.87 177.873 130.034 177.789 130.179C177.705 130.324 177.586 130.446 177.443 130.533L176.922 130.874C176.652 131.034 176.441 130.874 176.441 130.603V128.24C176.445 128.072 176.492 127.908 176.576 127.763C176.66 127.617 176.779 127.496 176.922 127.408L177.463 127.088C177.693 126.868 177.924 127.028 177.924 127.338Z",
    fill: "url(#paint83_linear_515_48900)"
  })), _path167 || (_path167 = /*#__PURE__*/React.createElement("path", {
    d: "M175.471 128.74V131.104C175.467 131.272 175.421 131.436 175.337 131.581C175.253 131.726 175.134 131.848 174.99 131.935L174.449 132.245C174.189 132.406 173.969 132.245 173.969 131.975V129.612C173.978 129.445 174.026 129.283 174.11 129.139C174.193 128.994 174.31 128.871 174.449 128.78L174.99 128.46C175.261 128.31 175.471 128.43 175.471 128.74Z",
    fill: "url(#paint84_linear_515_48900)"
  })), _path168 || (_path168 = /*#__PURE__*/React.createElement("path", {
    d: "M173.035 130.143V132.506C173.031 132.674 172.985 132.838 172.901 132.983C172.817 133.128 172.698 133.25 172.555 133.337L172.014 133.648C171.754 133.808 171.533 133.648 171.533 133.377V131.014C171.542 130.847 171.591 130.685 171.674 130.541C171.758 130.396 171.874 130.274 172.014 130.183L172.555 129.862C172.825 129.712 173.035 129.872 173.035 130.143Z",
    fill: "#37474F"
  })), _path169 || (_path169 = /*#__PURE__*/React.createElement("path", {
    d: "M170.612 131.545V133.878C170.603 134.045 170.554 134.207 170.471 134.351C170.387 134.495 170.271 134.618 170.131 134.709L169.58 135.02C169.32 135.18 169.1 135.02 169.1 134.749V132.386C169.109 132.219 169.157 132.057 169.241 131.913C169.324 131.768 169.441 131.646 169.58 131.555L170.131 131.234C170.391 131.114 170.612 131.234 170.612 131.545Z",
    fill: "url(#paint85_linear_515_48900)"
  })), _path170 || (_path170 = /*#__PURE__*/React.createElement("path", {
    d: "M168.18 132.947V135.31C168.169 135.476 168.12 135.638 168.037 135.782C167.953 135.926 167.838 136.049 167.699 136.141L167.158 136.452C166.888 136.612 166.678 136.452 166.678 136.181V133.818C166.682 133.65 166.728 133.486 166.812 133.341C166.896 133.196 167.015 133.074 167.158 132.987L167.699 132.666C167.96 132.516 168.18 132.636 168.18 132.947Z",
    fill: "#37474F"
  })), _path171 || (_path171 = /*#__PURE__*/React.createElement("path", {
    d: "M165.744 134.349V136.712C165.734 136.878 165.685 137.04 165.601 137.184C165.518 137.328 165.402 137.451 165.264 137.543L164.723 137.854C164.453 138.014 164.242 137.854 164.242 137.583V135.22C164.251 135.052 164.299 134.888 164.382 134.742C164.466 134.596 164.582 134.471 164.723 134.379L165.264 134.068C165.524 133.878 165.744 134.038 165.744 134.349Z",
    fill: "#37474F"
  })), _path172 || (_path172 = /*#__PURE__*/React.createElement("path", {
    d: "M163.311 135.751V138.114C163.302 138.281 163.254 138.443 163.171 138.588C163.087 138.732 162.97 138.855 162.83 138.945L162.289 139.256C162.019 139.416 161.809 139.256 161.809 138.985V136.622C161.817 136.454 161.865 136.29 161.948 136.144C162.032 135.998 162.149 135.873 162.289 135.781L162.83 135.47C163.1 135.32 163.311 135.44 163.311 135.751Z",
    fill: "#37474F"
  })), _path173 || (_path173 = /*#__PURE__*/React.createElement("path", {
    d: "M160.899 137.153V139.516C160.89 139.683 160.842 139.845 160.759 139.99C160.675 140.134 160.558 140.257 160.418 140.347L159.877 140.658C159.617 140.818 159.396 140.658 159.396 140.387V138.024C159.407 137.856 159.456 137.693 159.539 137.548C159.623 137.402 159.738 137.277 159.877 137.183L160.418 136.872C160.668 136.722 160.899 136.882 160.899 137.153Z",
    fill: "url(#paint86_linear_515_48900)"
  })), _path174 || (_path174 = /*#__PURE__*/React.createElement("path", {
    d: "M158.446 138.555V140.888C158.437 141.055 158.389 141.217 158.306 141.362C158.222 141.506 158.105 141.629 157.965 141.719L157.424 142.03C157.164 142.19 156.943 142.03 156.943 141.749V139.396C156.954 139.228 157.003 139.065 157.086 138.92C157.17 138.774 157.285 138.649 157.424 138.555L157.965 138.244C158.235 138.124 158.446 138.244 158.446 138.555Z",
    fill: "#37474F"
  })), _path175 || (_path175 = /*#__PURE__*/React.createElement("path", {
    d: "M156.02 139.957V142.32C156.009 142.486 155.96 142.648 155.877 142.792C155.794 142.936 155.678 143.059 155.539 143.151L154.989 143.462C154.728 143.622 154.508 143.462 154.508 143.181V140.828C154.519 140.66 154.567 140.498 154.651 140.352C154.734 140.206 154.85 140.081 154.989 139.987L155.539 139.676C155.8 139.526 156.02 139.646 156.02 139.957Z",
    fill: "#37474F"
  })), _path176 || (_path176 = /*#__PURE__*/React.createElement("path", {
    d: "M145.565 302.223L144.463 301.582C144.228 301.477 143.969 301.436 143.712 301.462C143.456 301.488 143.211 301.582 143.001 301.733C142.392 302.129 141.884 302.664 141.52 303.294C141.157 303.924 140.947 304.632 140.908 305.358C140.881 305.617 140.924 305.879 141.031 306.117C141.138 306.354 141.307 306.559 141.519 306.71L142.521 307.301L142.711 306.99C142.922 306.942 143.125 306.861 143.312 306.75C143.92 306.354 144.427 305.821 144.791 305.193C145.154 304.565 145.365 303.859 145.405 303.135C145.403 302.952 145.38 302.771 145.335 302.594L145.565 302.223Z",
    fill: "url(#paint87_linear_515_48900)"
  })), _path177 || (_path177 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M145.565 302.223L144.463 301.582C144.228 301.477 143.969 301.436 143.712 301.462C143.456 301.488 143.211 301.582 143.001 301.733C142.392 302.129 141.884 302.664 141.52 303.294C141.157 303.924 140.947 304.632 140.908 305.358C140.881 305.617 140.924 305.879 141.031 306.117C141.138 306.354 141.307 306.559 141.519 306.71L142.521 307.301L142.711 306.99C142.922 306.942 143.125 306.861 143.312 306.75C143.92 306.354 144.427 305.821 144.791 305.193C145.154 304.565 145.365 303.859 145.405 303.135C145.403 302.952 145.38 302.771 145.335 302.594L145.565 302.223Z",
    fill: "black"
  })), _path178 || (_path178 = /*#__PURE__*/React.createElement("path", {
    d: "M144.044 302.344C143.437 302.742 142.931 303.278 142.57 303.908C142.208 304.537 141.999 305.244 141.961 305.969C141.961 307.301 142.892 307.842 144.044 307.171C144.655 306.776 145.164 306.241 145.528 305.611C145.892 304.98 146.101 304.272 146.137 303.545C146.137 302.214 145.206 301.673 144.044 302.344Z",
    fill: "url(#paint88_linear_515_48900)"
  })), _path179 || (_path179 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.044 302.344C143.437 302.742 142.931 303.278 142.57 303.908C142.208 304.537 141.999 305.244 141.961 305.969C141.961 307.301 142.892 307.842 144.044 307.171C144.655 306.776 145.164 306.241 145.528 305.611C145.892 304.98 146.101 304.272 146.137 303.545C146.137 302.214 145.206 301.673 144.044 302.344Z",
    fill: "black"
  })), _path180 || (_path180 = /*#__PURE__*/React.createElement("path", {
    d: "M136.492 307.461L135.39 306.83C135.153 306.724 134.893 306.682 134.634 306.708C134.376 306.735 134.129 306.829 133.918 306.98C133.31 307.379 132.804 307.914 132.44 308.544C132.077 309.174 131.866 309.88 131.825 310.606C131.8 310.865 131.844 311.126 131.951 311.363C132.058 311.6 132.225 311.805 132.436 311.958L133.438 312.548L133.618 312.238C133.828 312.189 134.03 312.111 134.219 312.008C134.829 311.611 135.336 311.076 135.7 310.446C136.063 309.816 136.273 309.109 136.312 308.382C136.309 308.204 136.289 308.026 136.252 307.852L136.492 307.461Z",
    fill: "url(#paint89_linear_515_48900)"
  })), _path181 || (_path181 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M136.492 307.461L135.39 306.83C135.153 306.724 134.893 306.682 134.634 306.708C134.376 306.735 134.129 306.829 133.918 306.98C133.31 307.379 132.804 307.914 132.44 308.544C132.077 309.174 131.866 309.88 131.825 310.606C131.8 310.865 131.844 311.126 131.951 311.363C132.058 311.6 132.225 311.805 132.436 311.958L133.438 312.548L133.618 312.238C133.828 312.189 134.03 312.111 134.219 312.008C134.829 311.611 135.336 311.076 135.7 310.446C136.063 309.816 136.273 309.109 136.312 308.382C136.309 308.204 136.289 308.026 136.252 307.852L136.492 307.461Z",
    fill: "black"
  })), _path182 || (_path182 = /*#__PURE__*/React.createElement("path", {
    d: "M134.97 307.581C134.362 307.98 133.856 308.515 133.492 309.145C133.129 309.774 132.918 310.481 132.877 311.207C132.877 312.538 133.818 313.079 134.97 312.408C135.579 312.013 136.085 311.479 136.449 310.851C136.812 310.223 137.023 309.518 137.063 308.793C137.063 307.451 136.122 306.91 134.97 307.581Z",
    fill: "url(#paint90_linear_515_48900)"
  })), _path183 || (_path183 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.97 307.581C134.362 307.98 133.856 308.515 133.492 309.145C133.129 309.774 132.918 310.481 132.877 311.207C132.877 312.538 133.818 313.079 134.97 312.408C135.579 312.013 136.085 311.479 136.449 310.851C136.812 310.223 137.023 309.518 137.063 308.793C137.063 307.451 136.122 306.91 134.97 307.581Z",
    fill: "black"
  })), _path184 || (_path184 = /*#__PURE__*/React.createElement("path", {
    d: "M145.564 270.948L144.463 270.317C144.227 270.212 143.968 270.17 143.711 270.196C143.455 270.223 143.21 270.316 143 270.467C142.384 270.858 141.87 271.39 141.499 272.018C141.128 272.647 140.912 273.354 140.867 274.082C140.84 274.342 140.883 274.603 140.99 274.841C141.097 275.078 141.266 275.283 141.478 275.434L142.48 276.025L142.67 275.715C142.881 275.671 143.084 275.593 143.271 275.484C143.879 275.086 144.385 274.55 144.749 273.921C145.112 273.291 145.323 272.585 145.364 271.859C145.363 271.68 145.339 271.502 145.294 271.328L145.564 270.948Z",
    fill: "url(#paint91_linear_515_48900)"
  })), _path185 || (_path185 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M145.564 270.948L144.463 270.317C144.227 270.212 143.968 270.17 143.711 270.196C143.455 270.223 143.21 270.316 143 270.467C142.384 270.858 141.87 271.39 141.499 272.018C141.128 272.647 140.912 273.354 140.867 274.082C140.84 274.342 140.883 274.603 140.99 274.841C141.097 275.078 141.266 275.283 141.478 275.434L142.48 276.025L142.67 275.715C142.881 275.671 143.084 275.593 143.271 275.484C143.879 275.086 144.385 274.55 144.749 273.921C145.112 273.291 145.323 272.585 145.364 271.859C145.363 271.68 145.339 271.502 145.294 271.328L145.564 270.948Z",
    fill: "black"
  })), _path186 || (_path186 = /*#__PURE__*/React.createElement("path", {
    d: "M144.044 271.078C143.437 271.477 142.932 272.013 142.571 272.643C142.209 273.272 142 273.978 141.961 274.703C141.961 276.035 142.892 276.576 144.044 275.905C144.654 275.511 145.162 274.978 145.526 274.35C145.89 273.721 146.099 273.015 146.137 272.29C146.137 270.948 145.206 270.407 144.044 271.078Z",
    fill: "url(#paint92_linear_515_48900)"
  })), _path187 || (_path187 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.044 271.078C143.437 271.477 142.932 272.013 142.571 272.643C142.209 273.272 142 273.978 141.961 274.703C141.961 276.035 142.892 276.576 144.044 275.905C144.654 275.511 145.162 274.978 145.526 274.35C145.89 273.721 146.099 273.015 146.137 272.29C146.137 270.948 145.206 270.407 144.044 271.078Z",
    fill: "black"
  })), _path188 || (_path188 = /*#__PURE__*/React.createElement("path", {
    d: "M136.493 276.185L135.391 275.555C135.154 275.448 134.893 275.406 134.635 275.433C134.376 275.459 134.129 275.553 133.919 275.705C133.311 276.103 132.804 276.639 132.441 277.268C132.077 277.898 131.867 278.604 131.826 279.33C131.8 279.589 131.843 279.851 131.95 280.088C132.057 280.325 132.225 280.53 132.437 280.682L133.438 281.273L133.618 280.962C133.83 280.919 134.033 280.841 134.219 280.732C134.829 280.335 135.337 279.8 135.7 279.17C136.064 278.54 136.274 277.833 136.312 277.107C136.309 276.928 136.289 276.751 136.252 276.576L136.493 276.185Z",
    fill: "url(#paint93_linear_515_48900)"
  })), _path189 || (_path189 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M136.493 276.185L135.391 275.555C135.154 275.448 134.893 275.406 134.635 275.433C134.376 275.459 134.129 275.553 133.919 275.705C133.311 276.103 132.804 276.639 132.441 277.268C132.077 277.898 131.867 278.604 131.826 279.33C131.8 279.589 131.843 279.851 131.95 280.088C132.057 280.325 132.225 280.53 132.437 280.682L133.438 281.273L133.618 280.962C133.83 280.919 134.033 280.841 134.219 280.732C134.829 280.335 135.337 279.8 135.7 279.17C136.064 278.54 136.274 277.833 136.312 277.107C136.309 276.928 136.289 276.751 136.252 276.576L136.493 276.185Z",
    fill: "black"
  })), _path190 || (_path190 = /*#__PURE__*/React.createElement("path", {
    d: "M134.97 276.306C134.362 276.704 133.856 277.24 133.492 277.869C133.129 278.499 132.918 279.205 132.877 279.931C132.877 281.263 133.818 281.804 134.97 281.143C135.578 280.744 136.084 280.209 136.448 279.579C136.811 278.949 137.022 278.243 137.063 277.517C137.063 276.185 136.122 275.645 134.97 276.306Z",
    fill: "url(#paint94_linear_515_48900)"
  })), _path191 || (_path191 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.97 276.306C134.362 276.704 133.856 277.24 133.492 277.869C133.129 278.499 132.918 279.205 132.877 279.931C132.877 281.263 133.818 281.804 134.97 281.143C135.578 280.744 136.084 280.209 136.448 279.579C136.811 278.949 137.022 278.243 137.063 277.517C137.063 276.185 136.122 275.645 134.97 276.306Z",
    fill: "black"
  })), _path192 || (_path192 = /*#__PURE__*/React.createElement("path", {
    d: "M145.566 239.672L144.464 239.041C144.229 238.936 143.97 238.894 143.713 238.921C143.456 238.947 143.211 239.041 143.002 239.191C142.392 239.588 141.885 240.123 141.521 240.753C141.157 241.383 140.947 242.09 140.909 242.817C140.881 243.076 140.923 243.338 141.03 243.576C141.138 243.814 141.307 244.018 141.52 244.169L142.521 244.76L142.711 244.449C142.923 244.405 143.126 244.327 143.312 244.219C143.921 243.82 144.427 243.285 144.79 242.655C145.154 242.026 145.364 241.319 145.405 240.593C145.404 240.414 145.381 240.236 145.335 240.063L145.566 239.672Z",
    fill: "url(#paint95_linear_515_48900)"
  })), _path193 || (_path193 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M145.566 239.672L144.464 239.041C144.229 238.936 143.97 238.894 143.713 238.921C143.456 238.947 143.211 239.041 143.002 239.191C142.392 239.588 141.885 240.123 141.521 240.753C141.157 241.383 140.947 242.09 140.909 242.817C140.881 243.076 140.923 243.338 141.03 243.576C141.138 243.814 141.307 244.018 141.52 244.169L142.521 244.76L142.711 244.449C142.923 244.405 143.126 244.327 143.312 244.219C143.921 243.82 144.427 243.285 144.79 242.655C145.154 242.026 145.364 241.319 145.405 240.593C145.404 240.414 145.381 240.236 145.335 240.063L145.566 239.672Z",
    fill: "black"
  })), _path194 || (_path194 = /*#__PURE__*/React.createElement("path", {
    d: "M144.044 239.792C143.437 240.191 142.932 240.727 142.571 241.357C142.209 241.987 142 242.692 141.961 243.418C141.961 244.75 142.892 245.29 144.044 244.629C144.654 244.233 145.161 243.698 145.525 243.068C145.889 242.438 146.098 241.731 146.137 241.004C146.137 239.672 145.206 239.131 144.044 239.792Z",
    fill: "url(#paint96_linear_515_48900)"
  })), _path195 || (_path195 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.044 239.792C143.437 240.191 142.932 240.727 142.571 241.357C142.209 241.987 142 242.692 141.961 243.418C141.961 244.75 142.892 245.29 144.044 244.629C144.654 244.233 145.161 243.698 145.525 243.068C145.889 242.438 146.098 241.731 146.137 241.004C146.137 239.672 145.206 239.131 144.044 239.792Z",
    fill: "black"
  })), _path196 || (_path196 = /*#__PURE__*/React.createElement("path", {
    d: "M136.492 244.92L135.39 244.279C135.154 244.171 134.892 244.128 134.634 244.154C134.375 244.18 134.128 244.275 133.918 244.429C133.315 244.828 132.814 245.363 132.456 245.991C132.098 246.619 131.892 247.322 131.855 248.044C131.829 248.304 131.872 248.565 131.979 248.802C132.086 249.04 132.254 249.245 132.466 249.396L133.467 249.987L133.648 249.677C133.859 249.633 134.062 249.555 134.249 249.446C134.858 249.05 135.366 248.515 135.73 247.885C136.093 247.255 136.303 246.548 136.342 245.821C136.339 245.643 136.319 245.465 136.281 245.29L136.492 244.92Z",
    fill: "url(#paint97_linear_515_48900)"
  })), _path197 || (_path197 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M136.492 244.92L135.39 244.279C135.154 244.171 134.892 244.128 134.634 244.154C134.375 244.18 134.128 244.275 133.918 244.429C133.315 244.828 132.814 245.363 132.456 245.991C132.098 246.619 131.892 247.322 131.855 248.044C131.829 248.304 131.872 248.565 131.979 248.802C132.086 249.04 132.254 249.245 132.466 249.396L133.467 249.987L133.648 249.677C133.859 249.633 134.062 249.555 134.249 249.446C134.858 249.05 135.366 248.515 135.73 247.885C136.093 247.255 136.303 246.548 136.342 245.821C136.339 245.643 136.319 245.465 136.281 245.29L136.492 244.92Z",
    fill: "black"
  })), _path198 || (_path198 = /*#__PURE__*/React.createElement("path", {
    d: "M134.97 245.04C134.362 245.438 133.856 245.974 133.492 246.604C133.129 247.233 132.918 247.939 132.877 248.665C132.877 249.997 133.818 250.538 134.97 249.877C135.578 249.479 136.084 248.943 136.448 248.314C136.811 247.684 137.022 246.978 137.063 246.252C137.063 244.91 136.122 244.369 134.97 245.04Z",
    fill: "url(#paint98_linear_515_48900)"
  })), _path199 || (_path199 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.97 245.04C134.362 245.438 133.856 245.974 133.492 246.604C133.129 247.233 132.918 247.939 132.877 248.665C132.877 249.997 133.818 250.538 134.97 249.877C135.578 249.479 136.084 248.943 136.448 248.314C136.811 247.684 137.022 246.978 137.063 246.252C137.063 244.91 136.122 244.369 134.97 245.04Z",
    fill: "black"
  })), _path200 || (_path200 = /*#__PURE__*/React.createElement("path", {
    d: "M145.566 208.407L144.464 207.766C144.229 207.657 143.97 207.614 143.712 207.641C143.455 207.667 143.21 207.762 143.002 207.916C142.392 208.31 141.884 208.843 141.52 209.471C141.156 210.1 140.947 210.806 140.909 211.531C140.881 211.791 140.923 212.053 141.03 212.29C141.138 212.528 141.307 212.733 141.52 212.883L142.521 213.474L142.711 213.164C142.923 213.12 143.126 213.042 143.312 212.933C143.921 212.535 144.427 211.999 144.79 211.37C145.154 210.74 145.364 210.034 145.405 209.308C145.404 209.129 145.381 208.951 145.335 208.777L145.566 208.407Z",
    fill: "url(#paint99_linear_515_48900)"
  })), _path201 || (_path201 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M145.566 208.407L144.464 207.766C144.229 207.657 143.97 207.614 143.712 207.641C143.455 207.667 143.21 207.762 143.002 207.916C142.392 208.31 141.884 208.843 141.52 209.471C141.156 210.1 140.947 210.806 140.909 211.531C140.881 211.791 140.923 212.053 141.03 212.29C141.138 212.528 141.307 212.733 141.52 212.883L142.521 213.474L142.711 213.164C142.923 213.12 143.126 213.042 143.312 212.933C143.921 212.535 144.427 211.999 144.79 211.37C145.154 210.74 145.364 210.034 145.405 209.308C145.404 209.129 145.381 208.951 145.335 208.777L145.566 208.407Z",
    fill: "black"
  })), _path202 || (_path202 = /*#__PURE__*/React.createElement("path", {
    d: "M144.044 208.517C143.437 208.916 142.932 209.452 142.571 210.081C142.209 210.711 142 211.417 141.961 212.142C141.961 213.474 142.892 214.015 144.044 213.354C144.654 212.957 145.161 212.422 145.525 211.792C145.889 211.162 146.098 210.455 146.137 209.728C146.137 208.397 145.206 207.856 144.044 208.517Z",
    fill: "url(#paint100_linear_515_48900)"
  })), _path203 || (_path203 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.044 208.517C143.437 208.916 142.932 209.452 142.571 210.081C142.209 210.711 142 211.417 141.961 212.142C141.961 213.474 142.892 214.015 144.044 213.354C144.654 212.957 145.161 212.422 145.525 211.792C145.889 211.162 146.098 210.455 146.137 209.728C146.137 208.397 145.206 207.856 144.044 208.517Z",
    fill: "black"
  })), _path204 || (_path204 = /*#__PURE__*/React.createElement("path", {
    d: "M136.491 213.644L135.39 213.003C135.153 212.895 134.892 212.852 134.633 212.878C134.374 212.905 134.127 213 133.917 213.154C133.309 213.549 132.802 214.083 132.439 214.711C132.075 215.339 131.864 216.044 131.824 216.769C131.797 217.028 131.84 217.29 131.947 217.527C132.054 217.765 132.223 217.97 132.435 218.121L133.437 218.702L133.617 218.391C133.828 218.347 134.031 218.269 134.218 218.161C134.829 217.766 135.338 217.231 135.702 216.601C136.066 215.97 136.275 215.263 136.311 214.536C136.307 214.357 136.287 214.179 136.251 214.005L136.491 213.644Z",
    fill: "url(#paint101_linear_515_48900)"
  })), _path205 || (_path205 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M136.491 213.644L135.39 213.003C135.153 212.895 134.892 212.852 134.633 212.878C134.374 212.905 134.127 213 133.917 213.154C133.309 213.549 132.802 214.083 132.439 214.711C132.075 215.339 131.864 216.044 131.824 216.769C131.797 217.028 131.84 217.29 131.947 217.527C132.054 217.765 132.223 217.97 132.435 218.121L133.437 218.702L133.617 218.391C133.828 218.347 134.031 218.269 134.218 218.161C134.829 217.766 135.338 217.231 135.702 216.601C136.066 215.97 136.275 215.263 136.311 214.536C136.307 214.357 136.287 214.179 136.251 214.005L136.491 213.644Z",
    fill: "black"
  })), _path206 || (_path206 = /*#__PURE__*/React.createElement("path", {
    d: "M134.97 213.764C134.361 214.16 133.855 214.694 133.491 215.322C133.128 215.95 132.917 216.655 132.877 217.38C132.877 218.712 133.818 219.252 134.97 218.591C135.574 218.196 136.078 217.665 136.441 217.041C136.805 216.417 137.018 215.717 137.063 214.996C137.063 213.634 136.122 213.093 134.97 213.764Z",
    fill: "url(#paint102_linear_515_48900)"
  })), _path207 || (_path207 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.97 213.764C134.361 214.16 133.855 214.694 133.491 215.322C133.128 215.95 132.917 216.655 132.877 217.38C132.877 218.712 133.818 219.252 134.97 218.591C135.574 218.196 136.078 217.665 136.441 217.041C136.805 216.417 137.018 215.717 137.063 214.996C137.063 213.634 136.122 213.093 134.97 213.764Z",
    fill: "black"
  })), _path208 || (_path208 = /*#__PURE__*/React.createElement("path", {
    d: "M145.565 177.071L144.463 176.43C144.228 176.325 143.969 176.283 143.712 176.309C143.456 176.336 143.211 176.429 143.001 176.58C142.39 176.975 141.881 177.51 141.517 178.14C141.153 178.77 140.944 179.478 140.908 180.205C140.881 180.465 140.924 180.726 141.031 180.964C141.138 181.201 141.307 181.406 141.519 181.557L142.521 182.138L142.711 181.838C142.921 181.785 143.123 181.704 143.312 181.597C143.92 181.202 144.427 180.668 144.791 180.04C145.154 179.412 145.365 178.707 145.405 177.982C145.404 177.8 145.38 177.618 145.335 177.441L145.565 177.071Z",
    fill: "url(#paint103_linear_515_48900)"
  })), _path209 || (_path209 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M145.565 177.071L144.463 176.43C144.228 176.325 143.969 176.283 143.712 176.309C143.456 176.336 143.211 176.429 143.001 176.58C142.39 176.975 141.881 177.51 141.517 178.14C141.153 178.77 140.944 179.478 140.908 180.205C140.881 180.465 140.924 180.726 141.031 180.964C141.138 181.201 141.307 181.406 141.519 181.557L142.521 182.138L142.711 181.838C142.921 181.785 143.123 181.704 143.312 181.597C143.92 181.202 144.427 180.668 144.791 180.04C145.154 179.412 145.365 178.707 145.405 177.982C145.404 177.8 145.38 177.618 145.335 177.441L145.565 177.071Z",
    fill: "black"
  })), _path210 || (_path210 = /*#__PURE__*/React.createElement("path", {
    d: "M144.044 177.191C143.437 177.587 142.932 178.121 142.57 178.749C142.208 179.378 141.999 180.082 141.961 180.806C141.961 182.148 142.892 182.689 144.044 182.018C144.654 181.622 145.161 181.086 145.525 180.456C145.889 179.826 146.098 179.119 146.137 178.393C146.137 177.061 145.206 176.52 144.044 177.191Z",
    fill: "url(#paint104_linear_515_48900)"
  })), _path211 || (_path211 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.044 177.191C143.437 177.587 142.932 178.121 142.57 178.749C142.208 179.378 141.999 180.082 141.961 180.806C141.961 182.148 142.892 182.689 144.044 182.018C144.654 181.622 145.161 181.086 145.525 180.456C145.889 179.826 146.098 179.119 146.137 178.393C146.137 177.061 145.206 176.52 144.044 177.191Z",
    fill: "black"
  })), _path212 || (_path212 = /*#__PURE__*/React.createElement("path", {
    d: "M136.492 182.309L135.39 181.668C135.153 181.561 134.893 181.52 134.634 181.546C134.376 181.572 134.129 181.666 133.918 181.818C133.31 182.216 132.804 182.752 132.44 183.381C132.077 184.011 131.866 184.717 131.825 185.443C131.8 185.702 131.844 185.963 131.951 186.2C132.058 186.438 132.225 186.643 132.436 186.795L133.438 187.386L133.618 187.076C133.829 187.027 134.032 186.946 134.219 186.835C134.829 186.441 135.337 185.908 135.701 185.28C136.065 184.651 136.274 183.945 136.312 183.22C136.308 183.038 136.288 182.857 136.252 182.679L136.492 182.309Z",
    fill: "url(#paint105_linear_515_48900)"
  })), _path213 || (_path213 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M136.492 182.309L135.39 181.668C135.153 181.561 134.893 181.52 134.634 181.546C134.376 181.572 134.129 181.666 133.918 181.818C133.31 182.216 132.804 182.752 132.44 183.381C132.077 184.011 131.866 184.717 131.825 185.443C131.8 185.702 131.844 185.963 131.951 186.2C132.058 186.438 132.225 186.643 132.436 186.795L133.438 187.386L133.618 187.076C133.829 187.027 134.032 186.946 134.219 186.835C134.829 186.441 135.337 185.908 135.701 185.28C136.065 184.651 136.274 183.945 136.312 183.22C136.308 183.038 136.288 182.857 136.252 182.679L136.492 182.309Z",
    fill: "black"
  })), _path214 || (_path214 = /*#__PURE__*/React.createElement("path", {
    d: "M134.969 182.429C134.356 182.824 133.846 183.359 133.478 183.989C133.111 184.619 132.898 185.326 132.855 186.054C132.855 187.386 133.797 187.927 134.949 187.256C135.558 186.859 136.066 186.324 136.43 185.694C136.793 185.064 137.003 184.357 137.042 183.63C137.062 182.299 136.12 181.758 134.969 182.429Z",
    fill: "url(#paint106_linear_515_48900)"
  })), _path215 || (_path215 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.969 182.429C134.356 182.824 133.846 183.359 133.478 183.989C133.111 184.619 132.898 185.326 132.855 186.054C132.855 187.386 133.797 187.927 134.949 187.256C135.558 186.859 136.066 186.324 136.43 185.694C136.793 185.064 137.003 184.357 137.042 183.63C137.062 182.299 136.12 181.758 134.969 182.429Z",
    fill: "black"
  })), _path216 || (_path216 = /*#__PURE__*/React.createElement("path", {
    d: "M145.564 145.805L144.463 145.164C144.227 145.059 143.968 145.018 143.711 145.044C143.455 145.07 143.21 145.164 143 145.315C142.388 145.702 141.875 146.229 141.505 146.852C141.134 147.475 140.916 148.177 140.867 148.9C140.84 149.159 140.883 149.421 140.99 149.658C141.097 149.896 141.266 150.101 141.478 150.252L142.48 150.843L142.67 150.532C142.88 150.479 143.082 150.398 143.271 150.292C143.879 149.896 144.386 149.363 144.75 148.735C145.113 148.106 145.324 147.401 145.364 146.677C145.363 146.494 145.339 146.312 145.294 146.136L145.564 145.805Z",
    fill: "url(#paint107_linear_515_48900)"
  })), _path217 || (_path217 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M145.564 145.805L144.463 145.164C144.227 145.059 143.968 145.018 143.711 145.044C143.455 145.07 143.21 145.164 143 145.315C142.388 145.702 141.875 146.229 141.505 146.852C141.134 147.475 140.916 148.177 140.867 148.9C140.84 149.159 140.883 149.421 140.99 149.658C141.097 149.896 141.266 150.101 141.478 150.252L142.48 150.843L142.67 150.532C142.88 150.479 143.082 150.398 143.271 150.292C143.879 149.896 144.386 149.363 144.75 148.735C145.113 148.106 145.324 147.401 145.364 146.677C145.363 146.494 145.339 146.312 145.294 146.136L145.564 145.805Z",
    fill: "black"
  })), _path218 || (_path218 = /*#__PURE__*/React.createElement("path", {
    d: "M144.044 145.896C143.437 146.292 142.932 146.826 142.57 147.454C142.208 148.082 141.999 148.787 141.961 149.511C141.961 150.853 142.892 151.394 144.044 150.723C144.654 150.327 145.162 149.792 145.526 149.161C145.89 148.531 146.099 147.824 146.137 147.097C146.137 145.795 145.206 145.255 144.044 145.896Z",
    fill: "url(#paint108_linear_515_48900)"
  })), _path219 || (_path219 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M144.044 145.896C143.437 146.292 142.932 146.826 142.57 147.454C142.208 148.082 141.999 148.787 141.961 149.511C141.961 150.853 142.892 151.394 144.044 150.723C144.654 150.327 145.162 149.792 145.526 149.161C145.89 148.531 146.099 147.824 146.137 147.097C146.137 145.795 145.206 145.255 144.044 145.896Z",
    fill: "black"
  })), _path220 || (_path220 = /*#__PURE__*/React.createElement("path", {
    d: "M136.492 151.043L135.39 150.402C135.153 150.296 134.893 150.254 134.634 150.28C134.376 150.307 134.129 150.4 133.918 150.552C133.31 150.951 132.804 151.486 132.44 152.116C132.077 152.745 131.866 153.452 131.825 154.178C131.8 154.437 131.844 154.698 131.951 154.935C132.058 155.172 132.225 155.377 132.436 155.53L133.438 156.12L133.618 155.81C133.829 155.761 134.032 155.68 134.219 155.57C134.829 155.176 135.337 154.643 135.701 154.014C136.065 153.386 136.274 152.68 136.312 151.954C136.308 151.773 136.288 151.592 136.252 151.413L136.492 151.043Z",
    fill: "url(#paint109_linear_515_48900)"
  })), _path221 || (_path221 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M136.492 151.043L135.39 150.402C135.153 150.296 134.893 150.254 134.634 150.28C134.376 150.307 134.129 150.4 133.918 150.552C133.31 150.951 132.804 151.486 132.44 152.116C132.077 152.745 131.866 153.452 131.825 154.178C131.8 154.437 131.844 154.698 131.951 154.935C132.058 155.172 132.225 155.377 132.436 155.53L133.438 156.12L133.618 155.81C133.829 155.761 134.032 155.68 134.219 155.57C134.829 155.176 135.337 154.643 135.701 154.014C136.065 153.386 136.274 152.68 136.312 151.954C136.308 151.773 136.288 151.592 136.252 151.413L136.492 151.043Z",
    fill: "black"
  })), _path222 || (_path222 = /*#__PURE__*/React.createElement("path", {
    d: "M134.97 151.163C134.361 151.561 133.855 152.096 133.491 152.726C133.127 153.356 132.917 154.062 132.877 154.788C132.877 156.12 133.818 156.661 134.97 155.99C135.579 155.595 136.085 155.061 136.449 154.433C136.812 153.805 137.023 153.1 137.063 152.375C137.063 151.033 136.122 150.492 134.97 151.163Z",
    fill: "url(#paint110_linear_515_48900)"
  })), _path223 || (_path223 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M134.97 151.163C134.361 151.561 133.855 152.096 133.491 152.726C133.127 153.356 132.917 154.062 132.877 154.788C132.877 156.12 133.818 156.661 134.97 155.99C135.579 155.595 136.085 155.061 136.449 154.433C136.812 153.805 137.023 153.1 137.063 152.375C137.063 151.033 136.122 150.492 134.97 151.163Z",
    fill: "black"
  })), _path224 || (_path224 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3456 217.79L117.496 241.535C117.884 241.786 118.207 242.126 118.439 242.526C118.67 242.927 118.804 243.376 118.828 243.838V255.205C118.828 256.056 118.237 256.407 117.496 255.976L76.3456 232.241C75.9571 231.988 75.6339 231.646 75.4024 231.244C75.1709 230.842 75.0377 230.391 75.0137 229.928V218.561C75.0137 217.71 75.6045 217.37 76.3456 217.79Z",
    fill: "#455A64"
  })), _path225 || (_path225 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5176 222.798C77.5507 223.245 77.6885 223.679 77.9199 224.063C78.1512 224.447 78.4697 224.772 78.8495 225.011L114.992 245.861C115.733 246.282 116.334 245.982 116.334 245.18C116.299 244.732 116.16 244.298 115.926 243.914C115.693 243.53 115.373 243.205 114.992 242.967L78.8495 222.127C78.1084 221.706 77.5176 222.007 77.5176 222.798Z",
    fill: "url(#paint111_linear_515_48900)"
  })), _path226 || (_path226 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5176 228.576C77.5484 229.024 77.6852 229.458 77.9167 229.843C78.1483 230.228 78.468 230.552 78.8495 230.789L114.992 251.64C115.733 252.07 116.334 251.77 116.334 250.969C116.302 250.52 116.163 250.085 115.93 249.701C115.696 249.316 115.375 248.992 114.992 248.755L78.8495 227.905C78.1084 227.484 77.5176 227.785 77.5176 228.576Z",
    fill: "#263238"
  })), _path227 || (_path227 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8498 227.905L98.8089 239.412V242.306L78.8397 230.789C78.4583 230.552 78.1385 230.228 77.907 229.843C77.6754 229.458 77.5386 229.024 77.5078 228.576C77.5178 227.785 78.1087 227.484 78.8498 227.905Z",
    fill: "url(#paint112_linear_515_48900)"
  })), _path228 || (_path228 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3456 249.136L117.496 272.881C117.885 273.131 118.208 273.471 118.44 273.871C118.671 274.272 118.804 274.722 118.828 275.184V286.551C118.828 287.402 118.237 287.742 117.496 287.322L76.3456 263.577C75.9567 263.326 75.633 262.987 75.4014 262.586C75.1698 262.186 75.0369 261.736 75.0137 261.274V249.907C75.0137 249.046 75.6045 248.715 76.3456 249.136Z",
    fill: "#455A64"
  })), _path229 || (_path229 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5176 254.143C77.5484 254.591 77.6852 255.026 77.9167 255.411C78.1483 255.795 78.468 256.12 78.8495 256.357L114.992 277.207C115.733 277.638 116.334 277.337 116.334 276.536C116.302 276.087 116.163 275.653 115.93 275.268C115.696 274.883 115.375 274.559 114.992 274.323L78.8495 253.472C78.1084 253.052 77.5176 253.342 77.5176 254.143Z",
    fill: "url(#paint113_linear_515_48900)"
  })), _path230 || (_path230 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5176 259.922C77.5484 260.37 77.6852 260.804 77.9167 261.189C78.1483 261.574 78.468 261.898 78.8495 262.135L114.992 282.985C115.733 283.416 116.334 283.106 116.334 282.314C116.302 281.866 116.163 281.431 115.93 281.046C115.696 280.662 115.375 280.338 114.992 280.101L78.8495 259.251C78.1084 258.82 77.5176 259.121 77.5176 259.922Z",
    fill: "#263238"
  })), _path231 || (_path231 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8495 259.251L103.816 273.642V276.536L78.8495 262.135C78.468 261.898 78.1483 261.574 77.9167 261.189C77.6852 260.804 77.5484 260.37 77.5176 259.922C77.5176 259.121 78.1084 258.82 78.8495 259.251Z",
    fill: "url(#paint114_linear_515_48900)"
  })), _path232 || (_path232 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3456 280.251L117.496 303.996C117.885 304.247 118.208 304.586 118.44 304.987C118.671 305.387 118.804 305.837 118.828 306.299V317.666C118.828 318.517 118.237 318.858 117.496 318.437L76.3456 294.692C75.9567 294.442 75.633 294.102 75.4014 293.702C75.1698 293.301 75.0369 292.851 75.0137 292.389V281.022C75.0137 280.171 75.6045 279.831 76.3456 280.251Z",
    fill: "#455A64"
  })), _path233 || (_path233 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5176 285.259C77.5484 285.707 77.6852 286.141 77.9167 286.526C78.1483 286.911 78.468 287.235 78.8495 287.472L114.992 308.322C115.733 308.753 116.334 308.452 116.334 307.651C116.302 307.203 116.163 306.768 115.93 306.383C115.696 305.998 115.375 305.675 114.992 305.438L78.8495 284.588C78.1084 284.157 77.5176 284.458 77.5176 285.259Z",
    fill: "url(#paint115_linear_515_48900)"
  })), _path234 || (_path234 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5176 291.037C77.5484 291.485 77.6852 291.92 77.9167 292.304C78.1483 292.689 78.468 293.013 78.8495 293.25L114.992 314.141C115.733 314.572 116.334 314.261 116.334 313.47C116.302 313.021 116.163 312.587 115.93 312.202C115.696 311.817 115.375 311.493 114.992 311.257L78.8495 290.366C78.1084 289.936 77.5176 290.236 77.5176 291.037Z",
    fill: "#263238"
  })), _path235 || (_path235 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8495 290.366L108.823 307.651V310.536L78.8495 293.25C78.468 293.013 78.1483 292.689 77.9167 292.304C77.6852 291.92 77.5484 291.485 77.5176 291.037C77.5176 290.236 78.1084 289.936 78.8495 290.366Z",
    fill: "url(#paint116_linear_515_48900)"
  })), _path236 || (_path236 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3456 186.755L117.496 210.49C117.884 210.743 118.207 211.085 118.439 211.487C118.67 211.889 118.804 212.34 118.828 212.803V224.17C118.828 225.021 118.237 225.361 117.496 224.941L76.3456 201.196C75.9565 200.943 75.6329 200.602 75.4013 200.2C75.1698 199.797 75.0369 199.346 75.0137 198.883V187.526C75.0137 186.675 75.6045 186.324 76.3456 186.755Z",
    fill: "#455A64"
  })), _path237 || (_path237 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5176 191.762C77.5499 192.209 77.6874 192.641 77.9189 193.024C78.1504 193.407 78.4693 193.73 78.8495 193.966L114.992 214.816C115.733 215.237 116.334 214.936 116.334 214.145C116.302 213.696 116.163 213.262 115.93 212.877C115.696 212.492 115.375 212.168 114.992 211.932L78.8495 191.091C78.1084 190.661 77.5176 190.961 77.5176 191.762Z",
    fill: "url(#paint117_linear_515_48900)"
  })), _path238 || (_path238 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5176 197.541C77.5507 197.988 77.6885 198.422 77.9199 198.806C78.1512 199.191 78.4697 199.515 78.8495 199.754L114.992 220.604C115.733 221.025 116.334 220.725 116.334 219.933C116.301 219.484 116.162 219.048 115.929 218.662C115.695 218.275 115.375 217.949 114.992 217.71L78.8495 196.86C78.1084 196.439 77.5176 196.74 77.5176 197.541Z",
    fill: "#263238"
  })), _path239 || (_path239 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8495 196.86L111.327 215.597V218.481L78.8495 199.754C78.4697 199.515 78.1512 199.191 77.9199 198.806C77.6885 198.422 77.5507 197.988 77.5176 197.541C77.5176 196.74 78.1084 196.439 78.8495 196.86Z",
    fill: "url(#paint118_linear_515_48900)"
  })), _path240 || (_path240 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3456 124.134L117.496 147.898C117.885 148.149 118.208 148.489 118.44 148.889C118.671 149.29 118.804 149.74 118.828 150.202V161.568C118.828 162.419 118.237 162.76 117.496 162.339L76.3456 138.575C75.9567 138.324 75.633 137.984 75.4014 137.584C75.1698 137.183 75.0369 136.733 75.0137 136.271V124.865C75.0137 124.054 75.6045 123.713 76.3456 124.134Z",
    fill: "#455A64"
  })), _path241 || (_path241 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5176 129.141C77.5484 129.589 77.6852 130.023 77.9167 130.408C78.1483 130.793 78.468 131.117 78.8495 131.354L114.992 152.205C115.733 152.635 116.334 152.335 116.334 151.534C116.302 151.085 116.163 150.65 115.93 150.266C115.696 149.881 115.375 149.557 114.992 149.32L78.8495 128.47C78.1084 128.039 77.5176 128.34 77.5176 129.141Z",
    fill: "url(#paint119_linear_515_48900)"
  })), _path242 || (_path242 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5176 134.879C77.5484 135.328 77.6852 135.762 77.9167 136.147C78.1483 136.531 78.468 136.856 78.8495 137.093L114.992 157.943C115.733 158.374 116.334 158.063 116.334 157.272C116.302 156.823 116.163 156.389 115.93 156.004C115.696 155.619 115.375 155.295 114.992 155.059L78.8495 134.249C78.1084 133.818 77.5176 134.118 77.5176 134.879Z",
    fill: "#263238"
  })), _path243 || (_path243 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8495 134.249L103.816 148.64V151.534L78.8495 137.133C78.4627 136.892 78.1397 136.561 77.9078 136.169C77.676 135.777 77.5421 135.334 77.5176 134.879C77.5176 134.118 78.1084 133.818 78.8495 134.249Z",
    fill: "url(#paint120_linear_515_48900)"
  })), _path244 || (_path244 = /*#__PURE__*/React.createElement("path", {
    d: "M76.3456 155.419L117.496 179.164C117.885 179.415 118.208 179.754 118.44 180.155C118.671 180.555 118.804 181.005 118.828 181.467V192.834C118.828 193.685 118.237 194.026 117.496 193.605L76.3456 169.86C75.9567 169.61 75.633 169.27 75.4014 168.87C75.1698 168.469 75.0369 168.019 75.0137 167.557V156.19C75.0137 155.339 75.6045 154.999 76.3456 155.419Z",
    fill: "#455A64"
  })), _path245 || (_path245 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5176 160.427C77.5484 160.875 77.6852 161.309 77.9167 161.694C78.1483 162.079 78.468 162.403 78.8495 162.64L114.992 183.49C115.733 183.921 116.334 183.62 116.334 182.819C116.302 182.371 116.163 181.936 115.93 181.551C115.696 181.166 115.375 180.843 114.992 180.606L78.8495 159.756C78.1084 159.325 77.5176 159.635 77.5176 160.427Z",
    fill: "url(#paint121_linear_515_48900)"
  })), _path246 || (_path246 = /*#__PURE__*/React.createElement("path", {
    d: "M77.5176 166.205C77.5484 166.653 77.6852 167.087 77.9167 167.472C78.1483 167.857 78.468 168.181 78.8495 168.418L114.992 189.269C115.733 189.699 116.334 189.399 116.334 188.598C116.302 188.149 116.163 187.714 115.93 187.33C115.696 186.945 115.375 186.621 114.992 186.384L78.8495 165.534C78.1084 165.103 77.5176 165.404 77.5176 166.205Z",
    fill: "#263238"
  })), _path247 || (_path247 = /*#__PURE__*/React.createElement("path", {
    d: "M78.8495 165.534L111.327 184.261V187.156L78.8495 168.418C78.468 168.181 78.1483 167.857 77.9167 167.472C77.6852 167.087 77.5484 166.653 77.5176 166.205C77.5176 165.404 78.1084 165.103 78.8495 165.534Z",
    fill: "url(#paint122_linear_515_48900)"
  })), _path248 || (_path248 = /*#__PURE__*/React.createElement("path", {
    d: "M126.587 135.15L174.918 107.239C175.283 107.001 175.586 106.68 175.803 106.302C176.021 105.924 176.146 105.501 176.17 105.066V103.444C176.146 103.008 176.021 102.585 175.803 102.207C175.586 101.83 175.283 101.509 174.918 101.27L126.567 73.3597C126.18 73.1618 125.751 73.0587 125.316 73.0587C124.88 73.0587 124.451 73.1618 124.064 73.3597L75.7733 101.27C75.4086 101.509 75.1053 101.83 74.8878 102.207C74.6703 102.585 74.5448 103.008 74.5215 103.444V105.066C74.5448 105.501 74.6703 105.924 74.8878 106.302C75.1053 106.68 75.4086 107.001 75.7733 107.239L124.134 135.15C124.515 135.339 124.935 135.438 125.361 135.438C125.786 135.438 126.206 135.339 126.587 135.15Z",
    fill: "url(#paint123_linear_515_48900)"
  })), _path249 || (_path249 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M126.587 135.15L174.918 107.239C175.283 107.001 175.586 106.68 175.803 106.302C176.021 105.924 176.146 105.501 176.17 105.066V103.444C176.146 103.008 176.021 102.585 175.803 102.207C175.586 101.83 175.283 101.509 174.918 101.27L126.567 73.3597C126.18 73.1618 125.751 73.0587 125.316 73.0587C124.88 73.0587 124.451 73.1618 124.064 73.3597L75.7733 101.27C75.4086 101.509 75.1053 101.83 74.8878 102.207C74.6703 102.585 74.5448 103.008 74.5215 103.444V105.066C74.5448 105.501 74.6703 105.924 74.8878 106.302C75.1053 106.68 75.4086 107.001 75.7733 107.239L124.134 135.15C124.515 135.339 124.935 135.438 125.361 135.438C125.786 135.438 126.206 135.339 126.587 135.15Z",
    fill: "black"
  })), _path250 || (_path250 = /*#__PURE__*/React.createElement("path", {
    d: "M174.918 102.713L126.567 130.633C126.18 130.831 125.751 130.934 125.315 130.934C124.88 130.934 124.451 130.831 124.064 130.633L75.7731 102.723C75.6234 102.669 75.4939 102.571 75.4024 102.441C75.3109 102.311 75.2617 102.156 75.2617 101.997C75.2617 101.838 75.3109 101.682 75.4024 101.553C75.4939 101.423 75.6234 101.324 75.7731 101.27L124.134 73.3598C124.521 73.162 124.95 73.0588 125.385 73.0588C125.821 73.0588 126.25 73.162 126.637 73.3598L174.918 101.27C175.069 101.321 175.2 101.418 175.292 101.548C175.385 101.677 175.435 101.832 175.435 101.992C175.435 102.151 175.385 102.306 175.292 102.435C175.2 102.565 175.069 102.662 174.918 102.713Z",
    fill: "url(#paint124_linear_515_48900)"
  })), _path251 || (_path251 = /*#__PURE__*/React.createElement("path", {
    d: "M125.324 130.934V135.45C125.764 135.459 126.198 135.356 126.586 135.15L174.917 107.229C175.282 106.993 175.585 106.674 175.803 106.298C176.021 105.922 176.146 105.5 176.168 105.066V103.434C176.15 103.048 176.051 102.671 175.879 102.327C175.706 101.982 175.464 101.677 175.167 101.431C175.618 101.831 175.547 102.372 174.937 102.713L126.586 130.633C126.198 130.839 125.764 130.942 125.324 130.934Z",
    fill: "url(#paint125_linear_515_48900)"
  })), _path252 || (_path252 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M125.324 130.934V135.45C125.764 135.459 126.198 135.356 126.586 135.15L174.917 107.229C175.282 106.993 175.585 106.674 175.803 106.298C176.021 105.922 176.146 105.5 176.168 105.066V103.434C176.15 103.048 176.051 102.671 175.879 102.327C175.706 101.982 175.464 101.677 175.167 101.431C175.618 101.831 175.547 102.372 174.937 102.713L126.586 130.633C126.198 130.839 125.764 130.942 125.324 130.934Z",
    fill: "black"
  })), _path253 || (_path253 = /*#__PURE__*/React.createElement("path", {
    d: "M126.588 121.6L159.286 102.722C159.651 102.484 159.954 102.163 160.171 101.785C160.389 101.408 160.514 100.984 160.538 100.549V98.9269C160.514 98.4918 160.389 98.0683 160.171 97.6908C159.954 97.3132 159.651 96.9922 159.286 96.7537L138.325 84.6461C137.518 84.1449 136.803 83.5079 136.212 82.7633L126.198 69.2737C125.954 68.9624 125.608 68.7481 125.22 68.6692C124.833 68.5903 124.43 68.6519 124.085 68.843L91.3768 87.7206C91.0135 87.958 90.7109 88.2775 90.4935 88.6532C90.2761 89.0289 90.1499 89.4504 90.125 89.8837V100.549C90.1483 100.984 90.2738 101.408 90.4913 101.785C90.7088 102.163 91.0122 102.484 91.3768 102.722L124.085 121.6C124.472 121.798 124.901 121.901 125.336 121.901C125.772 121.901 126.201 121.798 126.588 121.6Z",
    fill: "#263238"
  })), _path254 || (_path254 = /*#__PURE__*/React.createElement("path", {
    d: "M124.085 117.083L103.114 104.976C102.308 104.473 101.593 103.836 101.001 103.093L90.9864 89.6033C90.8723 89.4597 90.7912 89.2927 90.7488 89.1142C90.7063 88.9357 90.7037 88.7501 90.7409 88.5705C90.7782 88.3909 90.8545 88.2217 90.9644 88.0748C91.0743 87.9279 91.2151 87.807 91.377 87.7206L124.085 68.843C124.431 68.6519 124.833 68.5903 125.22 68.6692C125.608 68.7481 125.954 68.9624 126.198 69.2737L136.212 82.7633C136.732 83.541 137.386 84.2194 138.145 84.7663L159.286 96.7838C159.437 96.8348 159.568 96.9317 159.661 97.0611C159.753 97.1904 159.803 97.3456 159.803 97.5048C159.803 97.664 159.753 97.8192 159.661 97.9486C159.568 98.0779 159.437 98.1749 159.286 98.2259L126.588 117.113C126.198 117.307 125.768 117.405 125.333 117.399C124.898 117.394 124.47 117.286 124.085 117.083Z",
    fill: "#455A64"
  })), _path255 || (_path255 = /*#__PURE__*/React.createElement("path", {
    d: "M91.377 87.7206L124.085 68.843C124.431 68.6519 124.833 68.5903 125.22 68.6692C125.608 68.7481 125.954 68.9624 126.198 69.2737L136.212 82.7633C136.506 83.1561 136.842 83.5154 137.214 83.8349C137.214 83.8349 102.012 104.175 102.002 104.165C101.635 103.84 101.3 103.481 101.001 103.093L90.9864 89.6033C90.8723 89.4597 90.7912 89.2927 90.7488 89.1142C90.7063 88.9357 90.7037 88.7501 90.7409 88.5705C90.7782 88.3909 90.8545 88.2217 90.9644 88.0748C91.0743 87.9279 91.2151 87.807 91.377 87.7206Z",
    fill: "#37474F"
  })), _path256 || (_path256 = /*#__PURE__*/React.createElement("path", {
    d: "M151.354 97.0843C150.899 96.8568 150.396 96.7384 149.887 96.7384C149.378 96.7384 148.876 96.8568 148.42 97.0843C148.242 97.1431 148.087 97.2566 147.977 97.4085C147.868 97.5604 147.809 97.7431 147.809 97.9305C147.809 98.1179 147.868 98.3006 147.977 98.4525C148.087 98.6044 148.242 98.7179 148.42 98.7767C148.874 99.0088 149.377 99.1298 149.887 99.1298C150.397 99.1298 150.9 99.0088 151.354 98.7767C151.532 98.7179 151.687 98.6044 151.797 98.4525C151.907 98.3006 151.966 98.1179 151.966 97.9305C151.966 97.7431 151.907 97.5604 151.797 97.4085C151.687 97.2566 151.532 97.1431 151.354 97.0843Z",
    fill: "url(#paint126_linear_515_48900)"
  })), _path257 || (_path257 = /*#__PURE__*/React.createElement("path", {
    d: "M145.485 100.479C145.031 100.247 144.528 100.126 144.018 100.126C143.508 100.126 143.005 100.247 142.551 100.479C142.373 100.538 142.218 100.652 142.108 100.804C141.999 100.955 141.939 101.138 141.939 101.326C141.939 101.513 141.999 101.696 142.108 101.848C142.218 101.999 142.373 102.113 142.551 102.172C143.007 102.399 143.509 102.518 144.018 102.518C144.527 102.518 145.03 102.399 145.485 102.172C145.663 102.113 145.818 101.999 145.928 101.848C146.038 101.696 146.097 101.513 146.097 101.326C146.097 101.138 146.038 100.955 145.928 100.804C145.818 100.652 145.663 100.538 145.485 100.479Z",
    fill: "url(#paint127_linear_515_48900)"
  })), _path258 || (_path258 = /*#__PURE__*/React.createElement("path", {
    d: "M139.616 103.834C139.162 103.602 138.659 103.481 138.149 103.481C137.639 103.481 137.136 103.602 136.682 103.834C136.504 103.893 136.349 104.006 136.239 104.158C136.129 104.31 136.07 104.493 136.07 104.68C136.07 104.868 136.129 105.05 136.239 105.202C136.349 105.354 136.504 105.468 136.682 105.527C137.136 105.759 137.639 105.88 138.149 105.88C138.659 105.88 139.162 105.759 139.616 105.527C139.794 105.468 139.949 105.354 140.059 105.202C140.168 105.05 140.228 104.868 140.228 104.68C140.228 104.493 140.168 104.31 140.059 104.158C139.949 104.006 139.794 103.893 139.616 103.834Z",
    fill: "#263238"
  })), _path259 || (_path259 = /*#__PURE__*/React.createElement("path", {
    d: "M133.749 107.249C133.295 107.017 132.792 106.896 132.282 106.896C131.772 106.896 131.269 107.017 130.815 107.249C130.637 107.308 130.482 107.421 130.372 107.573C130.262 107.725 130.203 107.908 130.203 108.095C130.203 108.283 130.262 108.465 130.372 108.617C130.482 108.769 130.637 108.883 130.815 108.942C131.269 109.174 131.772 109.295 132.282 109.295C132.792 109.295 133.295 109.174 133.749 108.942C133.927 108.883 134.082 108.769 134.191 108.617C134.301 108.465 134.36 108.283 134.36 108.095C134.36 107.908 134.301 107.725 134.191 107.573C134.082 107.421 133.927 107.308 133.749 107.249Z",
    fill: "#263238"
  })), _path260 || (_path260 = /*#__PURE__*/React.createElement("path", {
    d: "M146.96 94.5506C146.506 94.3185 146.003 94.1975 145.493 94.1975C144.983 94.1975 144.48 94.3185 144.026 94.5506C143.848 94.6094 143.693 94.7229 143.583 94.8748C143.473 95.0267 143.414 95.2094 143.414 95.3968C143.414 95.5843 143.473 95.7669 143.583 95.9188C143.693 96.0708 143.848 96.1842 144.026 96.2431C144.481 96.4705 144.983 96.5889 145.493 96.5889C146.002 96.5889 146.504 96.4705 146.96 96.2431C147.138 96.1842 147.293 96.0708 147.402 95.9188C147.512 95.7669 147.571 95.5843 147.571 95.3968C147.571 95.2094 147.512 95.0267 147.402 94.8748C147.293 94.7229 147.138 94.6094 146.96 94.5506Z",
    fill: "url(#paint128_linear_515_48900)"
  })), _path261 || (_path261 = /*#__PURE__*/React.createElement("path", {
    d: "M141.089 97.9356C140.634 97.7035 140.132 97.5825 139.622 97.5825C139.112 97.5825 138.609 97.7035 138.154 97.9356C137.976 97.9944 137.822 98.1079 137.712 98.2598C137.602 98.4117 137.543 98.5944 137.543 98.7818C137.543 98.9693 137.602 99.1519 137.712 99.3039C137.822 99.4558 137.976 99.5692 138.154 99.6281C138.609 99.8601 139.112 99.9812 139.622 99.9812C140.132 99.9812 140.634 99.8601 141.089 99.6281C141.267 99.5692 141.422 99.4558 141.531 99.3039C141.641 99.1519 141.7 98.9693 141.7 98.7818C141.7 98.5944 141.641 98.4117 141.531 98.2598C141.422 98.1079 141.267 97.9944 141.089 97.9356Z",
    fill: "#263238"
  })), _path262 || (_path262 = /*#__PURE__*/React.createElement("path", {
    d: "M133.747 103.373C134.892 103.373 135.82 102.835 135.82 102.172C135.82 101.508 134.892 100.97 133.747 100.97C132.602 100.97 131.674 101.508 131.674 102.172C131.674 102.835 132.602 103.373 133.747 103.373Z",
    fill: "url(#paint129_linear_515_48900)"
  })), _path263 || (_path263 = /*#__PURE__*/React.createElement("path", {
    d: "M129.352 104.705C128.896 104.478 128.394 104.36 127.885 104.36C127.375 104.36 126.873 104.478 126.418 104.705C126.241 104.767 126.088 104.882 125.979 105.034C125.871 105.187 125.812 105.369 125.812 105.557C125.812 105.744 125.871 105.926 125.979 106.079C126.088 106.231 126.241 106.346 126.418 106.408C126.873 106.635 127.375 106.754 127.885 106.754C128.394 106.754 128.896 106.635 129.352 106.408C129.529 106.346 129.682 106.231 129.79 106.079C129.899 105.926 129.957 105.744 129.957 105.557C129.957 105.369 129.899 105.187 129.79 105.034C129.682 104.882 129.529 104.767 129.352 104.705Z",
    fill: "#263238"
  })), _path264 || (_path264 = /*#__PURE__*/React.createElement("path", {
    d: "M142.552 92.0069C142.097 91.7748 141.595 91.6538 141.084 91.6538C140.574 91.6538 140.072 91.7748 139.617 92.0069C139.439 92.0657 139.285 92.1792 139.175 92.3311C139.065 92.483 139.006 92.6657 139.006 92.8531C139.006 93.0406 139.065 93.2232 139.175 93.3751C139.285 93.5271 139.439 93.6405 139.617 93.6994C140.072 93.9314 140.574 94.0524 141.084 94.0524C141.595 94.0524 142.097 93.9314 142.552 93.6994C142.73 93.6405 142.884 93.5271 142.994 93.3751C143.104 93.2232 143.163 93.0406 143.163 92.8531C143.163 92.6657 143.104 92.483 142.994 92.3311C142.884 92.1792 142.73 92.0657 142.552 92.0069Z",
    fill: "#263238"
  })), _path265 || (_path265 = /*#__PURE__*/React.createElement("path", {
    d: "M136.682 95.3919C136.228 95.1598 135.725 95.0388 135.215 95.0388C134.705 95.0388 134.202 95.1598 133.748 95.3919C133.57 95.4507 133.415 95.5642 133.306 95.7161C133.196 95.868 133.137 96.0507 133.137 96.2381C133.137 96.4256 133.196 96.6082 133.306 96.7602C133.415 96.9121 133.57 97.0255 133.748 97.0844C134.202 97.3164 134.705 97.4374 135.215 97.4374C135.725 97.4374 136.228 97.3164 136.682 97.0844C136.86 97.0255 137.015 96.9121 137.125 96.7602C137.235 96.6082 137.294 96.4256 137.294 96.2381C137.294 96.0507 137.235 95.868 137.125 95.7161C137.015 95.5642 136.86 95.4507 136.682 95.3919Z",
    fill: "url(#paint130_linear_515_48900)"
  })), _path266 || (_path266 = /*#__PURE__*/React.createElement("path", {
    d: "M130.854 98.8268C130.398 98.5994 129.896 98.481 129.387 98.481C128.877 98.481 128.375 98.5994 127.92 98.8268C127.743 98.8883 127.59 99.0033 127.481 99.1559C127.373 99.3084 127.314 99.4909 127.314 99.6781C127.314 99.8652 127.373 100.048 127.481 100.2C127.59 100.353 127.743 100.468 127.92 100.529C128.375 100.757 128.877 100.875 129.387 100.875C129.896 100.875 130.398 100.757 130.854 100.529C131.031 100.468 131.184 100.353 131.292 100.2C131.401 100.048 131.459 99.8652 131.459 99.6781C131.459 99.4909 131.401 99.3084 131.292 99.1559C131.184 99.0033 131.031 98.8883 130.854 98.8268Z",
    fill: "#263238"
  })), _path267 || (_path267 = /*#__PURE__*/React.createElement("path", {
    d: "M127.85 110.574C127.396 110.342 126.893 110.221 126.383 110.221C125.873 110.221 125.37 110.342 124.916 110.574C124.738 110.633 124.583 110.746 124.474 110.898C124.364 111.05 124.305 111.233 124.305 111.42C124.305 111.608 124.364 111.79 124.474 111.942C124.583 112.094 124.738 112.208 124.916 112.267C125.37 112.499 125.873 112.62 126.383 112.62C126.893 112.62 127.396 112.499 127.85 112.267C128.028 112.208 128.183 112.094 128.293 111.942C128.403 111.79 128.462 111.608 128.462 111.42C128.462 111.233 128.403 111.05 128.293 110.898C128.183 110.746 128.028 110.633 127.85 110.574Z",
    fill: "url(#paint131_linear_515_48900)"
  })), _path268 || (_path268 = /*#__PURE__*/React.createElement("path", {
    d: "M123.452 108.03C122.998 107.798 122.495 107.677 121.985 107.677C121.475 107.677 120.972 107.798 120.518 108.03C120.34 108.089 120.185 108.203 120.075 108.354C119.965 108.506 119.906 108.689 119.906 108.876C119.906 109.064 119.965 109.247 120.075 109.398C120.185 109.55 120.34 109.664 120.518 109.723C120.972 109.955 121.475 110.076 121.985 110.076C122.495 110.076 122.998 109.955 123.452 109.723C123.63 109.664 123.785 109.55 123.895 109.398C124.004 109.247 124.063 109.064 124.063 108.876C124.063 108.689 124.004 108.506 123.895 108.354C123.785 108.203 123.63 108.089 123.452 108.03Z",
    fill: "#263238"
  })), _path269 || (_path269 = /*#__PURE__*/React.createElement("path", {
    d: "M124.945 102.172C124.491 101.94 123.988 101.819 123.478 101.819C122.968 101.819 122.465 101.94 122.011 102.172C121.838 102.235 121.688 102.35 121.582 102.502C121.477 102.653 121.42 102.833 121.42 103.018C121.42 103.203 121.477 103.383 121.582 103.534C121.688 103.685 121.838 103.801 122.011 103.864C122.465 104.096 122.968 104.217 123.478 104.217C123.988 104.217 124.491 104.096 124.945 103.864C125.123 103.805 125.278 103.692 125.388 103.54C125.498 103.388 125.557 103.205 125.557 103.018C125.557 102.83 125.498 102.648 125.388 102.496C125.278 102.344 125.123 102.231 124.945 102.172Z",
    fill: "#263238"
  })), _path270 || (_path270 = /*#__PURE__*/React.createElement("path", {
    d: "M138.155 89.4632C137.699 89.2357 137.197 89.1173 136.687 89.1173C136.178 89.1173 135.676 89.2357 135.22 89.4632C135.044 89.5247 134.89 89.6397 134.782 89.7922C134.673 89.9447 134.615 90.1272 134.615 90.3144C134.615 90.5015 134.673 90.684 134.782 90.8366C134.89 90.9891 135.044 91.1041 135.22 91.1656C135.676 91.3931 136.178 91.5115 136.687 91.5115C137.197 91.5115 137.699 91.3931 138.155 91.1656C138.331 91.1041 138.485 90.9891 138.593 90.8366C138.701 90.684 138.76 90.5015 138.76 90.3144C138.76 90.1272 138.701 89.9447 138.593 89.7922C138.485 89.6397 138.331 89.5247 138.155 89.4632Z",
    fill: "url(#paint132_linear_515_48900)"
  })), _path271 || (_path271 = /*#__PURE__*/React.createElement("path", {
    d: "M132.288 92.8179C131.834 92.5859 131.331 92.4648 130.821 92.4648C130.311 92.4648 129.808 92.5859 129.354 92.8179C129.176 92.8768 129.021 92.9902 128.911 93.1421C128.801 93.2941 128.742 93.4767 128.742 93.6642C128.742 93.8516 128.801 94.0343 128.911 94.1862C129.021 94.3381 129.176 94.4516 129.354 94.5104C129.808 94.7425 130.311 94.8635 130.821 94.8635C131.331 94.8635 131.834 94.7425 132.288 94.5104C132.466 94.4516 132.621 94.3381 132.731 94.1862C132.84 94.0343 132.899 93.8516 132.899 93.6642C132.899 93.4767 132.84 93.2941 132.731 93.1421C132.621 92.9902 132.466 92.8768 132.288 92.8179Z",
    fill: "#263238"
  })), _path272 || (_path272 = /*#__PURE__*/React.createElement("path", {
    d: "M126.417 96.243C125.963 96.011 125.46 95.89 124.95 95.89C124.44 95.89 123.937 96.011 123.483 96.243C123.305 96.3019 123.15 96.4153 123.04 96.5673C122.93 96.7192 122.871 96.9018 122.871 97.0893C122.871 97.2767 122.93 97.4594 123.04 97.6113C123.15 97.7632 123.305 97.8767 123.483 97.9355C123.937 98.1676 124.44 98.2886 124.95 98.2886C125.46 98.2886 125.963 98.1676 126.417 97.9355C126.595 97.8767 126.75 97.7632 126.859 97.6113C126.969 97.4594 127.028 97.2767 127.028 97.0893C127.028 96.9018 126.969 96.7192 126.859 96.5673C126.75 96.4153 126.595 96.3019 126.417 96.243Z",
    fill: "url(#paint133_linear_515_48900)"
  })), _path273 || (_path273 = /*#__PURE__*/React.createElement("path", {
    d: "M119.089 101.681C120.234 101.681 121.162 101.143 121.162 100.479C121.162 99.8154 120.234 99.2773 119.089 99.2773C117.944 99.2773 117.016 99.8154 117.016 100.479C117.016 101.143 117.944 101.681 119.089 101.681Z",
    fill: "#263238"
  })), _path274 || (_path274 = /*#__PURE__*/React.createElement("path", {
    d: "M119.047 105.486C118.592 105.259 118.089 105.141 117.58 105.141C117.071 105.141 116.569 105.259 116.113 105.486C115.936 105.548 115.783 105.663 115.674 105.816C115.566 105.968 115.508 106.151 115.508 106.338C115.508 106.525 115.566 106.707 115.674 106.86C115.783 107.012 115.936 107.127 116.113 107.189C116.569 107.416 117.071 107.535 117.58 107.535C118.089 107.535 118.592 107.416 119.047 107.189C119.224 107.127 119.377 107.012 119.486 106.86C119.594 106.707 119.652 106.525 119.652 106.338C119.652 106.151 119.594 105.968 119.486 105.816C119.377 105.663 119.224 105.548 119.047 105.486Z",
    fill: "url(#paint134_linear_515_48900)"
  })), _path275 || (_path275 = /*#__PURE__*/React.createElement("path", {
    d: "M114.649 102.953C114.195 102.721 113.692 102.6 113.182 102.6C112.672 102.6 112.169 102.721 111.715 102.953C111.537 103.012 111.382 103.125 111.272 103.277C111.163 103.429 111.104 103.612 111.104 103.799C111.104 103.986 111.163 104.169 111.272 104.321C111.382 104.473 111.537 104.586 111.715 104.645C112.169 104.877 112.672 104.998 113.182 104.998C113.692 104.998 114.195 104.877 114.649 104.645C114.827 104.586 114.982 104.473 115.092 104.321C115.202 104.169 115.261 103.986 115.261 103.799C115.261 103.612 115.202 103.429 115.092 103.277C114.982 103.125 114.827 103.012 114.649 102.953Z",
    fill: "#263238"
  })), _path276 || (_path276 = /*#__PURE__*/React.createElement("path", {
    d: "M125.268 117.384V121.86C125.726 121.881 126.182 121.781 126.59 121.57L159.287 102.682C159.654 102.449 159.959 102.13 160.177 101.754C160.395 101.377 160.519 100.954 160.539 100.519V98.8869C160.52 98.5018 160.422 98.1247 160.249 97.7799C160.077 97.435 159.835 97.1299 159.538 96.884C159.998 97.2846 159.918 97.8253 159.307 98.1658L126.61 117.053C126.2 117.281 125.736 117.396 125.268 117.384Z",
    fill: "#37474F"
  })), _path277 || (_path277 = /*#__PURE__*/React.createElement("path", {
    d: "M131.857 82.2026C131.696 81.9926 131.464 81.8476 131.205 81.7943C130.945 81.741 130.676 81.7828 130.445 81.9121L101.983 98.3461C101.876 98.4043 101.783 98.4852 101.711 98.5833C101.639 98.6813 101.589 98.794 101.565 98.9134C101.541 99.0328 101.544 99.1561 101.573 99.2743C101.602 99.3926 101.656 99.5031 101.733 99.5979C101.895 99.8038 102.124 99.9458 102.381 99.9989C102.637 100.052 102.904 100.013 103.135 99.8884L131.596 83.4544C131.703 83.3959 131.795 83.315 131.868 83.2173C131.94 83.1196 131.99 83.0074 132.015 82.8884C132.04 82.7695 132.038 82.6466 132.011 82.5282C131.984 82.4098 131.931 82.2987 131.857 82.2026Z",
    fill: "#263238"
  })), _path278 || (_path278 = /*#__PURE__*/React.createElement("path", {
    d: "M131.856 82.2026C131.695 81.9926 131.464 81.8476 131.204 81.7943C130.945 81.741 130.675 81.7828 130.444 81.9121L109.283 94.13L110.465 95.7123L131.626 83.4945C131.736 83.4341 131.832 83.3497 131.905 83.2474C131.979 83.1452 132.029 83.0278 132.051 82.9038C132.073 82.7798 132.067 82.6524 132.033 82.531C132 82.4097 131.939 82.2974 131.856 82.2026Z",
    fill: "url(#paint135_linear_515_48900)"
  })), _path279 || (_path279 = /*#__PURE__*/React.createElement("path", {
    d: "M129.533 79.048C129.372 78.838 129.14 78.6931 128.881 78.6398C128.622 78.5864 128.352 78.6283 128.121 78.7576L99.6592 95.1816C99.552 95.2408 99.4589 95.3227 99.3866 95.4216C99.3143 95.5206 99.2645 95.6341 99.2407 95.7543C99.2168 95.8745 99.2195 95.9984 99.2486 96.1174C99.2776 96.2365 99.3323 96.3477 99.4089 96.4434C99.5709 96.6493 99.8004 96.7913 100.057 96.8444C100.313 96.8975 100.58 96.8584 100.811 96.7338L129.272 80.2999C129.379 80.2414 129.471 80.1605 129.544 80.0628C129.616 79.9651 129.666 79.8529 129.691 79.7339C129.716 79.615 129.714 79.4921 129.687 79.3736C129.66 79.2552 129.607 79.1442 129.533 79.048Z",
    fill: "#263238"
  })), _path280 || (_path280 = /*#__PURE__*/React.createElement("path", {
    d: "M129.532 79.048C129.37 78.8397 129.139 78.6953 128.881 78.6404C128.622 78.5854 128.353 78.6234 128.12 78.7475L121.02 82.8034L122.201 84.3858L129.272 80.3098C129.38 80.2515 129.474 80.1702 129.547 80.0717C129.62 79.9732 129.671 79.8598 129.696 79.7396C129.721 79.6193 129.719 79.4951 129.691 79.3756C129.662 79.2561 129.608 79.1443 129.532 79.048Z",
    fill: "url(#paint136_linear_515_48900)"
  })), _path281 || (_path281 = /*#__PURE__*/React.createElement("path", {
    d: "M127.18 75.8833C127.018 75.6775 126.788 75.5355 126.532 75.4823C126.275 75.4292 126.008 75.4684 125.778 75.5929L97.3163 92.0269C97.2085 92.0841 97.1147 92.1644 97.0414 92.262C96.9681 92.3597 96.9173 92.4722 96.8924 92.5917C96.8676 92.7112 96.8693 92.8347 96.8976 92.9534C96.9258 93.0722 96.9799 93.1832 97.0559 93.2787C97.2154 93.4879 97.4451 93.6325 97.7027 93.6859C97.9603 93.7393 98.2285 93.6978 98.458 93.5691L126.919 77.1452C127.026 77.0856 127.119 77.0038 127.191 76.9052C127.263 76.8066 127.314 76.6936 127.338 76.5738C127.363 76.4541 127.362 76.3305 127.334 76.2113C127.307 76.0922 127.254 75.9803 127.18 75.8833Z",
    fill: "#263238"
  })), _path282 || (_path282 = /*#__PURE__*/React.createElement("path", {
    d: "M127.179 75.8833C127.014 75.6783 126.783 75.5371 126.525 75.4841C126.267 75.4311 125.999 75.4696 125.767 75.5929L110.945 84.1253L112.127 85.7076L126.949 77.1852C127.059 77.1237 127.155 77.0383 127.229 76.9352C127.302 76.8321 127.352 76.7139 127.374 76.5891C127.396 76.4644 127.39 76.3363 127.356 76.2142C127.323 76.0921 127.262 75.979 127.179 75.8833Z",
    fill: "url(#paint137_linear_515_48900)"
  })), _path283 || (_path283 = /*#__PURE__*/React.createElement("path", {
    d: "M124.845 72.7287C124.686 72.5195 124.456 72.3749 124.198 72.3216C123.941 72.2682 123.673 72.3097 123.443 72.4383L94.9315 88.8122C94.8237 88.8695 94.7299 88.9497 94.6566 89.0474C94.5834 89.145 94.5325 89.2575 94.5077 89.377C94.4828 89.4965 94.4846 89.62 94.5128 89.7388C94.5411 89.8575 94.5951 89.9685 94.6712 90.064C94.8332 90.2699 95.0627 90.4119 95.3192 90.465C95.5757 90.5182 95.8427 90.479 96.0732 90.3545L124.535 73.9205C124.636 73.8656 124.726 73.7904 124.797 73.6995C124.868 73.6086 124.92 73.504 124.949 73.3922C124.978 73.2804 124.984 73.1638 124.966 73.0496C124.948 72.9355 124.907 72.8262 124.845 72.7287Z",
    fill: "#263238"
  })), _path284 || (_path284 = /*#__PURE__*/React.createElement("path", {
    d: "M124.845 72.7287C124.686 72.5195 124.456 72.3749 124.198 72.3215C123.941 72.2682 123.673 72.3096 123.443 72.4383L97.6055 87.35L98.7872 88.9323L124.615 74.0206C124.725 73.9602 124.821 73.8758 124.895 73.7736C124.968 73.6714 125.018 73.5539 125.04 73.4299C125.062 73.3059 125.056 73.1785 125.022 73.0572C124.989 72.9358 124.928 72.8236 124.845 72.7287Z",
    fill: "url(#paint138_linear_515_48900)"
  })), _path285 || (_path285 = /*#__PURE__*/React.createElement("path", {
    d: "M246.723 329.163C246.691 329.223 246.647 329.275 246.594 329.317C246.541 329.36 246.479 329.391 246.414 329.408C246.348 329.426 246.28 329.431 246.212 329.421C246.145 329.411 246.08 329.388 246.022 329.353L206.835 306.72C206.227 306.423 205.559 306.269 204.882 306.269C204.206 306.269 203.538 306.423 202.93 306.72L124.555 351.996C123.803 352.403 122.957 352.607 122.102 352.587C121.243 352.604 120.395 352.401 119.638 351.996L74.3821 325.868C74.036 325.733 73.7386 325.497 73.5289 325.191C73.3192 324.884 73.207 324.522 73.207 324.15C73.207 323.779 73.3192 323.416 73.5289 323.11C73.7386 322.803 74.036 322.567 74.3821 322.433L92.9792 311.707C93.0148 311.689 93.0543 311.679 93.0944 311.679C93.1345 311.679 93.174 311.689 93.2096 311.707C93.3157 311.774 93.4045 311.866 93.4689 311.974C93.5333 312.081 93.5714 312.203 93.5801 312.328C93.5847 312.4 93.5634 312.471 93.52 312.528C93.5011 312.551 93.477 312.568 93.4499 312.579H93.3798L74.8929 323.324C74.7213 323.393 74.5702 323.504 74.4544 323.648C74.3386 323.792 74.262 323.963 74.2319 324.145C74.2319 324.436 74.4723 324.736 74.8929 324.987L120.149 351.115C120.754 351.416 121.421 351.573 122.097 351.573C122.773 351.573 123.44 351.416 124.045 351.115L202.419 305.869C203.181 305.479 204.026 305.275 204.882 305.275C205.739 305.275 206.583 305.479 207.346 305.869L246.533 328.492C246.646 328.557 246.729 328.663 246.764 328.789C246.8 328.914 246.785 329.048 246.723 329.163Z",
    fill: "url(#paint139_linear_515_48900)"
  })), _path286 || (_path286 = /*#__PURE__*/React.createElement("path", {
    d: "M238.441 333.96C238.376 334.077 238.266 334.165 238.137 334.202C238.007 334.24 237.868 334.224 237.75 334.16L206.835 316.304C206.227 316.007 205.559 315.853 204.882 315.853C204.205 315.853 203.538 316.007 202.929 316.304L124.555 361.56C123.803 361.97 122.958 362.178 122.101 362.161C121.242 362.175 120.394 361.968 119.638 361.56L57.8177 325.868C57.4716 325.733 57.1742 325.497 56.9645 325.191C56.7548 324.884 56.6426 324.522 56.6426 324.15C56.6426 323.779 56.7548 323.416 56.9645 323.11C57.1742 322.803 57.4716 322.567 57.8177 322.433L84.6768 306.93C84.7159 306.912 84.7587 306.902 84.802 306.902C84.8453 306.902 84.8881 306.912 84.9272 306.93C85.0307 306.998 85.1165 307.09 85.1774 307.198C85.2384 307.306 85.2728 307.427 85.2777 307.551C85.2806 307.594 85.274 307.637 85.2584 307.676C85.2428 307.716 85.2186 307.752 85.1876 307.781L58.3284 323.324C58.1584 323.395 58.0088 323.507 57.8933 323.651C57.7779 323.794 57.7002 323.964 57.6675 324.145C57.6675 324.436 57.9178 324.736 58.3284 324.987L120.149 360.669C120.754 360.97 121.42 361.127 122.096 361.127C122.772 361.127 123.439 360.97 124.044 360.669L202.419 315.423C203.181 315.032 204.025 314.829 204.882 314.829C205.739 314.829 206.583 315.032 207.346 315.423L238.261 333.269C238.318 333.302 238.369 333.346 238.409 333.399C238.45 333.452 238.479 333.512 238.496 333.576C238.513 333.641 238.516 333.708 238.507 333.774C238.498 333.839 238.475 333.903 238.441 333.96Z",
    fill: "url(#paint140_linear_515_48900)"
  })), _path287 || (_path287 = /*#__PURE__*/React.createElement("path", {
    d: "M230.159 338.747C230.092 338.863 229.981 338.948 229.852 338.983C229.723 339.019 229.585 339.002 229.468 338.937L206.835 325.868C206.228 325.566 205.559 325.409 204.882 325.409C204.204 325.409 203.536 325.566 202.929 325.868L124.555 371.114C123.803 371.524 122.957 371.732 122.101 371.715C121.242 371.729 120.394 371.522 119.638 371.114L41.2633 325.868C40.9321 325.715 40.6488 325.475 40.4441 325.173C40.2394 324.872 40.121 324.52 40.1016 324.155C40.1272 323.792 40.2492 323.441 40.4551 323.14C40.6611 322.839 40.9435 322.599 41.2733 322.443L76.4145 302.253C76.4377 302.225 76.4692 302.204 76.5047 302.193C76.5391 302.177 76.5767 302.169 76.6148 302.169C76.6529 302.169 76.6905 302.177 76.725 302.193C76.8305 302.263 76.9182 302.356 76.9809 302.466C77.0435 302.575 77.0794 302.698 77.0855 302.824C77.0909 302.867 77.0844 302.91 77.0667 302.949C77.049 302.988 77.0208 303.021 76.9853 303.045L41.774 323.324C41.3534 323.565 41.1231 323.865 41.1231 324.145C41.1231 324.426 41.3534 324.736 41.774 324.987L120.148 370.223C120.753 370.524 121.42 370.681 122.096 370.681C122.772 370.681 123.439 370.524 124.044 370.223L202.418 324.977C203.181 324.586 204.025 324.383 204.882 324.383C205.738 324.383 206.583 324.586 207.345 324.977L229.978 337.996C230.042 338.03 230.098 338.078 230.142 338.136C230.187 338.194 230.218 338.26 230.235 338.331C230.252 338.402 230.254 338.475 230.241 338.547C230.228 338.619 230.2 338.687 230.159 338.747Z",
    fill: "url(#paint141_linear_515_48900)"
  })), _path288 || (_path288 = /*#__PURE__*/React.createElement("path", {
    d: "M221.887 343.524C221.819 343.64 221.709 343.725 221.58 343.76C221.451 343.796 221.313 343.779 221.196 343.714L206.835 335.432C206.228 335.13 205.559 334.973 204.882 334.973C204.204 334.973 203.536 335.13 202.929 335.432L124.555 380.678C123.802 381.085 122.957 381.291 122.101 381.279C121.242 381.288 120.395 381.081 119.637 380.678L24.699 325.868C24.3568 325.729 24.0639 325.492 23.8575 325.186C23.6512 324.88 23.541 324.519 23.541 324.15C23.541 323.781 23.6512 323.421 23.8575 323.115C24.0639 322.809 24.3568 322.571 24.699 322.433L68.0622 297.396C68.0704 297.382 68.082 297.37 68.096 297.361C68.11 297.353 68.1259 297.347 68.1423 297.346C68.1773 297.326 68.2171 297.315 68.2575 297.315C68.2979 297.315 68.3376 297.326 68.3727 297.346C68.4811 297.411 68.5717 297.502 68.6364 297.61C68.7011 297.718 68.7378 297.841 68.7432 297.967C68.7602 298.029 68.7602 298.095 68.7432 298.157H68.6631L25.3099 323.194C25.1407 323.264 24.9922 323.377 24.8783 323.52C24.7644 323.664 24.6889 323.834 24.6589 324.015C24.6589 324.306 24.8993 324.606 25.3099 324.856L120.248 379.666C120.855 379.963 121.521 380.117 122.196 380.117C122.871 380.117 123.537 379.963 124.144 379.666L202.518 334.41C203.281 334.02 204.125 333.817 204.982 333.817C205.839 333.817 206.683 334.02 207.445 334.41L221.806 342.702C221.876 342.743 221.934 342.8 221.977 342.868C222.021 342.936 222.047 343.013 222.055 343.093C222.063 343.173 222.052 343.253 222.022 343.328C221.993 343.403 221.947 343.47 221.887 343.524Z",
    fill: "url(#paint142_linear_515_48900)"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    d: "M246.723 329.163C246.691 329.223 246.647 329.275 246.594 329.317C246.541 329.36 246.479 329.391 246.414 329.408C246.348 329.426 246.28 329.431 246.212 329.421C246.145 329.411 246.08 329.388 246.022 329.353L206.835 306.72C206.227 306.423 205.559 306.269 204.882 306.269C204.206 306.269 203.538 306.423 202.93 306.72L124.555 351.996C123.803 352.403 122.957 352.607 122.102 352.587C121.243 352.604 120.395 352.401 119.638 351.996L74.3821 325.868C74.036 325.733 73.7386 325.497 73.5289 325.191C73.3192 324.884 73.207 324.522 73.207 324.15C73.207 323.779 73.3192 323.416 73.5289 323.11C73.7386 322.803 74.036 322.567 74.3821 322.433L92.9792 311.707C93.0148 311.689 93.0543 311.679 93.0944 311.679C93.1345 311.679 93.174 311.689 93.2096 311.707C93.3157 311.774 93.4045 311.866 93.4689 311.974C93.5333 312.081 93.5714 312.203 93.5801 312.328C93.5847 312.4 93.5634 312.471 93.52 312.528C93.5011 312.551 93.477 312.568 93.4499 312.579H93.3798L74.8929 323.324C74.7213 323.393 74.5702 323.504 74.4544 323.648C74.3386 323.792 74.262 323.963 74.2319 324.145C74.2319 324.436 74.4723 324.736 74.8929 324.987L120.149 351.115C120.754 351.416 121.421 351.573 122.097 351.573C122.773 351.573 123.44 351.416 124.045 351.115L202.419 305.869C203.181 305.479 204.026 305.275 204.882 305.275C205.739 305.275 206.583 305.479 207.346 305.869L246.533 328.492C246.646 328.557 246.729 328.663 246.764 328.789C246.8 328.914 246.785 329.048 246.723 329.163Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.441 333.96C238.376 334.077 238.266 334.165 238.137 334.202C238.007 334.24 237.868 334.224 237.75 334.16L206.835 316.304C206.227 316.007 205.559 315.853 204.882 315.853C204.205 315.853 203.538 316.007 202.929 316.304L124.555 361.56C123.803 361.97 122.958 362.178 122.101 362.161C121.242 362.175 120.394 361.968 119.638 361.56L57.8177 325.868C57.4716 325.733 57.1742 325.497 56.9645 325.191C56.7548 324.884 56.6426 324.522 56.6426 324.15C56.6426 323.779 56.7548 323.416 56.9645 323.11C57.1742 322.803 57.4716 322.567 57.8177 322.433L84.6768 306.93C84.7159 306.912 84.7587 306.902 84.802 306.902C84.8453 306.902 84.8881 306.912 84.9272 306.93C85.0307 306.998 85.1165 307.09 85.1774 307.198C85.2384 307.306 85.2728 307.427 85.2777 307.551C85.2806 307.594 85.274 307.637 85.2584 307.676C85.2428 307.716 85.2186 307.752 85.1876 307.781L58.3284 323.324C58.1584 323.395 58.0088 323.507 57.8933 323.651C57.7779 323.794 57.7002 323.964 57.6675 324.145C57.6675 324.436 57.9178 324.736 58.3284 324.987L120.149 360.669C120.754 360.97 121.42 361.127 122.096 361.127C122.772 361.127 123.439 360.97 124.044 360.669L202.419 315.423C203.181 315.032 204.025 314.829 204.882 314.829C205.739 314.829 206.583 315.032 207.346 315.423L238.261 333.269C238.318 333.302 238.369 333.346 238.409 333.399C238.45 333.452 238.479 333.512 238.496 333.576C238.513 333.641 238.516 333.708 238.507 333.774C238.498 333.839 238.475 333.903 238.441 333.96Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.159 338.747C230.092 338.863 229.981 338.948 229.852 338.983C229.723 339.019 229.585 339.002 229.468 338.937L206.835 325.868C206.228 325.566 205.559 325.409 204.882 325.409C204.204 325.409 203.536 325.566 202.929 325.868L124.555 371.114C123.803 371.524 122.957 371.732 122.101 371.715C121.242 371.729 120.394 371.522 119.638 371.114L41.2633 325.868C40.9321 325.715 40.6488 325.475 40.4441 325.173C40.2394 324.872 40.121 324.52 40.1016 324.155C40.1272 323.792 40.2492 323.441 40.4551 323.14C40.6611 322.839 40.9435 322.599 41.2733 322.443L76.4145 302.253C76.4377 302.225 76.4692 302.204 76.5047 302.193C76.5391 302.177 76.5767 302.169 76.6148 302.169C76.6529 302.169 76.6905 302.177 76.725 302.193C76.8305 302.263 76.9182 302.356 76.9809 302.466C77.0435 302.575 77.0794 302.698 77.0855 302.824C77.0909 302.867 77.0844 302.91 77.0667 302.949C77.049 302.988 77.0208 303.021 76.9853 303.045L41.774 323.324C41.3534 323.565 41.1231 323.865 41.1231 324.145C41.1231 324.426 41.3534 324.736 41.774 324.987L120.148 370.223C120.753 370.524 121.42 370.681 122.096 370.681C122.772 370.681 123.439 370.524 124.044 370.223L202.418 324.977C203.181 324.586 204.025 324.383 204.882 324.383C205.738 324.383 206.583 324.586 207.345 324.977L229.978 337.996C230.042 338.03 230.098 338.078 230.142 338.136C230.187 338.194 230.218 338.26 230.235 338.331C230.252 338.402 230.254 338.475 230.241 338.547C230.228 338.619 230.2 338.687 230.159 338.747Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M221.887 343.524C221.819 343.64 221.709 343.725 221.58 343.76C221.451 343.796 221.313 343.779 221.196 343.714L206.835 335.432C206.228 335.13 205.559 334.973 204.882 334.973C204.204 334.973 203.536 335.13 202.929 335.432L124.555 380.678C123.802 381.085 122.957 381.291 122.101 381.279C121.242 381.288 120.395 381.081 119.637 380.678L24.699 325.868C24.3568 325.729 24.0639 325.492 23.8575 325.186C23.6512 324.88 23.541 324.519 23.541 324.15C23.541 323.781 23.6512 323.421 23.8575 323.115C24.0639 322.809 24.3568 322.571 24.699 322.433L68.0622 297.396C68.0704 297.382 68.082 297.37 68.096 297.361C68.11 297.353 68.1259 297.347 68.1423 297.346C68.1773 297.326 68.2171 297.315 68.2575 297.315C68.2979 297.315 68.3376 297.326 68.3727 297.346C68.4811 297.411 68.5717 297.502 68.6364 297.61C68.7011 297.718 68.7378 297.841 68.7432 297.967C68.7602 298.029 68.7602 298.095 68.7432 298.157H68.6631L25.3099 323.194C25.1407 323.264 24.9922 323.377 24.8783 323.52C24.7644 323.664 24.6889 323.834 24.6589 324.015C24.6589 324.306 24.8993 324.606 25.3099 324.856L120.248 379.666C120.855 379.963 121.521 380.117 122.196 380.117C122.871 380.117 123.537 379.963 124.144 379.666L202.518 334.41C203.281 334.02 204.125 333.817 204.982 333.817C205.839 333.817 206.683 334.02 207.445 334.41L221.806 342.702C221.876 342.743 221.934 342.8 221.977 342.868C222.021 342.936 222.047 343.013 222.055 343.093C222.063 343.173 222.052 343.253 222.022 343.328C221.993 343.403 221.947 343.47 221.887 343.524Z",
    fill: "black"
  }))), _path289 || (_path289 = /*#__PURE__*/React.createElement("path", {
    d: "M337.865 354.56L364.193 339.338C366.897 337.775 368.259 335.722 368.259 333.669C368.259 331.616 368.259 330.004 368.259 330.004L343.493 315.984C342.729 315.488 342.092 314.819 341.636 314.03C341.18 313.242 340.917 312.357 340.869 311.447V279L294.902 305.558V337.976C294.95 338.885 295.213 339.771 295.669 340.559C296.125 341.348 296.762 342.017 297.526 342.512L318.216 354.53C323.644 357.694 332.437 357.694 337.865 354.56Z",
    fill: "#263238"
  })), _path290 || (_path290 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M305.948 343.724V347.369L297.516 342.512C296.756 342.013 296.123 341.343 295.669 340.555C295.215 339.767 294.952 338.883 294.902 337.975V305.528L303.665 300.521C303.845 302.744 304.036 305.047 304.216 307.281L298.097 310.786V336.173C298.142 337.082 298.403 337.967 298.857 338.756C299.312 339.545 299.947 340.214 300.711 340.709L305.948 343.724Z",
    fill: "black"
  })), _path291 || (_path291 = /*#__PURE__*/React.createElement("path", {
    d: "M298.098 336.173C298.147 337.084 298.411 337.97 298.867 338.76C299.322 339.549 299.958 340.221 300.721 340.72L318.237 350.924C323.655 354.059 332.458 354.059 337.886 350.924L364.224 335.702C369.652 332.568 369.652 327.49 364.224 324.356L346.679 314.141C345.916 313.644 345.281 312.974 344.825 312.186C344.369 311.398 344.105 310.513 344.055 309.604V284.227L298.098 310.786V336.173Z",
    fill: "#37474F"
  })), _path292 || (_path292 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M352.006 317.205L346.679 314.141C345.916 313.644 345.281 312.974 344.825 312.186C344.369 311.398 344.105 310.513 344.055 309.604V284.227L298.098 310.786V336.173C298.147 337.084 298.411 337.97 298.867 338.76C299.322 339.549 299.958 340.221 300.721 340.72L305.959 343.724L352.006 317.205Z",
    fill: "black"
  })), _path293 || (_path293 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.15,
    d: "M368.27 330.004V333.669C368.27 335.722 366.908 337.765 364.194 339.338L337.866 354.55C334.984 356.095 331.762 356.897 328.492 356.883V353.198C331.762 353.212 334.984 352.41 337.866 350.864L364.194 335.682C366.908 334.17 368.27 332.067 368.27 330.004Z",
    fill: "black"
  })), _path294 || (_path294 = /*#__PURE__*/React.createElement("path", {
    d: "M224.258 371.154C225.25 371.637 226.343 371.878 227.446 371.859C228.549 371.84 229.632 371.561 230.607 371.044C253.21 358.025 385.834 281.433 408.407 268.394C409.359 267.77 410.151 266.931 410.72 265.945C411.289 264.959 411.618 263.853 411.681 262.716V107.089C411.721 105.971 411.455 104.864 410.913 103.886C410.371 102.908 409.573 102.095 408.605 101.536C407.636 100.978 406.533 100.693 405.415 100.713C404.297 100.733 403.206 101.057 402.258 101.651L224.458 204.301C223.505 204.926 222.711 205.766 222.143 206.754C221.574 207.742 221.245 208.85 221.184 209.989V365.616C221.225 366.716 221.526 367.79 222.06 368.752C222.594 369.714 223.347 370.537 224.258 371.154Z",
    fill: "#455A64"
  })), _path295 || (_path295 = /*#__PURE__*/React.createElement("path", {
    d: "M230.609 371.034L408.408 268.384C409.36 267.762 410.153 266.925 410.722 265.941C411.29 264.956 411.62 263.851 411.683 262.716V107.089C411.683 104.996 410.211 104.155 408.408 105.196L230.609 207.846C229.654 208.467 228.86 209.306 228.291 210.293C227.722 211.279 227.394 212.387 227.334 213.524V369.141C227.334 371.224 228.796 372.085 230.609 371.034Z",
    fill: "url(#paint143_linear_515_48900)"
  })), _path296 || (_path296 = /*#__PURE__*/React.createElement("path", {
    d: "M230.609 371.034L408.408 268.384C409.36 267.762 410.153 266.925 410.722 265.941C411.29 264.956 411.62 263.851 411.683 262.716V107.089C411.683 104.996 410.211 104.155 408.408 105.196L230.609 207.846C229.654 208.467 228.86 209.306 228.291 210.293C227.722 211.279 227.394 212.387 227.334 213.524V369.141C227.334 371.224 228.796 372.085 230.609 371.034Z",
    fill: "#37474F"
  })), _path297 || (_path297 = /*#__PURE__*/React.createElement("path", {
    d: "M230.126 371.685C229.173 372.178 228.107 372.413 227.035 372.366C225.963 372.318 224.923 371.99 224.017 371.414C223.112 370.838 222.374 370.035 221.876 369.084C221.379 368.133 221.14 367.069 221.183 365.996V348.491L227.322 352.046V369.552C227.322 371.454 228.533 372.326 230.126 371.685Z",
    fill: "black"
  })), _path298 || (_path298 = /*#__PURE__*/React.createElement("path", {
    d: "M227.322 363.673V369.552C227.322 371.635 228.784 372.486 230.597 371.434L408.396 268.785C409.349 268.163 410.142 267.327 410.711 266.342C411.28 265.357 411.609 264.252 411.671 263.116V257.238L227.322 363.673Z",
    fill: "#263238"
  })), _path299 || (_path299 = /*#__PURE__*/React.createElement("path", {
    d: "M233.473 350.514V215.557C233.514 214.872 233.717 214.206 234.065 213.614C234.413 213.022 234.896 212.521 235.476 212.152L403.601 115.091C404.682 114.46 405.604 114.97 405.604 116.222V251.179C405.565 251.865 405.363 252.532 405.015 253.124C404.666 253.716 404.182 254.217 403.601 254.584L235.436 351.646C234.354 352.276 233.473 351.766 233.473 350.514Z",
    fill: "url(#paint144_linear_515_48900)"
  })), _path300 || (_path300 = /*#__PURE__*/React.createElement("path", {
    d: "M319.506 313.47C319.019 313.788 318.613 314.217 318.322 314.721C318.031 315.226 317.864 315.792 317.834 316.374C317.834 317.436 318.575 317.866 319.506 317.376C319.992 317.058 320.397 316.63 320.688 316.128C320.978 315.625 321.146 315.061 321.179 314.481C321.179 313.37 320.428 312.939 319.506 313.47Z",
    fill: "url(#paint145_linear_515_48900)"
  })), _path301 || (_path301 = /*#__PURE__*/React.createElement("path", {
    d: "M228.295 210.279C227.702 211.26 227.358 212.37 227.293 213.514V363.673L221.154 360.118V209.989C221.208 208.843 221.553 207.73 222.156 206.754L228.295 210.279Z",
    fill: "#263238"
  })), _path302 || (_path302 = /*#__PURE__*/React.createElement("path", {
    d: "M306.016 277.587C303.07 277.593 300.152 277.025 297.423 275.915C289.321 272.61 283.102 264.488 279.908 253.052C279.642 252.107 279.762 251.096 280.242 250.241C280.722 249.385 281.522 248.756 282.466 248.49C283.411 248.224 284.422 248.345 285.277 248.825C286.133 249.304 286.763 250.105 287.028 251.049C289.592 260.242 294.279 266.641 300.217 269.075C305.285 271.148 311.324 270.307 317.653 266.641C332.805 257.899 346.575 234.995 351.923 209.658C352.023 209.182 352.217 208.729 352.492 208.327C352.768 207.925 353.119 207.582 353.528 207.316C353.936 207.05 354.393 206.867 354.872 206.777C355.351 206.688 355.842 206.694 356.319 206.794C356.796 206.895 357.248 207.088 357.65 207.364C358.052 207.639 358.396 207.991 358.662 208.399C358.928 208.807 359.111 209.264 359.2 209.743C359.29 210.222 359.284 210.714 359.183 211.191C353.335 238.881 338.493 263.166 321.378 273.051C316.746 275.889 311.447 277.454 306.016 277.587Z",
    fill: "#F0F7FF"
  })), _path303 || (_path303 = /*#__PURE__*/React.createElement("path", {
    d: "M304.696 216.489C304.696 221.416 302.102 226.904 298.908 228.746C295.713 230.589 293.119 228.095 293.119 223.178C293.119 218.261 295.713 212.763 298.908 210.92C302.102 209.078 304.696 211.571 304.696 216.489Z",
    fill: "#F0F7FF"
  })), _path304 || (_path304 = /*#__PURE__*/React.createElement("path", {
    d: "M341.35 195.328C341.35 200.255 338.757 205.743 335.562 207.585C332.367 209.428 329.773 206.934 329.773 202.017C329.773 197.1 332.367 191.612 335.562 189.759C338.757 187.907 341.35 190.41 341.35 195.328Z",
    fill: "#F0F7FF"
  })), _path305 || (_path305 = /*#__PURE__*/React.createElement("path", {
    d: "M248.027 167.787L244.161 156.771L247.266 147.758V142.27L237.762 147.758V153.246L241.848 164.052C241.913 164.163 242.011 164.25 242.128 164.302L248.027 167.787Z",
    fill: "url(#paint146_linear_515_48900)"
  })), _path306 || (_path306 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M248.027 167.787L244.161 156.771L247.266 147.758V142.27L237.762 147.758V153.246L241.848 164.052C241.913 164.163 242.011 164.25 242.128 164.302L248.027 167.787Z",
    fill: "black"
  })), _path307 || (_path307 = /*#__PURE__*/React.createElement("path", {
    d: "M270.769 83.5746C270.715 82.5852 270.429 81.6224 269.933 80.7645C269.437 79.9066 268.746 79.1779 267.915 78.6374L265.602 77.3055C264.717 76.856 263.739 76.6217 262.748 76.6217C261.756 76.6217 260.778 76.856 259.893 77.3055L224.301 97.8955C223.469 98.4336 222.776 99.1618 222.279 100.02C221.783 100.879 221.498 101.842 221.447 102.833V157.112C221.498 158.102 221.783 159.066 222.279 159.924C222.776 160.783 223.469 161.511 224.301 162.049L226.615 163.391C227.499 163.84 228.477 164.075 229.469 164.075C230.461 164.075 231.439 163.84 232.323 163.391L243.77 156.781L247.846 167.567C247.904 167.667 247.99 167.749 248.093 167.802C248.197 167.855 248.313 167.878 248.428 167.867C248.544 167.857 248.654 167.813 248.746 167.742C248.838 167.672 248.908 167.576 248.947 167.467L253.264 151.293L267.915 142.801C268.748 142.263 269.441 141.535 269.937 140.676C270.433 139.818 270.718 138.854 270.769 137.864V83.5746Z",
    fill: "url(#paint147_linear_515_48900)"
  })), _path308 || (_path308 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M221.447 157.112C221.498 158.102 221.783 159.066 222.279 159.924C222.776 160.783 223.469 161.511 224.301 162.049L226.615 163.391C227.419 163.795 228.3 164.024 229.199 164.064C230.098 164.103 230.996 163.953 231.832 163.621C230.49 164.132 229.469 163.371 229.469 161.749V107.459C229.504 106.469 229.79 105.504 230.3 104.655L222.288 100.019C221.778 100.871 221.492 101.839 221.457 102.833L221.447 157.112Z",
    fill: "black"
  })), _path309 || (_path309 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M270.679 82.8035C270.349 81.5917 269.237 81.2011 267.925 81.9622L232.323 102.552C231.478 103.073 230.787 103.809 230.32 104.685L222.309 100.059C222.778 99.1848 223.469 98.4494 224.312 97.9255L259.903 77.3355C260.788 76.886 261.766 76.6518 262.758 76.6518C263.75 76.6518 264.727 76.886 265.612 77.3355L267.935 78.6774C268.648 79.1431 269.26 79.749 269.731 80.4583C270.203 81.1677 270.526 81.9656 270.679 82.8035Z",
    fill: "#F0F7FF"
  })), _path310 || (_path310 = /*#__PURE__*/React.createElement("path", {
    d: "M235.006 141.89L265.911 124.044C266.522 123.693 267.013 123.943 267.013 124.604C266.985 124.973 266.871 125.331 266.68 125.647C266.488 125.964 266.225 126.231 265.911 126.427L235.006 144.273C234.395 144.624 233.904 144.383 233.904 143.722C233.93 143.352 234.043 142.992 234.235 142.674C234.426 142.355 234.691 142.086 235.006 141.89Z",
    fill: "#F0F7FF"
  })), _path311 || (_path311 = /*#__PURE__*/React.createElement("path", {
    d: "M235.006 146.697L265.871 128.871C266.482 128.52 266.973 128.771 266.973 129.432C266.947 129.802 266.833 130.162 266.642 130.48C266.45 130.799 266.186 131.067 265.871 131.264L235.006 149.09C234.395 149.441 233.904 149.19 233.904 148.529C233.93 148.159 234.043 147.799 234.235 147.481C234.426 147.162 234.691 146.894 235.006 146.697Z",
    fill: "#F0F7FF"
  })), _path312 || (_path312 = /*#__PURE__*/React.createElement("path", {
    d: "M235.006 151.514L265.911 133.668C266.522 133.317 267.013 133.568 267.013 134.218C266.987 134.589 266.873 134.949 266.682 135.267C266.49 135.586 266.226 135.854 265.911 136.051L235.006 153.907C234.395 154.258 233.904 154.007 233.904 153.356C233.929 152.984 234.041 152.623 234.233 152.302C234.424 151.982 234.689 151.711 235.006 151.514Z",
    fill: "#F0F7FF"
  })), _path313 || (_path313 = /*#__PURE__*/React.createElement("path", {
    d: "M259.041 96.8239C258.43 96.5673 257.742 96.5634 257.128 96.8131C256.514 97.0628 256.024 97.5456 255.766 98.1558L246.322 120.639L244.069 118.445C243.586 118.024 242.96 117.805 242.32 117.831C241.68 117.857 241.075 118.128 240.628 118.587C240.182 119.047 239.928 119.66 239.92 120.3C239.912 120.941 240.149 121.56 240.584 122.031L245.461 126.778C245.929 127.228 246.554 127.479 247.204 127.479C247.37 127.493 247.538 127.493 247.704 127.479C248.103 127.398 248.476 127.221 248.791 126.962C249.105 126.704 249.351 126.372 249.507 125.996L260.373 100.149C260.508 99.8435 260.58 99.5144 260.586 99.1807C260.592 98.8471 260.531 98.5157 260.407 98.2059C260.283 97.8961 260.098 97.6143 259.863 97.377C259.629 97.1396 259.349 96.9516 259.041 96.8239Z",
    fill: "#F0F7FF"
  })), _path314 || (_path314 = /*#__PURE__*/React.createElement("path", {
    d: "M314.472 129.411L310.616 118.395L313.721 109.432V103.934L304.207 109.432V114.92L308.293 125.726C308.358 125.837 308.456 125.924 308.573 125.976L314.472 129.411Z",
    fill: "url(#paint148_linear_515_48900)"
  })), _path315 || (_path315 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M314.472 129.411L310.616 118.395L313.721 109.432V103.934L304.207 109.432V114.92L308.293 125.726C308.358 125.837 308.456 125.924 308.573 125.976L314.472 129.411Z",
    fill: "black"
  })), _path316 || (_path316 = /*#__PURE__*/React.createElement("path", {
    d: "M337.155 45.2086C337.101 44.2194 336.814 43.2569 336.318 42.3992C335.822 41.5414 335.131 40.8125 334.301 40.2714L331.978 38.9295C331.095 38.4801 330.119 38.2459 329.129 38.2459C328.138 38.2459 327.162 38.4801 326.28 38.9295L290.708 59.5195C289.878 60.0606 289.187 60.7895 288.691 61.6472C288.195 62.505 287.908 63.4675 287.854 64.4567V118.746C287.909 119.735 288.196 120.697 288.692 121.555C289.188 122.412 289.878 123.141 290.708 123.683L293.031 125.025C293.915 125.47 294.891 125.701 295.88 125.701C296.87 125.701 297.845 125.47 298.729 125.025L310.176 118.405L314.262 129.201C314.321 129.301 314.408 129.382 314.512 129.434C314.616 129.487 314.732 129.508 314.848 129.497C314.964 129.485 315.074 129.441 315.165 129.369C315.256 129.297 315.325 129.201 315.364 129.091L319.68 112.917L334.331 104.435C335.161 103.893 335.851 103.164 336.347 102.307C336.843 101.449 337.13 100.487 337.185 99.4978L337.155 45.2086Z",
    fill: "url(#paint149_linear_515_48900)"
  })), _path317 || (_path317 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M287.854 118.746C287.909 119.735 288.196 120.697 288.692 121.555C289.188 122.412 289.878 123.141 290.708 123.683L293.031 125.025C293.835 125.429 294.716 125.658 295.615 125.698C296.514 125.737 297.412 125.587 298.249 125.255C296.907 125.756 295.885 125.005 295.885 123.373V69.0935C295.915 68.0995 296.201 67.1301 296.716 66.2794L288.705 61.6426C288.188 62.4933 287.899 63.4622 287.864 64.4567L287.854 118.746Z",
    fill: "black"
  })), _path318 || (_path318 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M337.085 44.3974C336.755 43.1857 335.653 42.8051 334.331 43.5562L298.729 64.1563C297.889 64.6788 297.199 65.4103 296.727 66.2794L288.715 61.6526C289.187 60.783 289.877 60.0513 290.718 59.5295L326.31 38.9295C327.195 38.4846 328.173 38.253 329.164 38.253C330.155 38.253 331.132 38.4846 332.018 38.9295L334.341 40.2714C335.055 40.7366 335.667 41.3424 336.138 42.0518C336.61 42.7612 336.932 43.5593 337.085 44.3974Z",
    fill: "#F0F7FF"
  })), _path319 || (_path319 = /*#__PURE__*/React.createElement("path", {
    d: "M301.192 103.614L332.147 85.808C332.758 85.4474 333.259 85.6978 333.259 86.3588C333.23 86.73 333.115 87.0894 332.922 87.4078C332.729 87.7261 332.463 87.9946 332.147 88.1914L301.242 106.037C300.631 106.388 300.141 106.138 300.141 105.477C300.158 105.106 300.262 104.744 300.445 104.42C300.627 104.097 300.883 103.82 301.192 103.614Z",
    fill: "#F0F7FF"
  })), _path320 || (_path320 = /*#__PURE__*/React.createElement("path", {
    d: "M301.191 108.431L332.147 90.5848C332.757 90.2343 333.258 90.4847 333.258 91.1456C333.229 91.5167 333.113 91.8757 332.92 92.194C332.727 92.5122 332.462 92.7809 332.147 92.9783L301.191 110.844C300.581 111.205 300.09 110.955 300.09 110.294C300.111 109.918 300.222 109.552 300.414 109.228C300.606 108.904 300.872 108.631 301.191 108.431Z",
    fill: "#F0F7FF"
  })), _path321 || (_path321 = /*#__PURE__*/React.createElement("path", {
    d: "M301.192 113.238L332.147 95.3918C332.758 95.0413 333.259 95.2917 333.259 95.9527C333.237 96.3309 333.124 96.6982 332.931 97.024C332.737 97.3499 332.469 97.6246 332.147 97.8254L301.242 115.671C300.631 116.022 300.141 115.772 300.141 115.111C300.155 114.737 300.257 114.373 300.44 114.047C300.623 113.722 300.881 113.444 301.192 113.238Z",
    fill: "#F0F7FF"
  })), _path322 || (_path322 = /*#__PURE__*/React.createElement("path", {
    d: "M325.278 58.5882C324.976 58.4598 324.651 58.3924 324.322 58.3898C323.994 58.3873 323.668 58.4498 323.364 58.5735C323.06 58.6973 322.783 58.88 322.549 59.1111C322.316 59.3421 322.13 59.6171 322.003 59.9201L312.56 82.3929L310.306 80.2097C309.831 79.7489 309.192 79.4958 308.53 79.5061C307.868 79.5164 307.237 79.7893 306.776 80.2648C306.315 80.7402 306.062 81.3792 306.073 82.0413C306.083 82.7033 306.356 83.3341 306.831 83.7949L311.708 88.5318C311.936 88.7584 312.206 88.9379 312.504 89.0599C312.801 89.1819 313.12 89.2441 313.441 89.2429C313.609 89.2411 313.776 89.2243 313.942 89.1928C314.34 89.1115 314.713 88.9339 315.027 88.6756C315.341 88.4173 315.587 88.086 315.744 87.7106L326.61 61.8529C326.738 61.5513 326.806 61.2272 326.808 60.8994C326.81 60.5717 326.748 60.2467 326.624 59.9432C326.5 59.6397 326.317 59.3637 326.086 59.1311C325.856 58.8986 325.581 58.714 325.278 58.5882Z",
    fill: "#F0F7FF"
  })), _path323 || (_path323 = /*#__PURE__*/React.createElement("path", {
    d: "M380.868 91.1156L377.003 80.0995L380.107 71.0864V65.5884L370.604 71.0864V76.5744L374.689 87.3802C374.752 87.4907 374.851 87.5758 374.97 87.6205L380.868 91.1156Z",
    fill: "url(#paint150_linear_515_48900)"
  })), _path324 || (_path324 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M380.868 91.1156L377.003 80.0995L380.107 71.0864V65.5884L370.604 71.0864V76.5744L374.689 87.3802C374.752 87.4907 374.851 87.5758 374.97 87.6205L380.868 91.1156Z",
    fill: "black"
  })), _path325 || (_path325 = /*#__PURE__*/React.createElement("path", {
    d: "M403.572 6.9128C403.521 5.92388 403.236 4.96108 402.742 4.10303C402.248 3.24498 401.558 2.51599 400.728 1.9756L398.404 0.683717C397.52 0.234265 396.542 0 395.55 0C394.558 0 393.58 0.234265 392.696 0.683717L357.104 21.2237C356.273 21.7629 355.58 22.4914 355.084 23.3496C354.588 24.2077 354.302 25.1711 354.25 26.1609V80.4501C354.304 81.4395 354.59 82.4023 355.086 83.2601C355.582 84.118 356.274 84.8468 357.104 85.3873L359.418 86.7292C360.303 87.174 361.281 87.4057 362.272 87.4057C363.263 87.4057 364.24 87.174 365.126 86.7292L376.573 80.1096L380.648 90.9053C380.708 91.0052 380.795 91.0861 380.898 91.1385C381.002 91.1909 381.119 91.2125 381.234 91.201C381.35 91.1894 381.46 91.1451 381.551 91.0732C381.643 91.0013 381.712 90.9048 381.75 90.7951L386.066 74.6216L400.728 66.1392C401.556 65.597 402.245 64.8676 402.739 64.0099C403.233 63.1522 403.518 62.1903 403.572 61.202V6.9128Z",
    fill: "url(#paint151_linear_515_48900)"
  })), _path326 || (_path326 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M354.25 80.45C354.304 81.4395 354.59 82.4023 355.086 83.2601C355.582 84.118 356.274 84.8468 357.104 85.3872L359.418 86.7292C360.222 87.1329 361.103 87.3621 362.002 87.4018C362.901 87.4415 363.798 87.2908 364.635 86.9595C363.293 87.4603 362.272 86.7092 362.272 85.0768V30.7976C362.306 29.8044 362.592 28.8362 363.103 27.9835L355.091 23.3468C354.582 24.2 354.296 25.1679 354.26 26.1609L354.25 80.45Z",
    fill: "black"
  })), _path327 || (_path327 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M403.482 6.10162C403.151 4.88985 402.04 4.49928 400.728 5.26039L365.126 25.8604C364.281 26.3774 363.59 27.1103 363.123 27.9835L355.111 23.3568C355.584 22.4877 356.274 21.7562 357.114 21.2337L392.696 0.683714C393.582 0.238888 394.559 0.00723267 395.55 0.00723267C396.541 0.00723267 397.519 0.238888 398.404 0.683714L400.728 2.02567C401.437 2.48559 402.046 3.08346 402.519 3.7837C402.992 4.48394 403.32 5.27222 403.482 6.10162Z",
    fill: "#F0F7FF"
  })), _path328 || (_path328 = /*#__PURE__*/React.createElement("path", {
    d: "M367.418 65.348L398.333 47.5019C398.934 47.1514 399.435 47.4018 399.435 48.0628C399.406 48.4329 399.292 48.7914 399.101 49.1096C398.91 49.4277 398.647 49.6968 398.333 49.8954L367.418 67.7815C366.807 68.132 366.316 67.8817 366.316 67.2207C366.336 66.843 366.446 66.4756 366.638 66.1496C366.83 65.8236 367.097 65.5486 367.418 65.348Z",
    fill: "#F0F7FF"
  })), _path329 || (_path329 = /*#__PURE__*/React.createElement("path", {
    d: "M367.418 70.155L398.333 52.3189C398.934 51.9584 399.435 52.2088 399.435 52.8698C399.406 53.2399 399.292 53.5984 399.101 53.9166C398.91 54.2347 398.647 54.5038 398.333 54.7024L367.418 72.5485C366.807 72.899 366.316 72.6486 366.316 71.9876C366.344 71.6173 366.458 71.2585 366.649 70.9402C366.84 70.6219 367.104 70.353 367.418 70.155Z",
    fill: "#F0F7FF"
  })), _path330 || (_path330 = /*#__PURE__*/React.createElement("path", {
    d: "M367.418 74.972L398.333 57.126C398.934 56.7754 399.435 57.0258 399.435 57.6868C399.406 58.0569 399.292 58.4154 399.101 58.7336C398.91 59.0518 398.647 59.3209 398.333 59.5195L367.418 77.3655C366.807 77.716 366.316 77.4656 366.316 76.8047C366.342 76.4339 366.456 76.0745 366.647 75.756C366.839 75.4374 367.103 75.1688 367.418 74.972Z",
    fill: "#F0F7FF"
  })), _path331 || (_path331 = /*#__PURE__*/React.createElement("path", {
    d: "M391.504 20.3122C390.893 20.0556 390.205 20.0518 389.591 20.3014C388.977 20.5511 388.487 21.034 388.229 21.6442L378.775 44.127L376.532 41.9338C376.049 41.5128 375.423 41.2929 374.783 41.3193C374.143 41.3457 373.538 41.6164 373.091 42.0757C372.645 42.535 372.391 43.148 372.383 43.7885C372.375 44.429 372.612 45.0483 373.047 45.519L377.924 50.2659C378.391 50.7178 379.016 50.9693 379.666 50.9669C379.829 50.987 379.994 50.987 380.157 50.9669C380.557 50.889 380.931 50.7139 381.247 50.4572C381.563 50.2005 381.811 49.87 381.97 49.4948L392.836 23.6371C392.97 23.3318 393.043 23.0027 393.049 22.6691C393.055 22.3354 392.994 22.004 392.87 21.6942C392.746 21.3845 392.561 21.1026 392.326 20.8653C392.092 20.628 391.812 20.4399 391.504 20.3122Z",
    fill: "#F0F7FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_515_48900",
    x1: 52.6719,
    y1: 305.118,
    x2: 207.355,
    y2: 275.843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_515_48900",
    x1: 124.895,
    y1: 333.661,
    x2: 204.002,
    y2: 324.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_515_48900",
    x1: 52.6602,
    y1: 333.662,
    x2: 131.789,
    y2: 324.77,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_515_48900",
    x1: 52.6719,
    y1: 273.842,
    x2: 207.355,
    y2: 244.567,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_515_48900",
    x1: 124.887,
    y1: 294.693,
    x2: 203.748,
    y2: 284.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_515_48900",
    x1: 52.6719,
    y1: 294.693,
    x2: 131.533,
    y2: 284.741,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_515_48900",
    x1: 57.1758,
    y1: 299.91,
    x2: 130.256,
    y2: 287.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_515_48900",
    x1: 52.6719,
    y1: 242.576,
    x2: 207.356,
    y2: 213.305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_515_48900",
    x1: 124.887,
    y1: 263.427,
    x2: 203.749,
    y2: 253.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_515_48900",
    x1: 52.6719,
    y1: 263.427,
    x2: 131.534,
    y2: 253.477,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_515_48900",
    x1: 52.6719,
    y1: 211.301,
    x2: 207.356,
    y2: 182.029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_515_48900",
    x1: 124.887,
    y1: 232.151,
    x2: 203.749,
    y2: 222.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_515_48900",
    x1: 52.6719,
    y1: 232.151,
    x2: 131.534,
    y2: 222.202,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_515_48900",
    x1: 52.6719,
    y1: 179.965,
    x2: 207.356,
    y2: 150.693,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_515_48900",
    x1: 124.887,
    y1: 200.816,
    x2: 203.749,
    y2: 190.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_515_48900",
    x1: 52.6719,
    y1: 200.816,
    x2: 131.534,
    y2: 190.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_515_48900",
    x1: 52.6602,
    y1: 169.55,
    x2: 209.247,
    y2: 145.616,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_515_48900",
    x1: 124.846,
    y1: 169.55,
    x2: 203.8,
    y2: 159.786,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_515_48900",
    x1: 54.3535,
    y1: 147.728,
    x2: 205.433,
    y2: 119.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_515_48900",
    x1: 60.9219,
    y1: 282.605,
    x2: 66.0668,
    y2: 282.155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_515_48900",
    x1: 60.3516,
    y1: 282.773,
    x2: 64.962,
    y2: 282.382,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_515_48900",
    x1: 60.9219,
    y1: 251.299,
    x2: 66.0679,
    y2: 250.848,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_515_48900",
    x1: 60.3516,
    y1: 251.471,
    x2: 64.962,
    y2: 251.08,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_515_48900",
    x1: 60.9219,
    y1: 220.084,
    x2: 66.0675,
    y2: 219.634,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_515_48900",
    x1: 60.3516,
    y1: 220.195,
    x2: 64.9619,
    y2: 219.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_515_48900",
    x1: 60.9219,
    y1: 188.798,
    x2: 66.067,
    y2: 188.349,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_515_48900",
    x1: 60.3516,
    y1: 188.956,
    x2: 64.962,
    y2: 188.566,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_515_48900",
    x1: 60.9219,
    y1: 157.472,
    x2: 66.0675,
    y2: 157.023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_515_48900",
    x1: 60.3516,
    y1: 157.62,
    x2: 64.962,
    y2: 157.23,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_515_48900",
    x1: 60.9219,
    y1: 126.157,
    x2: 66.0668,
    y2: 125.707,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_515_48900",
    x1: 60.3516,
    y1: 126.365,
    x2: 64.9625,
    y2: 125.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_515_48900",
    x1: 188.559,
    y1: 280.301,
    x2: 190.222,
    y2: 280.231,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_515_48900",
    x1: 186.125,
    y1: 281.733,
    x2: 187.788,
    y2: 281.663,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_515_48900",
    x1: 183.691,
    y1: 283.135,
    x2: 185.366,
    y2: 283.065,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_515_48900",
    x1: 176.422,
    y1: 287.311,
    x2: 178.085,
    y2: 287.241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_515_48900",
    x1: 173.965,
    y1: 288.746,
    x2: 175.632,
    y2: 288.676,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_515_48900",
    x1: 171.531,
    y1: 290.148,
    x2: 173.198,
    y2: 290.079,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_515_48900",
    x1: 169.098,
    y1: 291.55,
    x2: 170.775,
    y2: 291.479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_515_48900",
    x1: 166.678,
    y1: 292.949,
    x2: 168.341,
    y2: 292.879,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_515_48900",
    x1: 164.242,
    y1: 294.321,
    x2: 165.906,
    y2: 294.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_515_48900",
    x1: 161.809,
    y1: 295.753,
    x2: 163.472,
    y2: 295.684,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_515_48900",
    x1: 156.943,
    y1: 298.552,
    x2: 158.607,
    y2: 298.482,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_515_48900",
    x1: 154.508,
    y1: 299.954,
    x2: 156.186,
    y2: 299.883,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_515_48900",
    x1: 188.559,
    y1: 249.06,
    x2: 190.222,
    y2: 248.99,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_515_48900",
    x1: 183.691,
    y1: 251.864,
    x2: 185.369,
    y2: 251.793,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_515_48900",
    x1: 176.441,
    y1: 256.12,
    x2: 178.083,
    y2: 256.053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_515_48900",
    x1: 173.969,
    y1: 257.472,
    x2: 175.632,
    y2: 257.402,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_515_48900",
    x1: 171.533,
    y1: 258.874,
    x2: 173.197,
    y2: 258.804,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_515_48900",
    x1: 166.678,
    y1: 261.678,
    x2: 168.341,
    y2: 261.608,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_515_48900",
    x1: 161.809,
    y1: 264.482,
    x2: 163.472,
    y2: 264.412,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_515_48900",
    x1: 156.943,
    y1: 267.276,
    x2: 158.607,
    y2: 267.206,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_515_48900",
    x1: 154.508,
    y1: 268.688,
    x2: 156.182,
    y2: 268.618,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_515_48900",
    x1: 188.559,
    y1: 217.759,
    x2: 190.222,
    y2: 217.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_515_48900",
    x1: 186.125,
    y1: 219.212,
    x2: 187.788,
    y2: 219.142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_515_48900",
    x1: 183.688,
    y1: 220.577,
    x2: 185.365,
    y2: 220.506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_515_48900",
    x1: 181.268,
    y1: 221.966,
    x2: 182.931,
    y2: 221.896,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_515_48900",
    x1: 173.965,
    y1: 226.225,
    x2: 175.632,
    y2: 226.156,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_515_48900",
    x1: 171.531,
    y1: 227.587,
    x2: 173.198,
    y2: 227.517,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_515_48900",
    x1: 169.098,
    y1: 228.979,
    x2: 170.775,
    y2: 228.908,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_515_48900",
    x1: 164.242,
    y1: 231.775,
    x2: 165.909,
    y2: 231.704,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_515_48900",
    x1: 161.809,
    y1: 233.226,
    x2: 163.472,
    y2: 233.157,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_515_48900",
    x1: 156.943,
    y1: 235.981,
    x2: 158.607,
    y2: 235.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_515_48900",
    x1: 188.559,
    y1: 186.518,
    x2: 190.222,
    y2: 186.449,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_515_48900",
    x1: 183.691,
    y1: 189.308,
    x2: 185.366,
    y2: 189.237,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_515_48900",
    x1: 181.268,
    y1: 190.71,
    x2: 182.931,
    y2: 190.64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_515_48900",
    x1: 178.834,
    y1: 192.162,
    x2: 180.497,
    y2: 192.093,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_515_48900",
    x1: 171.533,
    y1: 196.318,
    x2: 173.197,
    y2: 196.248,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_515_48900",
    x1: 166.678,
    y1: 199.172,
    x2: 168.341,
    y2: 199.103,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_515_48900",
    x1: 164.242,
    y1: 200.534,
    x2: 165.906,
    y2: 200.465,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_515_48900",
    x1: 161.809,
    y1: 201.926,
    x2: 163.472,
    y2: 201.856,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_515_48900",
    x1: 156.943,
    y1: 204.73,
    x2: 158.607,
    y2: 204.661,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_515_48900",
    x1: 154.508,
    y1: 206.183,
    x2: 156.182,
    y2: 206.112,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_515_48900",
    x1: 188.557,
    y1: 155.181,
    x2: 190.223,
    y2: 155.111,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_515_48900",
    x1: 183.688,
    y1: 157.985,
    x2: 185.365,
    y2: 157.914,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_515_48900",
    x1: 181.268,
    y1: 159.379,
    x2: 182.931,
    y2: 159.309,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_515_48900",
    x1: 178.834,
    y1: 160.781,
    x2: 180.501,
    y2: 160.711,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_515_48900",
    x1: 171.533,
    y1: 164.987,
    x2: 173.197,
    y2: 164.917,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_515_48900",
    x1: 166.678,
    y1: 167.791,
    x2: 168.344,
    y2: 167.721,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_515_48900",
    x1: 164.242,
    y1: 169.193,
    x2: 165.906,
    y2: 169.123,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_515_48900",
    x1: 161.809,
    y1: 170.595,
    x2: 163.472,
    y2: 170.525,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_515_48900",
    x1: 156.943,
    y1: 173.399,
    x2: 158.607,
    y2: 173.33,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_515_48900",
    x1: 154.508,
    y1: 174.801,
    x2: 156.182,
    y2: 174.731,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_515_48900",
    x1: 186.125,
    y1: 125.299,
    x2: 187.788,
    y2: 125.229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_515_48900",
    x1: 176.441,
    y1: 130.937,
    x2: 178.083,
    y2: 130.87,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_515_48900",
    x1: 173.969,
    y1: 132.309,
    x2: 175.632,
    y2: 132.24,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_515_48900",
    x1: 169.1,
    y1: 135.083,
    x2: 170.774,
    y2: 135.012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_515_48900",
    x1: 159.396,
    y1: 140.722,
    x2: 161.06,
    y2: 140.652,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_515_48900",
    x1: 140.9,
    y1: 307.301,
    x2: 146.036,
    y2: 306.853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_515_48900",
    x1: 141.961,
    y1: 307.459,
    x2: 146.561,
    y2: 307.071,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_515_48900",
    x1: 131.818,
    y1: 312.548,
    x2: 136.963,
    y2: 312.099,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_515_48900",
    x1: 132.877,
    y1: 312.697,
    x2: 137.487,
    y2: 312.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_515_48900",
    x1: 140.859,
    y1: 276.025,
    x2: 146.038,
    y2: 275.569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_515_48900",
    x1: 141.961,
    y1: 276.193,
    x2: 146.561,
    y2: 275.805,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_515_48900",
    x1: 131.818,
    y1: 281.273,
    x2: 136.964,
    y2: 280.823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_515_48900",
    x1: 132.877,
    y1: 281.425,
    x2: 137.487,
    y2: 281.034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_515_48900",
    x1: 140.9,
    y1: 244.76,
    x2: 146.036,
    y2: 244.312,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_515_48900",
    x1: 141.961,
    y1: 244.911,
    x2: 146.561,
    y2: 244.523,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_515_48900",
    x1: 131.848,
    y1: 249.987,
    x2: 136.961,
    y2: 249.543,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_515_48900",
    x1: 132.877,
    y1: 250.159,
    x2: 137.487,
    y2: 249.769,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_515_48900",
    x1: 140.9,
    y1: 213.474,
    x2: 146.036,
    y2: 213.026,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_515_48900",
    x1: 141.961,
    y1: 213.636,
    x2: 146.561,
    y2: 213.247,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_515_48900",
    x1: 131.816,
    y1: 218.702,
    x2: 136.962,
    y2: 218.251,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_515_48900",
    x1: 132.877,
    y1: 218.873,
    x2: 137.487,
    y2: 218.483,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_515_48900",
    x1: 140.9,
    y1: 182.138,
    x2: 146.036,
    y2: 181.69,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_515_48900",
    x1: 141.961,
    y1: 182.306,
    x2: 146.561,
    y2: 181.918,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_515_48900",
    x1: 131.818,
    y1: 187.386,
    x2: 136.963,
    y2: 186.937,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_515_48900",
    x1: 132.855,
    y1: 187.544,
    x2: 137.466,
    y2: 187.154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_515_48900",
    x1: 140.859,
    y1: 150.843,
    x2: 146.038,
    y2: 150.384,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_515_48900",
    x1: 141.961,
    y1: 151.011,
    x2: 146.56,
    y2: 150.621,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_515_48900",
    x1: 131.818,
    y1: 156.12,
    x2: 136.963,
    y2: 155.671,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_515_48900",
    x1: 132.877,
    y1: 156.278,
    x2: 137.487,
    y2: 155.888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_515_48900",
    x1: 77.5176,
    y1: 246.051,
    x2: 119.284,
    y2: 238.705,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_515_48900",
    x1: 77.5078,
    y1: 242.306,
    x2: 100.55,
    y2: 238.63,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_515_48900",
    x1: 77.5176,
    y1: 277.404,
    x2: 119.284,
    y2: 270.06,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_515_48900",
    x1: 77.5176,
    y1: 276.536,
    x2: 105.922,
    y2: 271.867,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_515_48900",
    x1: 77.5176,
    y1: 308.519,
    x2: 119.285,
    y2: 301.177,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_515_48900",
    x1: 77.5176,
    y1: 310.536,
    x2: 111.291,
    y2: 304.863,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_515_48900",
    x1: 77.5176,
    y1: 215.006,
    x2: 119.283,
    y2: 207.659,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_515_48900",
    x1: 77.5176,
    y1: 218.481,
    x2: 113.975,
    y2: 212.306,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_515_48900",
    x1: 77.5176,
    y1: 152.401,
    x2: 119.285,
    y2: 145.059,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_515_48900",
    x1: 77.5176,
    y1: 151.534,
    x2: 105.922,
    y2: 146.865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_515_48900",
    x1: 77.5176,
    y1: 183.687,
    x2: 119.285,
    y2: 176.344,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_515_48900",
    x1: 77.5176,
    y1: 187.156,
    x2: 113.976,
    y2: 180.982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_515_48900",
    x1: 74.5215,
    y1: 135.438,
    x2: 183.812,
    y2: 115.979,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_515_48900",
    x1: 75.2617,
    y1: 130.934,
    x2: 182.544,
    y2: 110.645,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_515_48900",
    x1: 125.324,
    y1: 135.451,
    x2: 180.259,
    y2: 126.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_515_48900",
    x1: 147.809,
    y1: 99.1298,
    x2: 152.259,
    y2: 98.2844,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_515_48900",
    x1: 141.939,
    y1: 102.518,
    x2: 146.39,
    y2: 101.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_515_48900",
    x1: 143.414,
    y1: 96.5889,
    x2: 147.865,
    y2: 95.7435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_515_48900",
    x1: 131.674,
    y1: 103.373,
    x2: 136.115,
    y2: 102.536,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint130_linear_515_48900",
    x1: 133.137,
    y1: 97.4374,
    x2: 137.589,
    y2: 96.5944,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint131_linear_515_48900",
    x1: 124.305,
    y1: 112.62,
    x2: 128.757,
    y2: 111.777,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint132_linear_515_48900",
    x1: 134.615,
    y1: 91.5115,
    x2: 139.054,
    y2: 90.672,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint133_linear_515_48900",
    x1: 122.871,
    y1: 98.2886,
    x2: 127.323,
    y2: 97.4455,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint134_linear_515_48900",
    x1: 115.508,
    y1: 107.535,
    x2: 119.946,
    y2: 106.695,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint135_linear_515_48900",
    x1: 109.283,
    y1: 95.7123,
    x2: 133.772,
    y2: 91.3396,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint136_linear_515_48900",
    x1: 121.02,
    y1: 84.3858,
    x2: 130.409,
    y2: 82.84,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint137_linear_515_48900",
    x1: 110.945,
    y1: 85.7076,
    x2: 128.64,
    y2: 82.6053,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint138_linear_515_48900",
    x1: 97.6055,
    y1: 88.9323,
    x2: 127.093,
    y2: 83.6155,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint139_linear_515_48900",
    x1: 73.207,
    y1: 352.588,
    x2: 239.093,
    y2: 286.091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint140_linear_515_48900",
    x1: 56.6426,
    y1: 362.162,
    x2: 235.282,
    y2: 297.92,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint141_linear_515_48900",
    x1: 40.1016,
    y1: 371.716,
    x2: 233.744,
    y2: 313.866,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint142_linear_515_48900",
    x1: 23.541,
    y1: 381.279,
    x2: 229.972,
    y2: 327.95,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint143_linear_515_48900",
    x1: 227.334,
    y1: 371.483,
    x2: 430.666,
    y2: 356.128,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint144_linear_515_48900",
    x1: 233.473,
    y1: 351.916,
    x2: 423.218,
    y2: 336.864,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint145_linear_515_48900",
    x1: 317.834,
    y1: 317.577,
    x2: 321.518,
    y2: 317.267,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint146_linear_515_48900",
    x1: 237.762,
    y1: 167.787,
    x2: 249.126,
    y2: 167.288,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint147_linear_515_48900",
    x1: 221.447,
    y1: 167.87,
    x2: 275.968,
    y2: 164.649,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint148_linear_515_48900",
    x1: 304.207,
    y1: 129.411,
    x2: 315.572,
    y2: 128.911,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint149_linear_515_48900",
    x1: 287.854,
    y1: 129.5,
    x2: 342.386,
    y2: 126.279,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint150_linear_515_48900",
    x1: 370.604,
    y1: 91.1156,
    x2: 381.968,
    y2: 90.6163,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint151_linear_515_48900",
    x1: 354.25,
    y1: 91.204,
    x2: 408.771,
    y2: 87.9823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B0CE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#423768"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServerStatus);
export default __webpack_public_path__ + "static/media/Server-Status.edaeb978fcfd9ea0d7d224c72d8a0319.svg";
export { ForwardRef as ReactComponent };